<template>
    <div class="app has-header" v-bind:class="{'loading-roster': loading, 'day-mode' : dayMode, 'shift-template' : shiftTemplateView}" tabindex="0">
        <templateview class="template-view" :state="templateViewState" ref="templateview"/>
        <datepicker :state="datepickerState" ref="pickFrom" v-on:datepicker-date-picked="onDatePicked"></datepicker>
        <div class="mockup" v-bind:style="{display : (mockupToggle ? 'inline-block' : 'none')}"></div>

        <div class="header" v-if="!dayMode">

            <div class="button fa-stack change-month" v-on:click="setDateSelection(dateSelectionStart.add(-1, 'month'), true)">
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="button icon set-date" v-on:click="toggleDatePicker()">
                <div class="label">{{monthDisplay}}</div>
            </div>
            <div class="button fa-stack change-month" v-on:click="setDateSelection(dateSelectionStart.add(1, 'month'), true)">
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
            <div class="button reset-date" v-on:click="setDateSelection($helpers.getCurrentMonthMomentUTC(), true)">
                <div class="label">Heute</div>
            </div>
            
            

            <div style="margin-left:540px;" class="button publish" v-bind:class="{disabled: selectedPublishableShifts.length <= 0}" v-on:click="PublishSelectedShifts()" v-if="selectedPublishableShifts.length > 0">
                <div ><i class="fas fa-eye"></i>{{(selectedPublishableShifts.length > 0 ? ' ('+selectedPublishableShifts.length+')' : '')}}</div>
            </div>
                
            <div style="margin-left:540px;" class="button publish-all" v-bind:class="{disabled: publishableShifts.length <= 0}" v-on:click="PublishAllShifts()" v-if="publishableShifts.length > 0 && selectedPublishableShifts.length == 0">
                <div><i class="fas fa-eye"></i>{{(publishableShifts.length > 0 ? ' ('+ publishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button unpublish" v-bind:class="{disabled: selectedUnpublishableShifts.length <= 0}" v-on:click="UnpublishSelectedShifts()" v-if="selectedUnpublishableShifts.length > 0">
                <div><i class="fas fa-eye-slash"></i>{{(selectedUnpublishableShifts.length > 0 ? ' ('+ selectedUnpublishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button unpublish-all" v-bind:class="{disabled: unpublishableShifts.length <= 0}" v-on:click="UnpublishAllShifts()" v-if="unpublishableShifts.length > 0 && selectedUnpublishableShifts.length == 0">
                <div><i class="fas fa-eye-slash"></i>{{(unpublishableShifts.length > 0 ? ' ('+ unpublishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button clear-all" v-bind:class="{disabled: publishableShifts.length <= 0}" v-on:click="ClearAllShifts()">
                <div><i class="fas fa-eraser"></i>{{(publishableShifts.length > 0 ? ' ('+ publishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button delete" v-bind:class="{disabled: shiftsSelected.length <= 0}" v-on:click="DeleteSelectedShifts()">
                <div><i class="fas fa-trash"></i>{{(shiftsSelected.length > 0 ? ' ('+ shiftsSelected.length+')' : '')}}</div>
            </div>

                

                

                
                
                
        
                
                <div class="button refresh" style="float: right; cursor:pointer; width:25px;"  v-on:click="refresh()">
                    <div><i class="fas fa-refresh" style="font-size:12px; padding-top:7px;"></i></div>
                </div>
                <div class="button" style="float: right; cursor:pointer; width:25px; padding-left:4px;" v-on:click="showModal('modal-rosterrequestwizard')">
                    <div><i class="fas fa-robot" style="font-size:14px; padding-top:5px;"></i></div>
                </div>
                <div class="button" style="float: right; cursor:pointer; width:25px; padding-left:4px;"  v-on:click="ToggleMonthOnlyDays()">
                    <div><i v-if="monthOnlyDays" class="fas fa-expand" style="padding-left:1px;"></i><i v-if="!monthOnlyDays" class="fas fa-compress"></i></div>
                </div>
                <!--<div class="button" style="buttonfloat: right; cursor:pointer;" v-if="monthOnlyDays" v-on:click="ToggleMonthOnlyDays()">
                    <img :src="visibleRumpfImage" style="height:25px; margin-top:6px; cursor:pointer;"/>
                </div>
                <div class="button" style="float:right; cursor:pointer;" v-if="!monthOnlyDays" v-on:click="ToggleMonthOnlyDays()">
                    <img :src="nonVisibleRumpfImage" style="height:25px; margin-top:6px; cursor:pointer;"/>
                </div> -->


                


            <searchbar class="spot" style="display: none;" ref="spotSearch" :searchbar="spots"/>
            <searchbar class="unit" style="display: none;" ref="unitSearch" :searchbar="businessUnits"/>

        </div>


        <div class="header day-mode" v-if="dayMode">
            <div class="fa-stack refresh" v-on:click="LoadTemplateView()">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-refresh fa-stack-2x"></i>
            </div>
            <div class="fa-stack preference" v-on:click="LoadPreferenceView()">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-chart-bar fa-stack-2x"></i>
            </div>
            <div class="fa-stack user">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-user fa-stack-2x"></i>
            </div>
            <div class="week-days" v-if="shiftTemplateView">
                <div class="icon" v-on:click="templateDaySelection = 1, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 1}">Mon</div>
                <div class="icon" v-on:click="templateDaySelection = 2, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 2}">Tue</div>
                <div class="icon" v-on:click="templateDaySelection = 3, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 3}">Wed</div>
                <div class="icon" v-on:click="templateDaySelection = 4, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 4}">Thu</div>
                <div class="icon" v-on:click="templateDaySelection = 5, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 5}">Fri</div>
                <div class="icon" v-on:click="templateDaySelection = 6, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 6}">Sat</div>
                <div class="icon" v-on:click="templateDaySelection = 7, SwitchTemplateDay()" v-bind:class="{'toggled': templateDaySelection === 7}">Sun</div>

            </div>
            <div class="icons-weekly">
                <div class="icon" v-bind:class="{'toggled': dayModeHours === 6}" v-on:click="dayModeHours = 6, ChangeTimeBarLength()">06</div>
                <div class="icon" v-bind:class="{'toggled': dayModeHours === 12}" v-on:click="dayModeHours = 12, ChangeTimeBarLength()">12</div>
                <div class="icon" v-bind:class="{'toggled': dayModeHours === 24}" v-on:click="dayModeHours = 24, ChangeTimeBarLength()">24</div>
                <div class="icon" v-bind:class="{'toggled': dayModeHours === 36}" v-on:click="dayModeHours = 36, ChangeTimeBarLength()">36</div>
            </div>

            <div class="button publish" v-bind:class="{disabled: selectedPublishableShifts.length <= 0}" v-on:click="PublishSelectedShifts()" v-if="selectedPublishableShifts.length > 0">
                <div ><i class="fas fa-eye"></i>{{(selectedPublishableShifts.length > 0 ? ' ('+selectedPublishableShifts.length+')' : '')}}</div>
            </div>
                
            <div class="button publish-all" v-bind:class="{disabled: publishableShifts.length <= 0}" v-on:click="PublishAllShifts()" v-if="publishableShifts.length > 0 && selectedPublishableShifts.length == 0">
                <div><i class="fas fa-eye"></i>{{(publishableShifts.length > 0 ? ' ('+ publishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button unpublish" v-bind:class="{disabled: selectedUnpublishableShifts.length <= 0}" v-on:click="UnpublishSelectedShifts()" v-if="selectedUnpublishableShifts.length > 0">
                <div><i class="fas fa-eye-slash"></i>{{(selectedUnpublishableShifts.length > 0 ? ' ('+ selectedUnpublishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button unpublish-all" v-bind:class="{disabled: unpublishableShifts.length <= 0}" v-on:click="UnpublishAllShifts()" v-if="unpublishableShifts.length > 0 && selectedUnpublishableShifts.length == 0">
                <div><i class="fas fa-eye-slash"></i>{{(unpublishableShifts.length > 0 ? ' ('+ unpublishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button clear-all" v-bind:class="{disabled: publishableShifts.length <= 0}" v-on:click="ClearAllShifts()">
                <div><i class="fas fa-eraser"></i>{{(publishableShifts.length > 0 ? ' ('+ publishableShifts.length+')' : '')}}</div>
            </div>

            <div class="button delete" v-bind:class="{disabled: shiftsSelected.length <= 0}" v-on:click="DeleteSelectedShifts()">
                <div><i class="fas fa-trash"></i>{{(shiftsSelected.length > 0 ? ' ('+ shiftsSelected.length+')' : '')}}</div>
            </div>

            <searchbar class="spot" ref="spotSearch" :searchbar="spots"/>
            <searchbar class="unit" ref="unitSearch" :searchbar="businessUnits"/>
        </div>


        <div class="scrollbar-container" v-bind:class="{show: employeeSelected !== null, 'show-unassigned': showUnassigned, 'business-sort': businessSortToggle}">
            <div class="grid preload">
                <div class="entry group collapsed" v-for="indexGroup in 40" v-bind:class="{'fade-out' : (employeeGroups.length > 0 && indexGroup > employeeGroups.length)}" :key="indexGroup" >
                    <div class="header">
                        <div class="label"> </div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-angle-down"></i>
                        </div>
                    </div>
                    <div v-if="indexGroup === 1">
                        <div class="entry" v-for="index in 20"  :key="index">
                            <div class="week" v-for="indexweek in 5" :key="indexweek">
                                <div class="day"
                                    v-for="index in 7" :key="index">
                                    <div class="name"></div>
                                    <div class="date"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid" v-bind:style="GetGridStyles()" v-bind:class="{show: employeeSelected !== null}">




                <div class="positions-filter button" v-on:click="OpenBUVisibilityPopup($event)">
                    <div class="label" style="padding-left: 3px; padding-top: 1px;">
                        <i class="fas fa-tasks"></i>
                    </div>
                </div>
                <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-filter"></i>
                    </div>
                </div>
                <!--
                <div class="sollist-switcher button" v-on:click="sollIstMode == 0 ? sollIstMode = 1 : sollIstMode = 0,UpdateSollIstMap()">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-sync-alt"></i>
                    </div>
                </div>
                -->
                <div class="sollist-switcher-aktuell button" 
                v-bind:class="{'sollist-active': sollIstMode == 1}"
                v-on:click="sollIstMode = 1,UpdateSollIstMap()">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        Aktuelle <strong>h</strong>
                    </div>
                </div>
                <div class="sollist-switcher-alle button" 
                v-bind:class="{'sollist-active': sollIstMode == 0}"
                v-on:click="sollIstMode = 0, UpdateSollIstMap()">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        Alle <strong>h</strong>
                    </div>
                </div>




                <div class="entry header">
                    <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">
                        <div class="day" v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index"
                            v-on:click="ToggleDayMode(indexweek, index)"
                            v-bind:day="gridWeekInfo['w'+indexweek]['e'+index].dayString"
                            v-bind:month="gridWeekInfo['w'+indexweek]['e'+index].monthString"
                            v-bind:style="{transition: dayMode ? '0s' : ''}"
                            v-bind:date="gridWeekInfo['w'+indexweek]['e'+index].date.format('MM-DD')"
                            v-bind:class="{unnassigned: GetDayUnassignedShifts(indexweek, index).length > 0, today: gridWeekInfo['w'+indexweek]['e'+index].date.format('DD.MM') == $helpers.getMomentUTC().format('DD.MM')}"
                            >
                            <div class="weather" v-if="GetWeatherFromDateFormat(gridWeekInfo['w'+indexweek]['e'+index].date.format('MM-DD'))" v-on:click="OpenWeatherPopup($event, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                <img class="picture"  v-bind:src="GetWeatherIcon(gridWeekInfo['w'+indexweek]['e'+index].date.format('MM-DD'))"/>
                                <div class="label">{{GetWeatherTemp(gridWeekInfo['w'+indexweek]['e'+index].date.format('MM-DD'))}}°</div>
                            </div>
                            <div class="unnassigned-marker">{{GetDayUnassignedShifts(indexweek, index).length}}</div>

                            

                            <div v-if="dayMode"><!-- Make the div bigger and write the name in total -->
                                <div class="name">{{dayModeInfo.name}}
                                </div>
                                <div class="date">{{dayModeInfo.date}}
                                </div>
                            </div>
                            <div v-if="!dayMode">
                                <div class="name">{{gridWeekInfo['w'+indexweek]['e'+index].date.format('dddd').substring(0,2)}}
                                </div>
                                <div class="date">{{gridWeekInfo['w'+indexweek]['e'+index].date.format('DD').substring(0,2)}}.{{gridWeekInfo['w'+indexweek]['e'+index].date.format('MM').substring(0,2) }}
                                </div>
                            </div>

                            <div class="income" v-if="storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString]" v-on:click="OpenIncomePopup($event, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                <div class="income-bar red" v-if="storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].planned && storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].actual" v-bind:style="{width: 'calc(100% - 10px)', 'margin-left': '1px'}"></div>
                                <div class="income-bar green" v-if="storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].actual && storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].planned" v-bind:style="{width: GetDailySalesBarWidth(gridWeekInfo['w'+indexweek]['e'+index].date)}"></div>
                                <div class="income-bar green" v-if="!storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].planned" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                                <div class="income-bar red" v-if="!storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString].actual" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                            </div>
                            <div class="income" v-if="!storeSales[gridWeekInfo['w'+indexweek]['e'+index].dateString]" v-on:click="OpenIncomePopup($event, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                <div class="income-bar gray" style="width: calc(100% - 10px); margin-left: 1px;"></div>
                            </div>
                            <div class="border-day"></div>

                            <div class="shadow" v-if="dayMode"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="entry group business" v-bind:style="{height: '25px'}" v-for="(businessGroup, indexBGroup) in businessGroupsBefore" :key="indexBGroup" v-bind:class="{'collapsed' : businessGroup.collapsed}">
                        <div class="header">
                            <div class="label">{{businessGroup.label}}</div>
                            <div class="fa-stack" v-on:click="SelectUnitSort(businessGroup)">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : businessGroup.collapsed, 'fa-angle-up' : !businessGroup.collapsed}"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: -32px;">
                    <!-- ********************************************************* -->
                    <!-- ************** EMPLOYEE GROUPS ************************** -->
                    <!-- ********************************************************* -->
                    <div class="entry group h-employee-groups" v-bind:groupindex="indexGroup"
                    v-if="draggingBusinessUnit || draggingEmployee || employeeGroup.showMajor" 
                    v-bind:style="{height: employeeGroup.collapsed ? '25px' : ((52 * employeeGroup.employeesFiltered.length) + 'px')}"
                    v-for="(employeeGroup, indexGroup) in employeeGroups" :key="indexGroup" 
                    v-bind:class="{'collapsed' : employeeGroup.collapsed}">

                        <!-- Start EmployeeGroups, green header (label, etc) -->
                        <div class="header">
                            <div class="label" v-bind:class="[dropIndexBusinessUnit == indexGroup ? 'helperDroppable' : [employeeGroup.helper ? 'helper' : ''],employeeGroup.indentationLevel == 0 ? 'indentationLevel0' : 'indentationLevel1']">
                                <div class="fa-stack new" v-if="shiftTemplateView">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-stack-2x fa-plus"></i>
                                </div>
                                <div class="fa-stack" v-if="employeeGroup.draggable" v-on:mousedown="DragStartBusinessUnit($event, employeeGroup,indexGroup)" v-bind:style="{'margin-left': employeeGroup.indentationLevel == 0 ? '0px' : '23px'}">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-stack-2x fa-arrows-alt"></i>
                                </div>
                                {{employeeGroup.label}} <span v-if="employeeGroup.helper && dropIndexBusinessUnit == indexGroup">&gt;&gt;</span>
                            </div>

                            
                            <div class="fa-stack add" v-on:click="OpenBusinessUnitPopup($event)" v-if="!employeeGroup.helper && !shiftTemplateView">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x fa-plus"></i>
                            </div>
                            <div class="fa-stack add" v-on:click="OpenNewShiftTemplatePopup($event, employeeGroup)" v-if="shiftTemplateView">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x fa-plus"></i>
                            </div>

                            <div class="fa-stack" v-on:click="employeeGroup.collapsed = !employeeGroup.collapsed" v-if="!employeeGroup.helper">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : employeeGroup.collapsed, 'fa-angle-up' : !employeeGroup.collapsed}"></i>
                            </div>
                        </div>
                        <!-- End EmployeeGroups, green header (label, etc) -->


                        <div class="entry" v-if="employeeGroup.show && !(employeeGroup.collapsed || (employee.shiftTemplateEntry && employee.shiftTemplateDelay))" v-for="(employee, index) in employeeGroup.employees" :key="index" 
                        v-bind:style="{display: !employeeGroup.employeesFiltered.find(e => e === employee) ? 'none !important' : ''}">
                            <div class="employee" 
                            v-bind:id="employee.id" 
                            v-on:click="SelectEmployee($event,employee)" 
                            v-bind:style="GetEmployeeStyles()" 
                            v-bind:class="[employee.shiftTemplateEntry ? 'template' : '', employeeGroup.indentationLevel == 0 ? 'indentationLevelEmployee0' : 'indentationLevelEmployee1']">
                                <div class="picture" v-bind:style="{ background: (employee !== null ? employee.picture : 'url(../img/default.jpg)')}" v-on:mousedown="DragStartEmployee($event, employeeGroup,indexGroup,employee)"></div>
                                <div class="namefirst">{{employee.firstName + ' ' + employee.lastName}}</div>
                                                                <!-- <div class="namelast"> TEST </div> -->

                                <div v-on:click.stop="OpenSollistPopup($event, employee)" style="cursor:pointer;">
                                    <sollistbar ref="sollistbars" :firstName="employee ? employee.firstName : null" :lastName="employee ? employee.lastName : null" :employeeId="employee ? employee.id : null" :indentationLevel="employeeGroup.indentationLevel"/>
                                </div>

                                <div class="fa-stack new" v-if="shiftTemplateView && !employee.shiftTemplateEntry && !employee.shiftTemplateUnassigned" v-bind:class="{'disabled' : ShiftInDayIsPublished(employee)}">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-stack-2x fa-minus"></i>
                                </div>
                                <div class="fa-stack delete" v-if="shiftTemplateView && employee.shiftTemplateUnassigned">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-stack-2x fa-times"></i>
                                </div>
                            </div>
                            <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">
                                <div class="day" v-bind:employeeId="employee.id"
                                     v-if="!dayMode"
                                     v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index"
                                     v-bind:class="GetDayStatus(employee, indexweek, index)"
                                     v-bind:day="gridWeekInfo['w'+indexweek]['e'+index].dayString"
                                     v-bind:month="gridWeekInfo['w'+indexweek]['e'+index].monthString"
                                     v-bind:year="gridWeekInfo['w'+indexweek]['e'+index].yearString"
                                     v-on:mousedown="DragStartShift($event, (employeeMap[employee.id] && employeeMap[employee.id].shiftsDate && employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString] && employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString].length > 0) ? employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString][0] : null)"
                                     v-on:mouseup="ToggleDropDownContainer($event, employee, 'timebar', 55, -55, 20, 3)">


                                    <div v-if="HasShift(employee, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                        <i class="fas fa-eye-slash" v-if="employeeMap[employee.id] && employeeMap[employee.id].shifts && employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString] && employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString].length > 0 && !employeeMap[employee.id].shiftsDate[gridWeekInfo['w'+indexweek]['e'+index].dateString][0].published"></i>
                                        <div class="name">{{LowestShiftTime(employee, gridWeekInfo['w'+indexweek]['e'+index].date)}}</div>
                                        <div class="date">{{HighestShiftTime(employee, gridWeekInfo['w'+indexweek]['e'+index].date)}}</div>
                                    </div>

                                    
                                    <div v-if="!HasShift(employee, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                        <div v-if="HasSickness(employee, gridWeekInfo['w'+indexweek]['e'+index].date)" style="
                                            float: left;
                                            width: 40px;
                                            height: 40px;
                                            left: 0;
                                            bottom:0;
                                            right:0;
                                            text-align:center;
                                            font-size: 10;
                                            background:#fff !important;
                                            padding-top:3px important;
                                            border-radius: 10px;
                                        ">
                                        <i style="position:relative; top:0;left:0;bottom:0;right:0; font-size:25px; 
                                        padding-top:6px; color:#e5154f;" 
                                        class="fas fa-briefcase-medical"></i></div>
                                    </div>


                                    <div v-if="!HasShift(employee, gridWeekInfo['w'+indexweek]['e'+index].date)">
                                        <div v-if="HasHoliday(employee, gridWeekInfo['w'+indexweek]['e'+index].date)" style="
                                            float: left;
                                            width: 40px;
                                            height: 40px;
                                            left: 0;
                                            bottom:0;
                                            right:0;
                                            text-align:center;
                                            font-size: 10;
                                            background:#fff !important;
                                            padding-top:3px important;
                                            border-radius: 10px;
                                        "><i style="position:relative; top:0;left:0;bottom:0;right:0; font-size:25px; 
                                        padding-top:6px; color:#dec92f;" 
                                        class="fas fa-umbrella-beach"></i></div>


                                    </div>


                                    
                                    
                                </div>
                            </div>
                            <div class="table" v-if="dayMode" v-bind:class="[employee.dayModeClasses]" v-bind:style="GetTableStyles()">
                                <timebar :eventProp="GetTimeBarProp(employee, dayModeDate)" :employeeId="employee ? employee.id : null" @timebar-update-shift="onTimebarUpdateShift" />
                            </div>
                        </div>
                    </div>                
                    <!-- ********************************************************* -->
                    <!-- ************** END EMPLOYEE GROUPS ********************** -->
                    <!-- ********************************************************* -->



                </div>
                <div>
                    <div class="entry group business" v-bind:style="{height: '25px'}" v-for="(businessGroup, indexBAGroup) in businessGroupsAfter" :key="indexBAGroup" v-bind:class="{'collapsed' : businessGroup.collapsed}">
                        <div class="header">
                            <div class="label">{{businessGroup.label}}</div>
                            <div class="fa-stack" v-on:click="SelectUnitSort(businessGroup)">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : businessGroup.collapsed, 'fa-angle-up' : !businessGroup.collapsed}"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hour-grid" v-bind:class="{'full-half': dayModeHours === 36, full: dayModeHours === 24, half: dayModeHours === 12 ,quarter: dayModeHours === 6}" v-if="dayMode">
                <div class="time-marks">
                    <div class="mark" v-for="indexHour in dayModeHours" v-bind:class="{am: parseInt(dayModeDate.clone().add(indexHour, 'hours').format('HH')) < 13}" :key="indexHour">
                        <div class="sale quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlySaleAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(0))" v-bind:class="GetQuarterlySale(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(0))"></div>
                        <div class="sale quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlySaleAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(15))" v-bind:class="GetQuarterlySale(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(15))"></div>
                        <div class="sale quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlySaleAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(30))" v-bind:class="GetQuarterlySale(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(30))"></div>
                        <div class="sale quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlySaleAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(45))" v-bind:class="GetQuarterlySale(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(45))"></div>
                        <div class="label">{{dayModeDate.clone().add(indexHour -  1, 'hours').format('HH')}}</div>
                    </div>
                </div>
                <div class="amount"></div>
            </div>
            <div class="shifts" v-if="dayMode">
                <div class="return backward">
                    <div class="fa-stack" v-on:click="ShiftTimeBarsBack()">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-stack-2x fa-angle-left"></i>
                    </div>
                </div>
                <div class="return forward" v-if="dayMode">
                    <div class="fa-stack" v-on:click="ShiftTimeBarsForwards()">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-stack-2x fa-angle-right"></i>
                    </div>
                </div>
                <div class="shifts-toggle" v-on:click="showUnassigned = !showUnassigned, UpdateTimebarLabels()">❮</div>
                <div class="label">Unnassigned Shifts</div>
                <div class="shift add" v-on:click="OpenNewUnassignedShiftPopup($event, dayModeDate)">
                    <div class="label">Add Shift</div>
                </div>
                <div class="shift" style="margin-top: 15px; margin-bottom: 10px;" v-if="dynamicFilterActive">
                    <div class="label" style="background-color: #6d8d23; color:#fff;">Dynamischer Filter ist aktiviert</div>
                </div>
                <div class="shift" v-for="(shift, index) in dayModeShifts" v-on:click="dayModeShiftSelected = dayModeShiftSelected === shift ? null : shift, UpdateTimeTableBorders(!dayModeShiftSelected ? [] : [shift])" v-bind:class="{selected: shift === dayModeShiftSelected}" :key="'shift' + index"
                 v-on:mousedown="DragStartShift($event, shift)">
                    <timebar :eventProp="GetTimeBarShiftProp(dayModeDate, shift)" @timebar-update-shift="onTimebarUpdateShift"/>
                </div>
            </div>
            <div class="employee-data" v-bind:style="{left: EmployeeDataScroll()}" v-bind:class="{show: employeeSelected !== null}">
                <div class="section title">
                    <div class="entry">
                        <div class="label">Editing</div>
                        <div style="width: 30px;height: 30px;position: absolute;left: 10px;top: 10px;cursor: pointer;    font-weight: 600;color: rgba(0,0,0,.3);"
                             v-on:click="CloseEmployeeDetails()"> ❮
                        </div>
                    </div>
                </div>
                <div class="employee">
                    <div class="picture"
                         v-bind:style="{ background: (employeeSelected !== null ? employeeSelected.picture : '')}"></div>
                    <div class="slideshow">
                        <div class="marker selected"></div>
                        <div class="marker"></div>
                        <div class="marker"></div>
                    </div>
                    <div class="bonus">
                        <div class="entry">
                            <div class="left">Urlaub</div>
                            <div class="right">15 / 25</div>
                        </div>
                        <div class="entry">
                            <div class="left">Krank / Arzt</div>
                            <div class="right">12</div>
                        </div>
                    </div>
                    <div class="namefirst">{{(employeeSelected !== null ? employeeSelected.firstName : '')}}</div>
                    <div class="namelast">{{(employeeSelected !== null ? employeeSelected.lastName : '') }}</div>
                    <div class="progressbar">
                        <div class="progressfill"
                             v-bind:style="{width: (employeeSelected !== null && employeeSelected.progress ? (employeeSelected.progress.toString() + '%'): '0%' )}">

                        </div>
                    </div>

                </div>
                <div class="section">
                    <div class="entry">
                        <div class="label">Samstag DD.MM.YY</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack disabled">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-right fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack disabled">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-left fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Fruhschicht</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="label">von 00:00</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="label">bis 00:00</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Service</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="icon send disabled">Senden</div>
                    </div>
                </div>
                <div class="section">
                    <div class="entry">
                        <div class="label">Urlaub</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Samstag DD.MM.YY</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Samstag DD.MM.YY</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="label">Ablehnen</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="icon send disabled">Senden</div>
                    </div>
                </div>
                <div class="section">
                    <div class="entry">
                        <div class="label">Urlaub</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Samstag DD.MM.YY</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry">
                        <div class="label">Samstag DD.MM.YY</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="label">Ablehnen</div>
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-angle-down fa-stack-2x"></i>
                        </div>
                    </div>
                    <div class="entry half">
                        <div class="icon send disabled">Senden</div>
                    </div>
                </div>
                <div class="section store">
                    <div class="entry" v-for="(unit, i) in spots.items.filter(s => s.label !== 'All')" :key="i">
                        <i class="fas fa-check-circle checkbox" v-bind:style="{color: businessUnitColor[i] +  ' !important'}" v-bind:class="{false: !employeeSelected || !employeeMap[employeeSelected.id].skills || !HasSkill(employeeMap[employeeSelected.id], skillMap[spotMap[unit.id].requiredSkill])}"></i>
                        <div class="label">{{unit.label}}</div>
                        <div class="icon menu"></div>
                    </div>
                    <div class="entry disabled">
                        <div class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                        </div>
                        <div class="label">Benutzerdefiniert</div>
                    </div>
                </div>
            </div>
        </div>
        <dropdown v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i"/>
        <drag ref="drag"/>
        <dragbusinessunit ref="dragbusinessunit"/>
        <dragemployee ref="dragemployee"/>
        <dropdowncontainer ref="dropdowncontainer"/>
        <userselect ref="userselect"/>
        <incomepopup ref="incomepopup"/>
        <weatherpopup ref="weatherpopup"/>
        <buvisibilitypopup ref="buvisibilitypopup"/>
        <filterpopup ref="filterpopup"/>
        <businessunitpopup ref="businessunitpopup"/>
        <sollistpopup ref="sollistpopup"/>
        <div v-if="loading" class="loading">
            <i class="fas fa-spinner"></i>
        </div>

        <b-modal ref="modal-rosterrequestwizard"  size="xl" no-close-on-backdrop no-close-on-esc centered title="Auto Dienstplan erstellen" ok-only ok-variant="secondary" ok-title="Abbrechen" @ok="hideModal('modal-rosterrequestwizard')">
            <b-container fluid>
               <rosterrequestwizard></rosterrequestwizard>
            </b-container>
        </b-modal>

        <!-- <b-modal ref="modal-autorosterresults"  size="xl" no-close-on-backdrop no-close-on-esc centered title="Auto Dienstplan Ergebnisse" ok-only ok-variant="secondary" ok-title="Abbrechen" @ok="hideModal('modal-autorosterresults')">
            <b-container fluid>
               <rosterresult @apply-rosterresult="applyAutoRosterResult()"></rosterresult>
            </b-container>
        </b-modal> -->

    </div>
</template>


<script>

    import datepicker from '../uicomponents/datepicker.vue'
    import userselect from './UserSelect.vue'
    import dropdown from '../uicomponents/dropdown.vue'
    import dropdowncontainer from '../uicomponents/dropdowncontainer.vue'
    import searchbar from '../uicomponents/searchbar.vue'
    import timebar from '../testroster/TimeBar.vue'
    import weatherslider from '../weathercontext/WeatherSlider.vue'
    import incomepopup from '../weathercontext/IncomePopup.vue'
    import weatherpopup from '../weathercontext/WeatherPopup.vue'
    import buvisibilitypopup from '../testroster/BUVisibilityPopup.vue'
    import filterpopup from '../testroster/FilterPopup.vue'
    import businessunitpopup from '../testroster/AddBusinessUnit.vue'
    import drag from './drag.vue'
    import dragbusinessunit from './dragBusinessUnit.vue'
    import dragemployee from './dragEmployee.vue'
    import rosterrequestwizard from '../rostercontext/RosterRequestWizard.vue'

    import sollistbar from '../testroster/SollIstBars.vue'
    import sollistpopup from '../testroster/SollIstPopup.vue'

    import templateview from '../shiftcontext/TemplateView.vue'

    import VueEventBus from '../../vue-event-bus';

    const moment = require('moment');
    export default {
        name: 'Roster',
        components: {
            datepicker,
            dropdown,
            userselect,
            searchbar,
            dropdowncontainer,
            timebar,
            drag,
            dragbusinessunit,
            dragemployee,
            weatherslider,
            incomepopup,
            weatherpopup,
            buvisibilitypopup,
            filterpopup,
            businessunitpopup,
            rosterrequestwizard,
            sollistbar,
            sollistpopup,
            templateview,
        },
        data() {
            return {
                viewMode: 1,
                sollIstMode: 1, // 0 = auflaufend , 1 = monatlich neu (überschuss immer auf 0 setzen)
                sollIstDragging: {
                    employeeIdOld: null,
                    employeeIdNew: null,
                    shiftTimeinMinutes: 0
                },
                clearFilterDelay: 1200,

                openRumpfWocheImg: 'img/month_open_rumpf_image.png',
                openRumpfWocheHoverImg: 'img/month_open_rumpf_image_hover.png',
                visibleRumpfImage: 'img/month_open_rumpf_image.png',

                rumpfWocheImg: 'img/month_rumpf_image.png',
                rumpfWocheHoverImg: 'img/month_rumpf_image_hover.png',
                nonVisibleRumpfImage: 'img/month_rumpf_image.png',

                sollIstMap: {},
                sollIstOverflow: 1,

                businessUnitColor: [
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d22',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d22',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d22',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                ],
                businessUnits: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [],
                    onceSelected: function ($event, item, searchbar){
                    }
                },
                spots: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [],
                    onceSelected: function ($event, item, searchbar){
                    }
                },
				loading: true,
                dateSelectionStart: undefined,
                posx: 0,
                employeeSelected: null,
                mockupToggle: false,
                datepickerState: {
                    monthView: true,
                    dayViewAllowed: false,
                    yearViewAllowed: false,
                    posx: 0,
                    posy: 0,
                    toggled: false,
                    date: undefined,
                    selectedDate: undefined,
                },
                dropdowns: [],
                styles: '.employee \n { \n background: black; \n }',
                dragging: false,
                dynamicFilterActive: false,
                draggingBusinessUnit: false,
                draggingEmployee: false,
                initialShowMajorDone: false,
                storeSettings: null,
                  employees: [],
                  employeeMap:{},
                  businessunitMap: {},
                  holidayMap: {},
                  userunitsort: [],
                  spotMap:{},
                  softSkills: [],
                  employeeContracts:[],
                  employeeContractMap: {},
                  employeeAvailabilities:[],
                  employeeAvailabilityMap: {},
                  skillMap:{},
                  employeeSkills:[],
                  employeeSkillMap: {},
                  employeeTypeMap: {},
                  employeeRulesMap: {},
                  employeeWorkBalanceMap: {},
                  fields: [{key:"firstName", label:"Vorname", sortable: true},{key:"lastName", label:"Nachname", sortable: true},{key:"accountLinked", label:"Account", sortable: true}, {key:"actions", sortable: false}],
                  contractTableFields: [{key:"paymentType", label:"Anstellungs-Typ", sortable: true}, {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true}, {key:"actions", sortable: false}],
                  availabilityTableFields: [{key:"type", label:"Verfügbarkeits-Typ", sortable: true}, {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true}, {key:"weekDays", label:"Wochentage", sortable: false}, {key:"actions", sortable: false}],
                  employeeSkillsTableFields: [{key:"name", label:"Name", sortable: true}, {key:"value", label:"Wert", sortable: true}, {key:"actions", sortable: false}],

                  countryMap: {
                      1: "Österreich",
                      2: "Deutschland",
                      3: "Italien"
                  },
                  employeename: "",
                  employeeId:"",
                  contractId:"",
                  availabilityId:"",
                  employeeSkillId: "",
                  employeeTypeId: undefined,
                  employeeRulesId: undefined,
                  newEmployee: {
                      title: "Herr",
                      prefix: "",
                      firstName: "",
                      postfix: "",
                      lastName: "",
                      dob: null,
                      gender: "M",
                      religion: "",
                      socialsecurity: "",
                      disability: false,
                      driverslicense: false,
                      dlExpiry: null,
                      firstaidcourse: false,
                      faExpiry: null,
                      mobilephone:"",
                      homephone: "",
                      email: "",
                      country: 1,
                      address: "",
                      postalCode: "",
                      city: "",
                      iban: "",
                      bic: "",
                      nationality: 1,
                      citizenType: 1,
                      employedSince: null,
                      guardianName: "",
                      guardianAddress: ""
                  },
                  employeeSkill: {
                      skillId: "",
                      value: 0
                  },
                  employeeContract: {
                      jobName: "",
                      from: null,
                      to: null,
                      probationTo: null,
                      paymentType: 1,
                      payment: 2000,
                      weekTimeRegular: 40,
                      weekWorkDaysRegular: 5,
                      vacationTime: 0,
                      employeeCategory: 1,
                      employmentType: 1,
                      contractType: 1,
                      nightWorkerType: 1,
                      nightWorkBonusHour: 0,
                      nightWorkBonusShift: 0,
                      overtimeBonusHour: 0,
                      overtimeBonusShift: 0,
                      costCenter: "",
                      collectiveContract: false,
                      collectiveContractType: "",
                      collectiveContractRank: 0,
                      apprenticeYear: 1,
                      comment: ""
                  },
                  employeeType: {
                      unitId:"",
                      monthTimeRegular: 172,
                      monthTimeMaxType: 1,
                      monthTimeMaxAdjustment: 0,
                      weekTimeMax: 60,
                      weekTimeRegular: 40,
                      dayTimeMax: 8,
                      dayTimeRegular: 8,
                      restTime: 11,
                      allowMultipleShifts: false,
                      shiftBetweenTimeMin: 0,
                      shiftBetweenTimeMax: 3,
                      limitConsecutiveDays: false,
                      daysConsecutiveMax: 6,
                      limitOvertime: false,
                      monthOvertimeMax: 20,
                      overtimeCutoff: 480,
                      useWorkDaysForSpareTime: false,
                      weekWorkDaysMax: 1,
                      weekWorkDaysRegular: 5,
                      weekSpareDaysMin: 1,
                      weekAdditionalSpareTime: 12
                  },
                  employeeAvailability: {
                      from: "",
                      to: "",
                      spotId: null,
                      state: 1,
                      factor: 1,
                      monday: false,
                      tuesday: false,
                      wednesday:false,
                      thursday: false,
                      friday: false,
                      saturday: false,
                      sunday: false,
                      comment: null,

                  },
                  employeeRules: {
                      desiredR: false,
                      desiredRfactor: 1,
                      undesiredR: false,
                      undesiredRfactor: 1,
                      weekendR: false,
                      weekendRfactor: 1,
                      weekendDaysR: false,
                      weekendDaysRfactor: 1,
                      skillR: false,
                      fairnessDefinitionR: false,
                      fairnessDefinitionRfactor: 1,
                      bioR: false,
                      bioRfactor: 1,
                  },
                  currentEmployeeRow: {},
                  currentContractRow:{},
                  currentAvailabilityRow:{},
                  currentEmployeeSkillRow: {},
                  employeeerror: false,
                  shiftSkillMap:{},
                  planShiftMap: {},
                  shiftChangeMap: {},
                  shiftChanges: [],
                  planshifts: [],
                  shiftSkills: [],
                  planShift: {
                      employeeId: null,
                      spotId: null,
                      fromDate: null,
                      toDate: null,
                      fromTime: null,
                      toTime: null,
                      workValue: -1,
                      calculateWorkvalue: true

                  },
                  planShiftUpdate: {
                      employeeId: null,
                      spotId: null,
                      fromDate: null,
                      toDate: null,
                      fromTime: null,
                      toTime: null,
                      workValue: -1,
                      calculateWorkvalue: true
                  },
                  shiftSkill: {
                      skillId: null,
                      required: false
                  },
                  planShiftId:"",
                  shiftSkillId: "",
                  shiftChangeId: "",
                  employeesFiltered: [],
                  dayMode: false,
                  dayModeDate: this.$helpers.getMomentUTC(),
                  
                  dayModeShiftSelected: {},
                  employeePreferenceMap: {},
                  employeepreferences: [],
                  gridStack: [],
                  employeeGroups: [],
                  businessGroups: [],
                  businessGroupsBefore: [],
                  businessGroupsAfter: [],
                  businessSortToggle: false,
                  selectedUnit: null,
                  dayModeHours: 24,
                  showUnassigned: true,
                  dayModeAssignedFilter: false,
                  shiftsSelected: [],
                    
                  weather: {
                      data:[],

                  },
                  weatherPopupOpen: false,
                  buVisibilityPopupOpen: false,
                  filterPopupOpen: false,
                  sollistPopupOpen: false,
                  monthOnlyDays: true,
                  rawWeatherData: [],
                  storeSales: {},
                  storeSalesDaily: [],

                  showBusinessUnits: true,
                  softSkillsFiltered: [],
                  shiftTemplateGroupMap: {},
                  shiftTemplateMap: {},
                  shiftTemplates: [],
                  shiftTemplateSkillMap: {},
                  shiftTemplateView: false,
                  dynamicSkillsFiltered: [],
                  dropIndexBusinessUnit: 0,
                  dynamicFiltering: (this.$store.state.accountPreference == null) ? true : this.$store.state.accountPreference.dynamicFilterEnabled,
                  templateDaySelection: 1,
                templateViewState: {
                    templateDaySelection: 1,
                    embedded: true,
                }
            }
        },
        updated(){
            var view = this;
            var last = null;
            
            $('.entry.group').each(function(i, e){
                $(this).css('margin-top', '');
                if(last && !last.hasClass('collapsed') && !last.hasClass('business')) $(this).css('margin-top', '25px');
                last = $(this);
            });
            
        },
        created(){
			moment.locale('de');
            this.setDateSelection(this.$helpers.getCurrentMonthMomentUTC(), true);
		    window.roster = this;
            window.moment = moment;
            if(window.trackDayBorder){
                clearTimeout(window.trackDayBorder);
                window.trackDayBorder = null;
            }
            window.trackDayBorder = setInterval(this.TrackDayBorderHeight, .5);
            VueEventBus.$on("autoscheduling-submitted", this.onAutoSchedulingSubmitted);
            VueEventBus.$on("preview-autoroster-result", this.onPreviewAutoRosterResult);
            VueEventBus.$on("apply-autoroster-result", this.onApplyAutoRosterResult);
            
            
        },
        beforeDestroy(){
            VueEventBus.$off("autoscheduling-submitted", this.onAutoSchedulingSubmitted);
            VueEventBus.$off("preview-autoroster-result", this.onPreviewAutoRosterResult);
            VueEventBus.$off("apply-autoroster-result", this.onApplyAutoRosterResult);
            if(this.$refs.incomepopup && this.$refs.incomepopup.$el) $(this.$refs.incomepopup.$el).remove();
            if(this.$refs.weatherpopup && this.$refs.weatherpopup.$el) $(this.$refs.weatherpopup.$el).remove();
            if(this.$refs.buvisibilitypopup && this.$refs.buvisibilitypopup.$el) $(this.$refs.buvisibilitypopup.$el).remove();
            if(this.$refs.filterpopup && this.$refs.filterpopup.$el) $(this.$refs.filterpopup.$el).remove();
            if(this.$refs.sollistpopup && this.$refs.sollistpopup.$el) $(this.$refs.sollistpopup.$el).remove();
            if(this.$refs.businessunitpopup && this.$refs.businessunitpopup.$el) $(this.$refs.businessunitpopup.$el).remove();
            if(this.$refs.dropdowncontainer && this.$refs.dropdowncontainer.$el) $(this.$refs.dropdowncontainer.$el).remove();
            if(this.$refs.userselect && this.$refs.userselect.$el) $(this.$refs.userselect.$el).remove();
            if(window.trackDayBorder){
                clearTimeout(trackDayBorder);
                window.trackDayBorder = null;
            }
            
        },
        mounted() {
            let view = this;
           
           
            
            $('.app .scrollbar-container .grid').on('scroll', this.EmployeeDataScroll);
            this.SetWeatherSliderOffset();
            $('.app .scrollbar-container .grid').on('scroll', this.SetWeatherSliderOffset);
            //$('.app .scrollbar-container .grid').on('scroll', this.SetDayViewDayOffset);
            
            
        },
        computed: {
            gridWeekInfo: function(){
               
                let from = this.dateSelectionStart.clone().startOf('isoWeek').format();
                let to =  this.dateSelectionStart.clone().endOf('month').endOf('isoWeek').add(1,'weeks').startOf('isoWeek');
               
                let weeks = to.diff(from, 'weeks');
                
                let gridWeekInfo =  {
                    weeks: weeks,
                };
                let startIndex = this.dateSelectionStart.isoWeekday();
               
                for (let i = 1; i <= gridWeekInfo.weeks; i++){
                    gridWeekInfo['w'+i] = {indices: []};
                    for(let j = 1; j <= 7; j++){
                        //index week goes from 1 to 6, index from 1 to 7
                        //we know that dateSelectionStart must be in first week
                       
                        let indexTotal = (i-1)*7 + j;
                        
                        let currentDate;

                        currentDate = this.dateSelectionStart.clone().add(indexTotal - startIndex, 'days') 
                        
                        let gridWeekEntry = {
                            index: j,
                            date: currentDate,
                            dateString: currentDate.format('YYYY-MM-DD'),
                            dayString: currentDate.format('DD'),
                            monthString: currentDate.format('MM'),
                            yearString: currentDate.format('YYYY')
                        }
                       
                        
                        if((!this.dayMode || (this.dayMode && gridWeekEntry.dateString === this.dayModeDate.format('YYYY-MM-DD')))
                            && (!this.monthOnlyDays || (this.monthOnlyDays && currentDate.month() === this.dateSelectionStart.month()))) {
                            
                            gridWeekInfo['w'+i].indices.push(gridWeekEntry.index);
                            gridWeekInfo['w'+i]['e'+gridWeekEntry.index] = gridWeekEntry;
                        };
                        
                        
                    }
                }
                return gridWeekInfo;
            },
            dayModeInfo(){
                let dayModeInfo = {
                    name: this.dayModeDate.format("dddd"),
                    date: this.dayModeDate.format("DD.MMMM")
                }
                return dayModeInfo;
            },
            monthDisplay: function() {
                if(this.dateSelectionStart != null){
                    return this.dateSelectionStart.format('MMM YYYY');
                } else {
                    '-';
                }
                
            },
            loginStatus() {
                return this.$store.state.loggedIn;
            },
            rosterFromTo() {
                if(this.$store.state.loggedIn){
                    return this.$store.state.rosterFromTo;
                } else {
                    return null;
                }
                
            },
            publishableShifts() {
                if(this.dayMode) {
                    return this.planshifts.filter(s => !s.published && s.employeeId != null && s.date.date() === this.dayModeDate.date());
                } else {
                    return this.planshifts.filter(s => !s.published && s.employeeId != null);
                }
                
            },
            unpublishableShifts() {
                if(this.dayMode) {
                    return this.planshifts.filter(s => s.published && s.date.diff(this.$helpers.getMomentUTC(), 'minutes') > 30 && s.date.date() === this.dayModeDate.date());
                } else {
                    return this.planshifts.filter(s => s.published && s.date.diff(this.$helpers.getMomentUTC(), 'minutes') > 30);
                }
                
            },
            selectedPublishableShifts() {
                if(this.dayMode) {
                    return this.shiftsSelected.filter(s => !s.published && s.employeeId != null && s.fromDate.date() === this.dayModeDate.date());
                } else {
                    return this.shiftsSelected.filter(s => !s.published && s.employeeId != null);
                }
                
            },
            selectedUnpublishableShifts() {
                if(this.dayMode) {
                    return this.shiftsSelected.filter(s => s.published && s.fromDate.diff(this.$helpers.getMomentUTC(), 'minutes') > 30 && s.fromDate.date() === this.dayModeDate.date());
                } else {
                    return this.shiftsSelected.filter(s => s.published && s.fromDate.diff(this.$helpers.getMomentUTC(), 'minutes') > 30);
                }
                
            },
            dayModeShifts() {
                return Object.values(this.planShiftMap).filter(s => !s.employeeId && this.dayModeDate.format('YYYY-MM-DD') === s.fromDate.format('YYYY-MM-DD'));
            },
            storeId() {
                return this.$store.state.storeId;
            }
        },
        watch: {
            /*loginStatus(newVal, oldVal) {
                console.log("Changed login");
                 this.refresh();

            },*/
            rosterFromTo(newVal, oldVal) {
                if(newVal != null){
                    console.log("Changed rosterFromTo");
                    this.refresh();
                }
            },
            storeId(newVal, oldVal) {
                console.log("Changed storeId: "+newVal);
                this.refresh();
            }
        },
        methods: {
            LoadPreferenceView(){
                this.$router.push({ name: 'preferences', params: { mode: 2, currentDay: this.dayModeDate.clone() } } );
            },
            LoadTemplateView(){
                var view = this;
                this.templateViewState = {
                    templateDaySelection: this.dayModeDate.isoWeekday(),
                    embedded: true,
                    RefreshButton: function() {
                        view.shiftTemplateView = false;
                    },
                };
                this.shiftTemplateView = true;
                //this.$router.push({ name: 'templateview', params: { daySelected: this.dayModeDate.clone() } } );
            },
            setDateSelection(date, calculateRosterFromTo){
                this.dateSelectionStart = date.clone(); 
                
                if(calculateRosterFromTo){
                    //update vuex store with calculated from to => triggers reload of data via refresh
                    // We need the last 2 months for the SOLL-IST Comparison, or a sophisticated check if the Monatsabschluss exists
                    let rosterFromTo = {
                        month: this.dateSelectionStart.month(),
                        from: this.dateSelectionStart.clone().startOf('isoWeek').format(),
                        to: this.dateSelectionStart.clone().endOf('month').endOf('isoWeek').add(1,'weeks').startOf('isoWeek').format(),
                    };
                    this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                } else {
                    //dont update vuex from to, only update client side view

                }

            },
            onDatePicked(date){
                
                this.setDateSelection(date, true);
            },
            toggleDatePicker() {
                this.datepickerState = {
                    toggled: true,
                    monthView: true,
                    dayViewAllowed: false,
                    yearViewAllowed: false,
                    posx: window.mouse.x,
                    posy: window.mouse.y,
                    date: this.dateSelectionStart,
                    selectedDate: this.dateSelectionStart
                };
            },
            onPreviewAutoRosterResult: function(shifts){
                this.replaceShifts(shifts, true);
                
            },
            onApplyAutoRosterResult(){
                this.refresh();
            },
            onAutoSchedulingSubmitted(){
                this.hideModal('modal-rosterrequestwizard');
            },
            GetDailySalesBarWidth(date){
                var format = date.format('YYYY-MM-DD');
                if(!this.storeSales[format] || !this.storeSales[format].planned || !this.storeSales[format].actual) return 'calc(0% - 10px)';
                var length = (this.storeSales[format].actual.sumAmount / this.storeSales[format].planned.sumAmount) * 100;
                if(length > 100) length = 100;
                var ratio = (this.storeSales[format].actual.sumAmount / this.storeSales[format].planned.sumAmount);
                var margin = 10 * ratio;
                return 'calc(' + length + '% - ' + margin + 'px)';


            },
            HideQuarterlyHover(){
                $(this.$el).find('.hour-grid .amount').css('opacity', 0);
            },
            PositionQuarterlyHover($event){
                var target = $event.currentTarget;
                var box = target.getBoundingClientRect();
                $(this.$el).find('.hour-grid .amount').css('opacity', 1);
                $(this.$el).find('.hour-grid .amount').css('top', (box.bottom + 5) + 'px');
                $(this.$el).find('.hour-grid .amount').css('left', (box.left + (box.width * .5)) + 'px');
                $(this.$el).find('.hour-grid .amount').text($(target).attr('amount'));

            },
            GetQuarterlySale(date){
                if(this.storeSalesDaily.find(s => !s.planned && s.dateMoment.date() === date.date() && s.dateMoment.hours() === date.hours() && s.dateMoment.minutes() === date.minutes())) return 'green';
                return 'gray';
            },
            GetQuarterlySaleAmount(date){
                var sales =  this.storeSalesDaily.filter(s => !s.planned && s.dateMoment.date() === date.date() && s.dateMoment.hours() === date.hours() && s.dateMoment.minutes() === date.minutes());
                if(sales.length > 0) {
                    var total = 0;
                    sales.forEach(s => total += s.amount);
                    total *= 0.01;
                    return '€ ' + total;
                }
                return '€ 0';
            },
            TrackDayBorderHeight(){
                if($('.entry.group > .entry').length > 0) requestAnimationFrame(function(){

                    if($('.entry.group > .entry').last() && $('.entry.group > .entry').last()[0])$('.border-day').css('height', ($('.entry.group > .entry').last()[0].getBoundingClientRect().bottom - 135 + $('.scrollbar-container > .grid').scrollTop()) + 'px');
                });
                else $('.border-day').css('height', '60px');
            },
            ToggleMonthOnlyDays(){
                this.monthOnlyDays = !this.monthOnlyDays;
                $('.weather-slider').css('left', $('.entry.header .day[date=' + this.$helpers.getMomentUTC().format('MM-DD') + ']')[0] ? $('.entry.header .day[date=' + this.$helpers.getMomentUTC().format('MM-DD') + ']')[0].getBoundingClientRect().left + 'px' : '');
                this.$forceUpdate();
            },
            OpenIncomePopup($event, day){
                if(this.$refs.incomepopup){
                     this.$refs.incomepopup.Init({
                        date: day.clone(),
                        elRelative: $event.currentTarget,
                    });
                }
               
            },
            GetWeatherSliderOffset(){
                return $('.entry.header .day[date=' + this.$helpers.getMomentUTC().format('MM-DD') + ']')[0] ? $('.entry.header .day[date=' + this.$helpers.getMomentUTC().format('MM-DD') + ']')[0].getBoundingClientRect().left + 'px' : '1000 px';
                return ($('.entry.header .day').index($('.entry.header .day[date=' + this.$helpers.getMomentUTC().format('MM-DD') + ']')[0]) * 50) + 'px';
            },
            SetDayViewDayOffset($event){
               /*$('.day-mode .grid .entry.header .day').css('margin-left', (1 * ($('.app .scrollbar-container .grid').scrollLeft() - 0) * 0.5) + 'px');
               $('.day-mode .grid .entry.header .day').css('margin-top', (1 * ($('.app .scrollbar-container .grid').scrollTop() - 0) * .5) + 'px');*/
            },
            SetWeatherSliderOffset($event){

               $('.weather-slider').css('margin-left', (-1 * ($('.app .scrollbar-container .grid').scrollLeft() - 0)) + 'px');
               $('.weather-slider').css('margin-top', (-1 * ($('.app .scrollbar-container .grid').scrollTop() - 0)) + 'px');
            },
            extractDate: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split = str.split("T");
                    return split[0];
                } else {
                    return null;
                }
            },
            extractTime: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split1 = str.split("T");
                    let split2 = split1[1].split(":")
                    return split2[0]+":"+split2[1];
                } else {
                    return null;
                }

            },
            PublishSelectedShifts(){
                let view = this;
                if(!this.selectedPublishableShifts || this.selectedPublishableShifts.length === 0) return;
                 let url = '/api/sec/planshift/publish/multi';

                 url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/planshift/publish/multi');
                 let ids = [];
                 this.selectedPublishableShifts.forEach(s => ids.push(s.id));
                 let payload = {
                   storeId: view.$store.state.storeId,
                   ids: ids,
                 }
                 view.axios({
                     method: 'put',
                     headers: {
                         'AUTHORIZATION': "bearer "+view.$store.state.jwt
                     },
                     url: url,
                     data: payload
                 }).then(response => {
                    view.shiftsSelected = [];

                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => view.$set(view.planShiftMap[s.id], 'published', true));
                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => s.published = true);
                    view.$forceUpdate();
                    window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'Shifts Published', description: 'Selected shifts were published'});
                 }).catch(function (error) {
                    window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Multi Shift Publish Error', description: 'Error publishing shifts.'});
                 });
            },
            UnpublishSelectedShifts(){
                let view = this;
                if(!this.selectedUnpublishableShifts || this.selectedUnpublishableShifts.length === 0) return;
                 let url = '/api/sec/planshift/unpublish/multi';

                 url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/planshift/unpublish/multi');
                 let ids = [];
                 this.selectedUnpublishableShifts.forEach(s => ids.push(s.id));
                 let payload = {
                   storeId: view.$store.state.storeId,
                   ids: ids,
                 }
                 view.axios({
                     method: 'put',
                     headers: {
                         'AUTHORIZATION': "bearer "+view.$store.state.jwt
                     },
                     url: url,
                     data: payload
                 }).then(response => {
                    view.shiftsSelected = [];

                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => view.$set(view.planShiftMap[s.id], 'published', false));
                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => s.published = false);
                    view.$forceUpdate();
                    window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'Shifts Unpublished', description: 'Selected shifts were unpublished'});
                 }).catch(function (error) {
                     window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Multi Shift Unpublish Error', description: 'Error unpublishing shifts.'});
                 });
            },
            DeleteSelectedShifts(){
                var view = this;
                if(!this.shiftsSelected) return;
                if(!this.shiftTemplateView){
                    let url = '/api/sec/planshift/any/delete';

                     url = this.$helpers.appendParam("id", this.planShiftId, url, '/api/sec/planshift/any/delete');
                     url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/any/delete');
                     var ids = [];
                     this.shiftsSelected.forEach(s => ids.push(s.id));
                     let payload = {
                       ids: ids,
                     }
                     view.axios({
                        method: 'post',
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                     }).then(response => {
                        view.shiftsSelected = [];
                        var deletedIds = response.data.data;
                        deletedIds.forEach(i => view.$delete(view.planShiftMap, i));
                        window.roster.planshifts = window.roster.planshifts.filter(s => !deletedIds.find(i => i === s.id));
                        if(window.timebars) window.timebars.forEach(t => t.Init());
                        requestAnimationFrame(function(){
                            window.roster.GenerateEmployeeShiftsFromMap(window.roster.planShiftMap);
                            window.roster.$forceUpdate();
                            });
                        window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'Shifts Deleted', description: 'Selected shifts were deleted.'});
                     }).catch(function (error) {
                            console.log(error);
                         window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Multi Shift Deletion Error', description: 'Error deleting shifts.'});
                     });
                } else {
                    var total = this.shiftsSelected.length;
                    this.shiftsSelected.forEach(s => view.DeleteShiftTemplate(s).then(response =>
                        {
                            console.log(s);
                            Object.values(view.shiftTemplateGroupMap).forEach(g => g.templates = g.templates.filter(t => t.id !== s.id));
                            view.employeeGroups.forEach(g => g.employeesFiltered = g.employeesFiltered.filter(e => e.shiftTemplate && e.shiftTemplate.id !== s.id));
                            view.employeeGroups.forEach(g => g.employees = g.employees.filter(e => e.shiftTemplate && e.shiftTemplate.id !== s.id));
                            total--;
                            if(total === 0){
                                window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'Shift Templates Deleted', description: 'Selected shift templates were deleted.'});
                                view.$forceUpdate();
                            }
                        }).catch(function (error) {
                            console.log(error);
                            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Multi Shift Deletion Error', description: 'Error deleting shifts.'});
                         }));
                }
            },
            DeleteShiftTemplate(shift){
                let view = this;
                let url = '/api/sec/shifttemplate';

                url = this.$helpers.appendParam("id", shift.id, url, '/api/sec/shifttemplate');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplate');


                return this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            ClearAllShifts() {
                var view = this;
                if(!this.publishableShifts && this.publishableShifts.length <= 0) return;
                window.app.popupalerts.push({header: 'Clear All Shifts (' + this.publishableShifts.length + ')', description: 'Clear all clearable shifts?', hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                    let url = '/api/sec/planshift/multi';

                    
                    let params = {
                        storeId: view.$store.state.storeId
                    }
                    let payload = {
                       storeId: view.$store.state.storeId,
                       requests: [],
                    }
                    let requests = [];
                    view.publishableShifts.forEach(s => payload.requests.push({id: s.id, updateFields: ["employeeId"], employeeId: null}));
                     
                    view.axios({
                         method: 'put',
                         params: params,
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                    }).then(response => {
                        view.shiftsSelected = [];

                        popup.loading = false;
                        popup.hidden = true;
                        response.data.data.forEach(id => view.removeShiftFromEmployee(id));
                       
                        window.roster.$forceUpdate();
                        window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'All Shifts Cleared', description: 'All clearable shifts were cleared'});
                    }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                        console.log(error);
                         window.app.popupmessages.push({timer: 5000, type: 'error', header: 'All Shift Clear Error', description: 'Error clearing all shifts.'});
                    });
                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                    
                }});
            },
            PublishAllShifts(){
                var view = this;
                if(!this.publishableShifts && this.publishableShifts.length <= 0) return;
                window.app.popupalerts.push({header: 'Publish All Shifts (' + this.publishableShifts.length + ')', description: 'Publish all shifts?', hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                     let url = '/api/sec/planshift/publish/multi';

                     url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/planshift/publish/multi');
                     var ids = [];
                     view.publishableShifts.forEach(s => ids.push(s.id));
                     let payload = {
                       storeId: view.$store.state.storeId,
                       ids: ids,
                     }
                     view.axios({
                         method: 'put',
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                     }).then(response => {
                        view.shiftsSelected = [];

                        popup.loading = false;
                        popup.hidden = true;
                        
                        Object.values(window.roster.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => view.$set(view.planShiftMap[s.id], 'published', true));
                        window.roster.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => s.published = true);
                        window.roster.$forceUpdate();
                        window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'All Shifts Published', description: 'All shifts were published'});
                     }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                         window.app.popupmessages.push({timer: 5000, type: 'error', header: 'All Shift Publish Error', description: 'Error publishing all shifts.'});
                     });
                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                    
                }});

            },
            UnpublishAllShifts(){
                var view = this;
                if(!this.unpublishableShifts && this.unpublishableShifts.length <= 0) return;
                window.app.popupalerts.push({header: 'Unpublish All Shifts (' + this.unpublishableShifts.length + ')', description: 'Unpublish all shifts?', hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                     let url = '/api/sec/planshift/unpublish/multi';

                     url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/planshift/unpublish/multi');
                     var ids = [];
                     view.unpublishableShifts.forEach(s => ids.push(s.id));
                     let payload = {
                       storeId: view.$store.state.storeId,
                       ids: ids,
                     }
                     view.axios({
                         method: 'put',
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                     }).then(response => {
                        view.shiftsSelected = [];

                        popup.loading = false;
                        popup.hidden = true;
                        
                        Object.values(window.roster.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => view.$set(view.planShiftMap[s.id], 'published', false));
                        window.roster.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => s.published = false);
                        window.roster.$forceUpdate();
                        window.app.popupmessages.push({timer: 5000, type: 'confirmed', header: 'All Shifts Unpublished', description: 'All shifts were unpublished'});
                     }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                         window.app.popupmessages.push({timer: 5000, type: 'error', header: 'All Shift Unpublish Error', description: 'Error unpublishing all shifts.'});
                     });
                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                    
                }});

            },
            GetWeather(){
                var view = this;
                view.rawWeatherData = [];
                view.weather.data = [];
                let url = '/api/sec/weather';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to
                };
                //url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("from", this.$store.state.rosterFromTo.from, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("to", this.$store.state.rosterFromTo.to, url, '/api/sec/weather');

                this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    for(var x in response.data){
                                (function(data){
                                    view.rawWeatherData.push(data);
                                    var last = view.rawWeatherData[view.rawWeatherData.length - 1];
                                    last.date = moment.unix(data.dt).locale('de');

                                    // 3HOURLY DATA - START
                                    last.temp = Math.round(data.temp - 273.15);
                                    last.tempMin = Math.round(data.tempMin - 273.15);
                                    last.tempMax = Math.round(data.tempMax - 273.15);
                                    last.humidity = data.humidity;
                                    last.windspeed = data.windspeed;
                                    //last.pop = data.pop; //The 3hourly weather API does not return the Prob of Precipitation. But it returns the rain in millimeters. We need a workaround to calculate some kind of percentage from the mm information.
                                    last.weatherCode = view.GetWeatherCode(data.weatherId);
                                    // 3HOURLY DATA - END


                                    // DAY DATA - START
                                    last.dTemp = Math.round(data.dTemp - 273.15);
                                    last.dMinTemp = Math.round(data.dMinTemp - 273.15);
                                    last.dMaxTemp = Math.round(data.dMaxTemp - 273.15);
                                    last.dPop = data.dProbOfPrecipitation;
                                    last.dHumidity = data.dHumidity;
                                    last.dWindSpd = Math.round(data.dWindSpd * 3.6);
                                    last.dWeatherCode = view.GetWeatherCode(data.dWeatherCode);
                                    // DAY DATA - END

                                    if(last.date.date() >= view.$helpers.getMomentUTC().date() && !view.weather.data.find(d => d.date.date() === last.date.date()))
                                    {
                                        var hasDTemp = view.rawWeatherData.find(d => d.date.date() == last.date.date() && d.dTemp);
                                        if(hasDTemp) view.weather.data.push(hasDTemp);
                                        else view.weather.data.push(last);
                                    }
                                    //console.log(last.date.format('LLLL'));
                                    })(response.data[x]);

                    }
                }).catch(function (error) {
                    //TODO error handling
                })
            },

            GetWeatherCode(id){
                                switch (id){
                                    case 201: // thunderstorm with rain
                                    case 202: // thunderstorm with heavy rain
                                    case 211: // thunderstorm
                                    case 212: // heavy thunderstorm
                                    case 221: // ragged thunderstorm
                                    case 230: // thunderstorm with light drizzle
                                    case 231: // thunderstorm with drizzle
                                    case 232: // thunderstorm with heavy drizzle
                                    case 233: // thunderstorm with hail
                                        return "Thunderstorm_Rain";
                                        break;
                                    case 200: // thunderstorm with light rain
                                    case 210: // light thunderstorm
                                        return "Thunderstorm";
                                        break;


                                    case 300: // light intensity drizzle
                                    case 301: // drizzle
                                    case 302: // heavy intensity drizzle
                                    case 310: // light intensity drizzle rain
                                    case 311: // drizzle rain
                                    case 312: // heavy intensity drizzle rain
                                    case 313: // shower rain and drizzle
                                    case 314: // heavy shower rain and drizzle
                                    case 321: // shower drizzle
                                    case 520: // light intensity shower rain
                                    case 521: // shower rain
                                    case 522: // heavy intensity shower rain
                                    case 531: // ragged shower rain
                                        return "Rain_Medium";
                                        break;

                                    case 500: // light rain
                                    case 501: // moderate rain
                                    case 502: // heavy intensity rain
                                    case 503: // very heavy rain
                                    case 504: // extreme rain
                                        return "Sun_Rain";
                                        break;

                                    case 511: // freezing rain
                                        return "Snow_Rain";
                                        break;
                                    case 600: // light snow
                                    case 601: // Snow
                                    case 602: // Heavy snow
                                    case 610: // Mix snow/rain
                                    case 611: // Sleet
                                    case 612: // Light shower sleet
                                    case 613: // Shower sleet
                                    case 615: // Light rain and snow
                                    case 616: // Rain and snow
                                    case 620: // Light shower snow
                                    case 621: // Shower snow
                                    case 622: // Heavy shower snow
                                    case 623: // Flurries
                                        return "Snow_Medium";
                                        break;

                                    case 700: // mist
                                    case 701: // mist
                                    case 711: // Smoke
                                    case 721: // Haze
                                    case 731: // sand/ dust whirls
                                    case 741: // fog
                                    case 751: // sand
                                    case 761: // dust
                                    case 762: // volcanic ash
                                    case 771: // squalls
                                    case 781: // tornado
                                        return "Fog";
                                        break;
                                    case 800: // clear sky
                                        return "Sunny";
                                        break;
                                    case 801: // few clouds: 11-25%
                                        return "Little_Cloudy";
                                    case 802: // scattered clouds: 25-50%
                                        return "Cloudy_Medium";
                                    case 803: // broken clouds: 51-84%
                                    case 804: // overcast clouds: 85-100%
                                        return "Very_Cloudy";
                                        break;
                                    case 900: // Unknown Precipitation
                                        return "Warnung";
                                        break;
                                    default:
                                        return "Sunny";
                                            break;
                                }
            },

            OpenWeatherPopup($event, day, index){
                if(!this.rawWeatherData.find(d => d.date.date() === day.date())) return;
                this.$refs.weatherpopup.Init({
                    date: day,
                    data: this.rawWeatherData.slice(),
                    elRelative: $event.currentTarget,
                });
            },
            OpenBUVisibilityPopup($event){
                this.$refs.buvisibilitypopup.Init();
            },
            OpenFilterPopup($event){
                this.$refs.filterpopup.Init(this);
            },
            OpenSollistPopup($event , employee){
                this.$refs.sollistpopup.Init(this , employee, $event.currentTarget);
            },
            OpenBusinessUnitPopup($event){
                this.$refs.businessunitpopup.Init({
                    elRelative: $event.currentTarget,
                });
            },
            GetWeatherIcon(MMDD){
                var weather = this.GetWeatherFromDateFormat(MMDD);
                var weatherCode = 'Sunny';
                return 'img/' + weather.dWeatherCode + '.svg';

            },
            GetWeatherTemp(MMDD){
                var weather = this.GetWeatherFromDateFormat(MMDD);
                if(weather) return weather.dTemp;
                return '- ';

            },
            GetWeatherFromDateFormat(MMDD){
                var weather = this.rawWeatherData.find(d => d.date.format('MM-DD') === MMDD && d.dTemp && !isNaN(d.dTemp));
                return weather;

            },
            GetIndexWeekFromDate(date){
                if(!date) return -1;
                return date.week() - date.clone().date(0).week();
            },
            GetIndexDayFromDate(date){
                if(!date) return -1;
                return date.weekday() - 1;
            },
            EmployeeDataScroll(){
                $('.employee-data').css('left', (-1 * $('.app .scrollbar-container .grid').scrollLeft()) + 240 + 'px');
            },
            ShiftTimeBarsBack(){
                var view = this;
                if(this.dayModeHours < 24) {
                    this.dayModeDate = this.dayModeDate.clone().add('hours', this.dayModeHours * -1);
                } else {
                    this.dayModeDate = this.dayModeDate.clone().hours(0).add(-1, 'days');
                }
                
                if(this.dayModeAssignedFilter) {
                    var group = this.employeeGroups.find(g => !g.collapsed);
                    if(group){
                        group.employeesFiltered = group.employees.filter(e => view.HasShift(e, view.dayModeDate));
                        group.employeesFiltered.sort((a, b) => {
                                    var A = parseInt(window.roster.LowestShiftTimeDate(a, window.roster.dayModeDate).format('x'));
                                    var B = parseInt(window.roster.LowestShiftTimeDate(b, window.roster.dayModeDate).format('x'));
                                    return A - B;
                        });
                    }
                }
                for(var x in window.timebars){
                    (function(timebar){
                        if(!timebar.eventProp.relative)
                        {
                            timebar.day = view.dayModeDate.clone();
                            timebar.timeDisplayLengthInMilliseconds = view.dayModeHours * 1000 * 60 * 60;

                            requestAnimationFrame(function(){
                                timebar.Init(timebar.day);
                                requestAnimationFrame(function(){
                                    timebar.$forceUpdate();
                                });
                            });
                        }
                    })(window.timebars[x]);
                }
                this.UpdateTimebarLabels();
                this.$forceUpdate();
            },
            ShiftTimeBarsForwards(){
                var view = this;
                if(this.dayModeHours < 24) {
                    this.dayModeDate = this.dayModeDate.clone().add('hours', this.dayModeHours);
                } else {
                    this.dayModeDate = this.dayModeDate.clone().hours(0).add(1, 'days');
                }
                if(this.dayModeAssignedFilter) {
                    var group = this.employeeGroups.find(g => !g.collapsed);
                    if(group){
                        group.employeesFiltered = group.employees.filter(e => view.HasShift(e, view.dayModeDate));
                        group.employeesFiltered.sort(function(a, b) {
                                    var A = parseInt(window.roster.LowestShiftTimeDate(a, window.roster.dayModeDate).format('x'));
                                    var B = parseInt(window.roster.LowestShiftTimeDate(b, window.roster.dayModeDate).format('x'));
                                    return A - B;
                        });
                    }
                }
                for(var x in window.timebars){
                    (function(timebar){
                        if(!timebar.eventProp.relative)
                        {
                            timebar.day = view.dayModeDate.clone();
                            timebar.timeDisplayLengthInMilliseconds = view.dayModeHours * 1000 * 60 * 60;

                            requestAnimationFrame(function(){
                                timebar.Init(timebar.day);
                                requestAnimationFrame(function(){
                                    timebar.$forceUpdate();
                                });
                            });
                        }
                    })(window.timebars[x]);
                }
                this.UpdateTimebarLabels();
                this.$forceUpdate();
            },
            ChangeTimeBarLength(){
                var view = this;
                this.dayModeDate.hour(0);
                for(var x in window.timebars){
                    (function(timebar){
                        if(!timebar.eventProp.relative)
                        {
                            timebar.timeDisplayLengthInMilliseconds = view.dayModeHours * 1000 * 60 * 60;
                            requestAnimationFrame(function(){
                                timebar.Init();
                                requestAnimationFrame(function(){
                                    timebar.$forceUpdate();
                                });
                            });
                        }
                    })(window.timebars[x]);
                }
                this.UpdateTimebarLabels();
                this.$forceUpdate();
            },
            GetGridStyles(){
                var styles = {};
                return styles;
                if(this.dayMode)
                {
                    var nextDay = this.dayModeDate.clone().add(-1, 'day');
                    var weekNumber = nextDay.week() - nextDay.startOf('month').week();
                    if(weekNumber === 5) weekNumber = 0;
                    var left = 0 - (50 * (this.dayModeDate.date() + this.dateSelectionStart.weekday() - 2)) - weekNumber;
                    styles.left = (left).toString() + 'px';
                    styles.width = "calc(100vw - " + styles.left + " - 300px)";
                }

                return styles;
            },
            GetEmployeeStyles(){
                var styles = {};
                return styles;
                if(this.dayMode)
                {
                    var nextDay = this.dayModeDate.clone().add(-1, 'day');
                    var weekNumber = nextDay.week() - nextDay.startOf('month').week();
                    if(weekNumber === 5) weekNumber = 0;
                    var left = 0 + (50 * (this.dayModeDate.date() + this.dateSelectionStart.weekday() - 2)) + weekNumber;
                    styles.left = (left).toString() + 'px';
                }

                return styles;
            },
            GetTableStyles(){
                var styles = {};
                return styles;
                if(this.dayMode)
                {
                    var nextDay = this.dayModeDate.clone().add(-1, 'day');
                    var weekNumber = nextDay.week() - nextDay.startOf('month').week();
                    if(weekNumber === 5) weekNumber = 0;
                    var left = 200 + (50 * (this.dayModeDate.date() + this.dateSelectionStart.weekday() - 2)) + weekNumber;
                    styles.left = (left).toString() + 'px';
                }

                return styles;
            },
            IsToday(indexweek, index){
                var date = this.dateSelectionStart.clone().add((parseInt(indexweek - 1) * 7) + parseInt(index - 1) - this.dateSelectionStart.weekday() + 1, 'day');
                return (this.$helpers.getMomentUTC().date() === date.date());
            },
            FilterSpot(spotId,option){
                var spot = this.$refs.spotSearch.searchbar.items.find(i => i.id === spotId);

                if(this.dragging){
                    let index = this.dynamicSkillsFiltered.indexOf(spot.requiredSkill);
                    if(option){
                        //drag start -> add
                        if (index === -1){
                            this.dynamicSkillsFiltered.push(spot.requiredSkill);
                        }
                    }else{
                        //drag end -> remove
                        if (index !== -1){
                            this.dynamicSkillsFiltered.splice(index, 1);
                        }
                    }
                }else{
                    let index = this.dynamicSkillsFiltered.indexOf(spot.requiredSkill);
                    if (index === -1){
                        this.dynamicSkillsFiltered.push(spot.requiredSkill);
                    }else{
                         this.dynamicSkillsFiltered.splice(index, 1);
                    }
                }
                this.filterEmployees();
                this.$forceUpdate();

                var view = this;
                if(spot && spot.requiredSkill)
                {
                    //this.employeesFiltered = view.employees.filter(e => view.employeeMap[e.id].skills && view.employeeMap[e.id].skills.find(s => s.skillId === spot.requiredSkill));
                    this.$refs.spotSearch.searchbar.input = this.$refs.spotSearch.input = spot.label;
                    this.$forceUpdate();
                }
            },
            ToggleDayMode(indexweek, index, toggle){
                
                if($(window.mouse.element).closest('.income').length > 0) return;
                if($(window.mouse.element).closest('.weather').length > 0) return;
                if(this.$refs.incomepopup){
                    this.$refs.incomepopup.toggled = false;
                }
                var view = this;
                if(this.shiftTemplateView){
                    view.PopulateUnitGroups(!view.shiftTemplateView);
                    requestAnimationFrame(function(){
                        view.ToggleDayMode(indexweek, index, toggle)
                    });
                    return;
                }
                if(!indexweek){
                    this.dayMode = false;
                    var group = this.employeeGroups.find(g => !g.collapsed);
                    //if(group) group.employeesFiltered = group.employees.slice();
                    requestAnimationFrame(function(){ view.$forceUpdate() });
                    return;
                }
                let tempDate = this.gridWeekInfo['w'+indexweek]['e'+index].date.clone().minutes(0).seconds(0);
                //if((this.dayMode && tempDate.format('YYYY-MM-DD') === this.dayModeDate.format('YYYY-MM-DD')) || !this.dayMode){
                    if(toggle) this.dayMode = toggle;
                    else this.dayMode = !this.dayMode;
                    requestAnimationFrame(function(){ view.$forceUpdate() });
                /*} else {

                }*/
                if(!this.dayMode){
                    var group = this.employeeGroups.find(g => !g.collapsed);
                    //if(group) group.employeesFiltered = group.employees.slice();
                    requestAnimationFrame(function(){ view.$forceUpdate() });
                    return;
                }
                var view = this;
                this.dayModeDate = tempDate;
                
                //this.UpdateTimeTableBorders();
                this.employeesFiltered.sort((a, b) => { return a.dayModeClasses < b.dayModeClasses ? -1 : +1});
                var group = this.employeeGroups.find(g => !g.collapsed);
                
                this.loadStoreSalesDaily(this.dayModeDate).then(response => {
                                view.storeSalesDaily = response.data;
                                view.storeSalesDaily.forEach(s => s.dateMoment = this.$helpers.getMomentFromStringUTC(s.from, 'YYYY-MM-DDTHH:mmZ'));
                                view.$forceUpdate();
                            }).catch(function (error) {
                            })
                    requestAnimationFrame(function(){
                        view.$forceUpdate();
                    });
                

            },
            UpdateTimeTableBorders(shifts){
                var shiftsTemp = shifts ? shifts : this.dayModeShifts;
                var groups = this.employeeGroups.filter(g => !g.collapsed);
                for(var x in groups){
                    var group = groups[x];
                    for(var e in group.employees)
                    {
                        if(shiftsTemp.length !== 0) group.employees[e].dayModeClasses = this.GetDayAvailabilityRelativeToShifts(group.employees[e], this.dayModeDate, shiftsTemp);
                        else group.employees[e].dayModeClasses = ''; //this.GetDayAvailabilityType(group.employees[e], this.dayModeDate);
                    }
                }
                this.$forceUpdate();
            },
            GetDayUnassignedShifts(indexweek, index){
                let entry = this.gridWeekInfo['w'+indexweek]['e'+index];
                if(entry){
                    var day = entry.date;
                    return Object.values(this.planShiftMap).filter(s => (!s.employeeId || s.employeeId === '') && day.format('YYYY-MM-DD') === s.fromDate.format('YYYY-MM-DD'));
                } else {
                    return [];
                }
                
            },

            GetTimeBarProp(employee, dateStart, relative, startTime)
            {
                var date = dateStart.clone();
                var eventProp = {
                    day: dateStart.clone(),
                    employee: employee,
                    relative: relative,
                    timeDisplayLengthInMilliseconds: 24 * 1000 * 3600,
                    shiftTemplateEntry: employee.shiftTemplateEntry,
                    shiftTemplate: employee.shiftTemplate,
                    shiftTemplateUnassigned: employee.shiftTemplateUnassigned,
                };

                return eventProp;
            },
            GetTimeBarShiftProp(dateStart, shift)
            {
                
                var date = dateStart.clone();
                var eventProp = {
                    hideBar: true,
                    rota: {show: false, id: null, start: date.format('x'), startDate: date, end: date.clone().add(8, 'hours').format('x'), endDate: date.clone().add(8, 'hours')},
                    workHours: {id: -1, start: date.clone().add(-2, 'hours').format('x'), startDate: date.clone().add(-2, 'hours'), end: date.clone().add(12, 'hours').format('x'), endDate: date.clone().add(12, 'hours')},
                    //desired: {id: -1, start: date.clone().add(0, 'hours').format('x'), startDate: date.clone().add(0, 'hours'), end: date.clone().add(8, 'hours').format('x'), endDate: date.clone().add(8, 'hours')},
                    shifts: [],
                    timeFrames: [],
                    info: [],
                    errors: [],
                    warnings: [],
                    relative: true,
                    day: dateStart.clone(),
                    isShift: true,
                };
                if(shift)
                {
                    eventProp.timeFrames = [{classes: 'shift', show: shift, id: -1, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate, shift: shift}];
                    eventProp.rota = {show: shift, id: null, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate};
                    eventProp.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    eventProp.info.push({label: 'Skill:', data: shift.spotId ? this.spotMap[shift.spotId].unitName : '', half: true});
                    eventProp.info.push({label: 'Spot:', data: shift.spotId ? this.spotMap[shift.spotId].name : '', half: true});
                    eventProp.day = shift.fromDate.clone().hours(0).minutes(0);
                }
                return eventProp;
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            GetDayAvailability(employee, dayOfWeek)
            {
                if(!this.employeeMap[employee.id] || !this.employeeMap[employee.id].availability) return false;
                var available = this.employeeMap[employee.id].availability[2];
                var unavailable = this.employeeMap[employee.id].availability[1];
                var result = false;
                if(available && available.weekDays.find(w => w === dayOfWeek)) result = true;
                if(unavailable && !unavailable.weekDays.find(w => w === dayOfWeek)) result = true;
                return result;
            },
            HasSkill(employee, skill)
            {
                return skill && this.employeeMap[employee.id] && this.employeeMap[employee.id].skills && this.employeeMap[employee.id].skills.length > 0 && this.employeeMap[employee.id].skills.find(s => s.skillId === skill.id)
            },
            HasHoliday(employee, date){
                //ToDo : Maybe make this method faster, by precomputing the holiday days. and access a map here
                let view = this;
                if(!employee) return false;
                let start = date.clone().format();
                let end = date.clone().add(1,'day').format();
                let startM = moment(start);
                let endM = moment(end);
                for (let j in view.employeePreferenceMap) {
                    let x = view.employeePreferenceMap[j];
                    if(x.type == 1){ // 1 = Urlaub , 2 = Krankenstand
                        if(x.employeeId == employee.id){
                            let xStartM = moment(x.from);
                            let xEndM = moment(x.to);
                            if(xStartM.unix() <= startM.unix() && xEndM.unix() >= endM.unix()){
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            HasSickness(employee, date){
                //ToDo : Maybe make this method faster, by precomputing the sickness days. and access a map here
                //ToDo : You can combine "HasHoliday & HasSickness" the only difference is the "type"
                let view = this;
                if(!employee) return false;
                let start = date.clone().format();
                let end = date.clone().add(1,'day').format();
                let startM = moment(start);
                let endM = moment(end);
                for (let j in view.employeePreferenceMap) {
                    let x = view.employeePreferenceMap[j];
                    if(x.type == 2){ // 1 = Urlaub , 2 = Krankenstand
                        if(x.employeeId == employee.id){
                            let xStartM = moment(x.from);
                            let xEndM = moment(x.to);
                            if(xStartM.unix() <= startM.unix() && xEndM.unix() >= endM.unix()){
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            HasShift(employee, date)
            {
                if(!employee) return null;
                var shiftInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')][0] : null;
                return shiftInDay;
            },
            HighestShiftTime(employee, date)
            {
                if(!employee) return null;
                var shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    var max = shiftsInDay.reduce(function(prev, current) {
                        if (parseInt(current.toDate.format('x'))> parseInt(prev.toDate.format('x'))) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.toDate.format('HH') + ':' + max.toDate.format('mm');
                }
                return '';
            },
            LowestShiftTime(employee, date)
            {
                if(!employee) return null;
                var shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    var max = shiftsInDay.reduce(function(prev, current) {
                        if (parseInt(current.fromDate.format('x'))< parseInt(prev.fromDate.format('x'))) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.fromDate.format('HH') + ':' + max.fromDate.format('mm');
                }
                return '';
            },
            LowestShiftTimeDate(employee, date)
            {
                if(!employee) return moment(0, 'x');
                var shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    var max = shiftsInDay.reduce(function(prev, current) {
                        if (parseInt(current.fromDate.format('x'))< parseInt(prev.fromDate.format('x'))) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.fromDate.clone();
                }
                return moment(0, 'x');
            },
            GetShiftsInDay(employee, date)
            {
                if(!employee) return null;
                var shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay) shiftsInDay = shiftsInDay.slice();
                return shiftsInDay;
            },
            CheckShiftAvailabilityOverlap(employee, date, state, shifts)
            {
                if(!employee || !employee.id || employee.id === '') return false;
                var view = this;
                var employeeMapped = this.employeeMap[employee.id];
                var shiftsInDay = shifts ? shifts : this.GetShiftsInDay(employee, date);
                var preferenceInDay = employeeMapped.preferencesDate ? employeeMapped.preferencesDate[date.format('YYYY-MM-DD')] : null;
                //if(preferenceInDay && preferenceInDay.overrideContract) return false;
                var specificPreference = false;
                if(shiftsInDay && preferenceInDay)
                {
                    if(shiftsInDay.find(s => preferenceInDay.find(p => p.state === state && view.CheckTimeFrameIntersect(s.fromDate, s.toDate, p.fromDate, p.toDate)))) specificPreference = true;
                }
                var generalAvailability = false;
                var dayOfWeek = date.weekday();
                if(shiftsInDay && employeeMapped.availability && employeeMapped.availability[state] && employeeMapped.availability[state].weekDays.find(w => w === dayOfWeek))
                {
                    var availability = employeeMapped.availability[state];
                    var fromDate = date.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]);
                    var toDate = date.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1]);
                    if(shiftsInDay.find(s => view.CheckTimeFrameIntersect(s.fromDate, s.toDate, fromDate, toDate))) generalAvailability = true;
                }
                return specificPreference || generalAvailability;
            },
            CheckShiftOverlap(employee, date, shifts)
            {
                if(!employee || !employee.id || employee.id === '') return false;
                var view = this;
                var employeeMapped = this.employeeMap[employee.id];
                var shiftsInDay = shifts ? shifts : this.GetShiftsInDay(employee, date);
                if(!shiftsInDay || shiftsInDay.length < 2) return false;

                var shiftFirst = shiftsInDay[0];
                var shiftsRest = shiftsInDay.slice(1);
                if(shiftsRest.find(s => view.CheckTimeFrameIntersect(shiftFirst.fromDate, shiftFirst.toDate, s.fromDate, s.toDate))) return true;
                return false;
            },
            CheckShiftAvailabilityEncapsulate(employee, date, type, shifts)
            {
                if(!employee || !employee.id || employee.id === '') return false;
                var view = this;
                var employeeMapped = this.employeeMap[employee.id];
                var shiftsInDay = shifts ? shifts : this.GetShiftsInDay(employee, date);
                var preferenceInDay = employeeMapped.preferencesDate ? employeeMapped.preferencesDate[date.format('YYYY-MM-DD')] : null;
                //if(preferenceInDay && preferenceInDay.overrideContract) return false;
                var specificPreference = false;
                if(shiftsInDay && preferenceInDay)
                {
                    if(shiftsInDay.find(s => preferenceInDay.find(p => p.type === type && view.CheckTimeFrameEncapsulated(s.fromDate, s.toDate, p.fromDate, p.toDate)))) specificPreference = true;
                }
                var generalAvailability = false;
                var dayOfWeek = date.weekday();
                if(shiftsInDay && employeeMapped.availability && employeeMapped.availability[type] && employeeMapped.availability[type].weekDays.find(w => w === dayOfWeek))
                {
                    var availability = employeeMapped.availability[type];
                    var fromDate = date.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]);
                    var toDate = date.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1]);
                    if(shiftsInDay.find(s => view.CheckTimeFrameEncapsulated(s.fromDate, s.toDate, fromDate, toDate))) generalAvailability = true;
                }
                return specificPreference || generalAvailability;
            },
            CheckTimeFrameIntersect(startA, endA, startB, endB)
            {
                return (parseInt(startA.format('x')) < parseInt(endB.format('x'))) && (parseInt(startB.format('x')) < parseInt(endA.format('x')));
            },
            CheckTimeFrameEncapsulated(startInner, endInner, startOuter, endOuter)
            {
                return (parseInt(startInner.format('x')) > parseInt(startOuter.format('x'))) && (parseInt(endInner.format('x')) < parseInt(endOuter.format('x')));
            },
            GetDayAvailabilityType(employee, date)
            {
                if(!employee || !employee.id || employee.id === '') return '';
                var dayOfWeek = date.weekday();
                var shiftInDay = this.HasShift(employee, date);
                if(this.CheckShiftAvailabilityOverlap(employee, date, 1)) return 'border-red shift-in-unavailable ';
                if(this.CheckShiftOverlap(employee, date)) return 'border-red shifts-collide ';
                if(shiftInDay && !this.HasSkill(employee, this.skillMap[this.spotMap[shiftInDay.spotId].requiredSkill])) return 'border-red skill-missing ';
                var result = ' ';
                if(this.CheckShiftAvailabilityOverlap(employee, date, 3)) return 'border-yellow shift-in-undesired ';
                if(this.CheckShiftAvailabilityEncapsulate(employee, date, 4)) return 'border-green shift-in-desired ';
                return result;
            },
            GetDayAvailabilityRelativeToShifts(employee, date, shifts)
            {
                var dayOfWeek = date.weekday();
                if(this.CheckShiftAvailabilityOverlap(employee, date, 1, shifts)) return 'border-red shift-in-unavailable ';
                if(shifts && shifts.length > 0 && !this.HasSkill(employee, this.skillMap[this.spotMap[shifts[0].spotId].requiredSkill])) return 'border-red skill-missing ';
                var tempShifts = this.GetShiftsInDay(employee, date);
                if(shifts)
                {
                    if(!tempShifts)
                    {
                        tempShifts = shifts.slice();
                    }
                    else
                    {
                        for(var x in shifts)
                        {
                            var shiftTemp = shifts[x];
                            if(!tempShifts.find(s => s === shiftTemp)) tempShifts.push(shiftTemp);
                        }
                    }
                }
                if(this.CheckShiftOverlap(employee, date, tempShifts)) return 'border-red shifts-collide ';
                var result = ' ';
                if(this.CheckShiftAvailabilityOverlap(employee, date, 3, shifts)) return 'border-yellow shift-in-undesired ';
                if(this.CheckShiftAvailabilityEncapsulate(employee, date, 4, shifts)) return 'border-green shift-in-desired ';
                return result;
            },
        refresh() {
            if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined 
                && this.$store.state.rosterFromTo != null  && this.$store.state.rosterFromTo.from != null && this.$store.state.rosterFromTo.to != null) {
                let view = this;
                this.storeSales = {};
                this.shiftTemplateMap = {};
                this.shiftTemplates = [];
                this.shiftTemplateSkillMap = {};
                if(this.$refs.incomepopup){
                    this.$refs.incomepopup.toggled = false;
                }
                this.dayMode = false;
                this.employeeGroups = [];
                this.GetWeather();
                this.loading = true;
                
                this.loadStoreSettings()
                .then(response => {
                    view.updateStoreSettings(response.data);
                    return  view.loadUserUnitSort()
                })
                .then(response => {
                    view.updateUserUnitSort(response.data);
                    return  view.loadHolidays()
                })
                .then(response => {
                    view.updateHolidays(response.data);
                    return  view.loadBusinessUnits()
                }).then(response => {
                    view.updateBusinessUnits(response.data);
                    return view.loadSpots();
                }).then(response => {
                    view.updateSpots(response.data);
                    return view.loadSkills();
                }).then(response => {
                    view.updateSkills(response.data);
                    return view.loadEmployeeTypes();  
                }).then(response => {
                    view.updateEmployeeTypes(response.data);
                    return view.loadEmployeeRules();
                }).then(response => {
                    view.updateEmployeeRules(response.data);
                    return view.loadShiftTemplateGroups();
                }).then(response => {
                    view.updateShiftTemplateGroups(response.data);
                    let groupPayload = {ids: []};
                    for(let i = 0; i < response.data.length; i++){
                        groupPayload.ids.push(response.data[i].id);
                    }
                    return view.loadShiftTemplates(groupPayload);
                }).then(response => {
                    view.updateShiftTemplates(response.data);
                    let templatePayload = {ids: []};
                    for(let i = 0; i < response.data.length; i++){
                        templatePayload.ids.push(response.data[i].id);
                    }
                    return view.loadShiftTemplateSkills(templatePayload);
                }).then(response => {
                    view.updateShiftTemplateSkills(response.data);
                    return view.loadActiveEmployees(); 
                }).then(response => {
                    let employeePayload = {ids: []};
                    for (let i = 0; i < response.data.length; i++) {
                        employeePayload.ids.push(response.data[i].id);
                    }
                    view.updateEmployees(response.data);

                    return view.loadEmployeeAvailabilities(employeePayload)
                    .then(response => {
                        view.updateEmployeeAvailabilities(response.data);
                        return view.loadEmployeeSkills(employeePayload)
                    }).then(response => {
                        view.updateEmployeeSkills(response.data);
                        return view.loadEmployeePreferences(employeePayload);
                    }).then(response => {
                        view.updateEmployeePreferences(response.data);
                        return view.loadEmployeeContracts(employeePayload);
                    }).then(response=> {
                        view.updateEmployeeContracts(response.data);
                        return view.loadEmployeeWorkBalances(employeePayload);
                    }).then(response => {
                        view.updateEmployeeWorkBalances(response.data);
                        return view.loadShifts()
                    }).then(response => {
                        let shiftPayload = {ids: []};
                        for (let i = 0; i < response.data.length; i++) {
                            shiftPayload.ids.push(response.data[i].id);
                        }
                        view.updateShifts(response.data); 
                        return view.loadShiftChanges(shiftPayload)
                        .then(response => {
                            view.updateShiftChanges(response.data);
                            return view.loadShiftSkills(shiftPayload);
                        }).then(response => {
                            view.updateShiftSkills(response.data);
                            view.sortSpotMap();
                            view.sortEmployeeGroups();
                            view.loading = false;
                        })
                    })
                }).catch(function (error) {
                    console.log(error)
                })
                this.RefreshStoreSales();
            }
        
        
    },
    loadStoreSettings : function() {
      
        let url = '/api/sec/storesettings';
        let params = {
            storeId: this.$store.state.storeId,
            id: this.$store.state.storeId,
        };
        
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
        
        
    },
    updateStoreSettings: function(data){
        
        this.storeSettings = data;
    },
    loadShiftTemplateGroups() {

        let url = '/api/sec/shifttemplategroup';

        let params = {
            storeId: this.$store.state.storeId,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },
    loadShiftTemplateSkills : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shifttemplateskillrequirement/any/template';

            let params = {
                storeId: this.$store.state.storeId,
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }
        


    },

    updateShiftTemplateSkills: function(data){

        let map = {};
        
        for (let i = 0; i < data.length; i++) {
            map[data[i].id] = data[i];
            if(this.shiftTemplateMap[data[i].templateId] != undefined){
                if(this.shiftTemplateMap[data[i].templateId].requiredSkills == undefined){
                    this.shiftTemplateMap[data[i].templateId].requiredSkills = []
                }
                this.shiftTemplateMap[data[i].templateId].requiredSkills.push(data[i].id);
            }
        }
        this.shiftTemplateSkillMap = map;
    },
    loadShiftTemplates : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shifttemplate/any/group';

            let params = {
                storeId: this.$store.state.storeId,
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }
        


    },
    updateShiftTemplateGroups : function(data){
        let map = {};
        for (let i = 0; i < data.length; i++) {
            map[data[i].id] = data[i];
        }
        this.shiftTemplateGroupMap = map;
    },
    updateShiftTemplates : function(data){
        var view = this;
        let overviewA = [];
        let map = {};
        
        for (let i = 0; i < data.length; i++) {

            
            map[data[i].id] = data[i];
            let shiftTemplateItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                regularOnly: data[i].regularOnly,
                holidayOnly: data[i].holidayOnly,
                weekDays: data[i].weekDays,
                yearDays: data[i].yearDays,
                count: data[i].count
            }
            
            if(!this.shiftTemplateGroupMap[data[i].groupId].templates) this.shiftTemplateGroupMap[data[i].groupId].templates = [];
            this.shiftTemplateGroupMap[data[i].groupId].templates.push(shiftTemplateItem);


            if(!this.$helpers.isBlank(data[i].spotId)){
                shiftTemplateItem.spot = this.spotMap[data[i].spotId].name;
                shiftTemplateItem.spotId = data[i].spotId;
            } else {
                shiftTemplateItem.spot = "";
            }
            overviewA.push(shiftTemplateItem);
        }
        this.shiftTemplates = overviewA;
        this.shiftTemplateMap = map;
    },
    updateEmployeePreferences: function(data) {
        let overviewA = [];
        let tEmployeePreferenceMap = {}
        var i;
        for (i = 0; i < data.length; i++) {
            tEmployeePreferenceMap[data[i].id] = data[i];
            let employeePreferenceItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                factor: data[i].factor,
                approved: data[i].approved,
                type: data[i].type,
                state: data[i].state,
                workValue: data[i].workValue,
            }
            data[i].fromDate = moment(data[i].from.split('T')[0], 'YYYY-MM-DD');
            data[i].fromHours = parseInt(data[i].from.split('T')[1].split(':')[0]);
            data[i].fromMinutes = parseInt(data[i].from.split('T')[1].split(':')[1]);
            data[i].toDate = moment(data[i].to.split('T')[0], 'YYYY-MM-DD');
            data[i].toHours = parseInt(data[i].to.split('T')[1].split(':')[0]);
            data[i].toMinutes = parseInt(data[i].to.split('T')[1].split(':')[1]);
            if(!this.$helpers.isBlank(data[i].employeeId)){
                employeePreferenceItem.employee = this.employeeMap[data[i].employeeId];
                if(!this.employeeMap[data[i].employeeId].preferences) this.employeeMap[data[i].employeeId].preferences = [];
                if(!this.employeeMap[data[i].employeeId].preferencesDate) this.employeeMap[data[i].employeeId].preferencesDate = {};
                this.employeeMap[data[i].employeeId].preferences.push(data[i]);
                var daysDiff = data[i].toDate.diff(data[i].fromDate, 'days') + 1;
                var tempDate = data[i].fromDate.clone();
                for(var x = 0; x < daysDiff; x++)
                {
                    if(!this.employeeMap[data[i].employeeId].preferencesDate[tempDate.format('YYYY-MM-DD')]) this.employeeMap[data[i].employeeId].preferencesDate[tempDate.format('YYYY-MM-DD')] = [];
                    var preferenceTemp = {
                                             preference: data[i],
                                             fromHours: data[i].fromHours,
                                             fromMinutes: data[i].fromMinutes,
                                             toHours: data[i].toHours,
                                             toMinutes: data[i].toMinutes,
                                             factor: data[i].factor,
                                             overrideContract: data[i].overrideContract,
                                             approved: data[i].approved,
                                             type: data[i].type,
                                             state: data[i].state,
                                             workValue:  data[i].workValue,
                                             date: tempDate.clone().hours(0).minutes(0),
                                             fromDate: tempDate.clone().hours(data[i].fromHours).minutes(data[i].fromMinutes),
                                             toDate: tempDate.clone().hours(data[i].toHours).minutes(data[i].toMinutes),
                                         };
                    this.employeeMap[data[i].employeeId].preferencesDate[tempDate.format('YYYY-MM-DD')].push(preferenceTemp);
                    tempDate.add(1, 'days');
                }
            } else {
                employeePreferenceItem.employee = "";
            }
            if(!this.$helpers.isBlank(data[i].spotId)){
                employeePreferenceItem.spot = this.spotMap[data[i].spotId].name;
            } else {
                employeePreferenceItem.spot = "";
            }
            overviewA.push(employeePreferenceItem);
        }
        this.employeePreferenceMap = tEmployeePreferenceMap
        this.employeepreferences = overviewA;
    },
    updateEmployeeContracts: function(data){
        var i;
        let tcontracts = {}
        for (i = 0; i < data.length; i++) {


            tcontracts[data[i].id] =data[i];
        }
        this.employeeContractMap = tcontracts;
    },
    updateEmployeeAvailabilities: function(data){
        var i;
        let tavailabilities = {}
        for (i = 0; i < data.length; i++) {
            tavailabilities[data[i].id] =data[i];
            var employee = this.employeeMap[data[i].employeeId];
            if(employee)
            {
                if(!employee.availability) employee.availability  = {};
                employee.availability[data[i].state] = data[i];
            }
        }
        var availabilities = Object.values(this.employeeMap).filter(e => e.availability);
        for(var x in availabilities)
        {
            var availability = availabilities[x].availability;
            
        }
        this.employeeAvailabilityMap = tavailabilities;
    },
    updateSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.skillMap = tskills;
    },
    UpdateTimebarLabels(){
        clearTimeout(window.timebarLabelUpdateInterval);
        window.timebarLabelUpdateInterval = setInterval(function(){
            if(window.timebars) window.timebars.forEach(t => t.AdjustTimeFrameLabelsInbounds());
        }, 100);
        setTimeout(function(){clearTimeout(window.timebarLabelUpdateInterval);}, 1000)
    },
    PopulateGroups(){

        this.selectedUnit = units[0];
        this.businessGroupsBefore = this.businessGroups.filter(b => view.businessGroups.indexOf(b) < view.businessGroups.indexOf(view.selectedUnit));
        this.businessGroupsAfter = this.businessGroups.filter(b => view.businessGroups.indexOf(b) > view.businessGroups.indexOf(view.selectedUnit));
    },
    SelectUnitSort(unitGroup){
        /*
        var view = this;
        var lastCollapse = unitGroup.collapsed;
        this.businessGroups.forEach(b => b.collapsed = true);
        unitGroup.collapsed = !lastCollapse;
        if(unitGroup.collapsed){
            //this.employeeGroups = [];
            return;
        }
        $('.unit.group.business').each(function(i, e){
            $(this).css('margin-top', '');
            if(i + 1 === view.businessGroups.indexOf(view.selectedUnit)) $(this).css('margin-top', '25px');

        });
        this.selectedUnit = unitGroup;
        var unit = unitGroup.unit;
        this.businessGroupsBefore = this.businessGroups.filter(b => view.businessGroups.indexOf(b) <= view.businessGroups.indexOf(view.selectedUnit));
        this.businessGroupsAfter = this.businessGroups.filter(b => view.businessGroups.indexOf(b) > view.businessGroups.indexOf(view.selectedUnit));
        var spots = Object.values(view.spotMap);
        if(view.selectedUnit.unit){
            spots = spots.filter(s => s.unitName === view.selectedUnit.unit.name);
        } else {
            this.businessGroups.forEach(b => b.collapsed = true);
            var all = this.businessGroups.find(b => b.label === 'All');
            if(all) all.collapsed = false;
        }
        //this.employeeGroups = [];
        for(var x in spots)
        {
            var spot = spots[x]
            var group = {};
            group.label = spot.name;
            group.spot = spot;
            //group.collapsed = (spot.name !== 'All');
            group.collapsed = true;
            group.employees = spot.requiredSkill && spot.requiredSkill !== '' ? view.employees.filter(e => view.employeeMap[e.id].skills && view.employeeMap[e.id].skills.find(s => s.skillId === spot.requiredSkill)) : this.employees.slice();
            group.employeesFiltered = group.employees.slice();
            this.employeeGroups.push(group);
        }*/
    },
    updateEmployeeSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            if(!this.skillMap[data[i].skillId]){
                console.log('unloaded employee skills');
                setTimeout(this.updateEmployeeSkills, 500);
                return;
            }
            data[i].name = this.skillMap[data[i].skillId].name;
            tskills[data[i].id] = data[i];
            var employee = this.employeeMap[data[i].employeeId];
            if(employee)
            {
                if(!employee.skills) employee.skills = [];
                employee.skills.push(data[i]);
            }
        }
        this.employeeSkillMap = tskills;
        //this.employeeGroups = [];
        this.businessGroups = [];
        this.businessGroups.push({label: 'All', unit: null, collapsed: false});
        var units = Object.values(this.businessunitMap);
        var view = this;
        for(var x in units)
        {
            (function(unit){
                view.businessGroups.push({label: unit.name, unit: unit, collapsed: true});
            })(units[x]);

        }/*
        this.selectedUnit = units[0];
        this.businessGroupsBefore = this.businessGroups.filter(b => view.businessGroups.indexOf(b) < view.businessGroups.indexOf(view.selectedUnit));
        this.businessGroupsAfter = this.businessGroups.filter(b => view.businessGroups.indexOf(b) > view.businessGroups.indexOf(view.selectedUnit));*/
        var spots = Object.values(view.spotMap);
        spots.unshift({name: 'All'});
        for(var x in spots)
        {
            var spot = spots[x]
            var group = {};
            group.label = spot.name;
            group.spot = spot;
            //group.collapsed = (spot.name !== 'All');
            group.collapsed = true;
            group.employees = spot.requiredSkill && spot.requiredSkill !== '' ? view.employees.filter(e => view.employeeMap[e.id].skills && view.employeeMap[e.id].skills.find(s => s.skillId === spot.requiredSkill)) : this.employees.slice();
            group.employeesFiltered = group.employees.slice();
            //this.employeeGroups.push(group);
        }


        $('.searchbar.employee-sort input').val('Skill');
        
        //this.SelectUnitSort(this.businessGroups[0]);
        setTimeout(function(){
            var index = 0;
            var indexTotal = 0;
            $('.grid.preload .entry:not(.header)').each(function(i, e){
                var elentry = $(this);
                var indexinner = 0;
                $(this).find('.day').each(function(i, e){
                    var el = $(this);
                    setTimeout(function(){el.addClass('fade-out');}, (10 * index) + (indexinner * 20));
                    indexinner++;
                });
                index++;
            });
        setTimeout(function(){
            if(view.employeeGroups.length > 0) view.employeeGroups[0].collapsed = false;
            setTimeout(function(){
                $('.grid.preload').remove();
            }, 200);
        }, ($('.grid.preload .entry:not(.header)').length * 10) + (10 * 20));

        }, 100);
    },
    updateEmployeeTypes: function(data){
        var i;
        let ttypes = {}
        for (i = 0; i < data.length; i++) {
            ttypes[data[i].id] =data[i];
        }
        this.employeeTypeMap = ttypes;
    },
    updateSpots: function(data){
        var i;
        let tspots = {}
        for (i = 0; i < data.length; i++) {
            let priority = 0;
            let tmp = this.userunitsort.filter(x => (x.unitId === data[i].id));
            if(tmp != undefined && tmp.length > 0){
                priority = tmp[0].priority;
            }
            tspots[data[i].id] =data[i];

            //Each spot has a required business unit, since we drop spots to employeeGroups, we add the businessUnit now to the spot
            for(var j in this.businessunitMap){
                if(data[i].unitId == this.businessunitMap[j].id){
                    tspots[data[i].id].bunit = this.businessunitMap[j];
                }
            }


            tspots[data[i].id].toggled = false;
            tspots[data[i].id].priority = priority;
            data[i].label = data[i].name
        }
        this.spotMap = tspots;

        data.push({name: 'All', label:'All'});
        var view = this;
        var spots = Object.values(view.spotMap);
        spots.push({name: 'All', label:'All'});
        //if(item.label !== 'All') spots.filter(s => s.unitName === item.label);
        view.spots = {
            toggled: false,
            displayedItems: [],
            input: 'All',
            items: spots,
            onceSelected: function ($event, item, searchbar){
                if(item.label === 'All')
                {
                    var selectedUnit = $('.searchbar.unit input').val();
                    if(selectedUnit === 'All')
                        view.employeesFiltered = view.employees.slice();
                    else
                        view.employeesFiltered = view.employees.filter(e => (view.employeeMap[e.id].skills && view.employeeMap[e.id].skills.find(s => s.name === selectedUnit)) || (view.employeeMap[e.id] && view.employeeMap[e.id].shifts && view.employeeMap[e.id].shifts.find(s => s.spotId)));

                }
                else
                {
                    view.employeesFiltered = view.employees.filter(e => (view.employeeMap[e.id].skills && view.employeeMap[e.id].skills.find(s => s.skillId === item.requiredSkill)) || (view.employeeMap[e.id] && view.employeeMap[e.id].shifts && view.employeeMap[e.id].shifts.find(s => s.spotId && s.spotId === item.id)));
                }
                view.$forceUpdate();
            }
        }
        var view = this;
    },
    updateSkills: function(data){
        let skills = [];
        let tskills = {}
        for (let i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
            skills.push(data[i]);
        }
        this.skillMap = tskills;

        let spots = [];
        for(var x in this.spotMap){
            spots.push(this.spotMap[x]);
        }

        this.softSkills = skills.filter(item => (spots.find(x => x.requiredSkill === item.id) === undefined));
        for (let i = 0; i < this.softSkills.length; i++) {
            this.softSkills[i].toggled = false;
        }

    },

    ShiftInDayIsPublished(employee){
        if(!employee || employee.shiftTemplateEntry) return false;
        var shifts = this.GetShiftsInDay(employee, this.dayModeDate);
        if(!shifts || shifts.length === 0) return false;
        return shifts.filter(s => s.published).length > 0;
    },
    SelectEmployeeForTemplate($event, shiftTemplate){
            var target = $event.currentTarget;
            var view = this;
            this.$refs.userselect.Init({
                elRelative: target,
                items: Object.values(window.roster.employeeMap),
                callbackEnd: function(employee){
                    var shift = {
                        from: view.dayModeDate.clone().hours(shiftTemplate.from.split(':')[0]).minutes(shiftTemplate.from.split(':')[1]),
                        to: view.dayModeDate.clone().hours(shiftTemplate.to.split(':')[0]).minutes(shiftTemplate.to.split(':')[1]),
                        templateId: shiftTemplate.id,
                        spotId: shiftTemplate.spotId,
                        historicFrom: view.dayModeDate.clone().hours(shiftTemplate.from.split(':')[0]).minutes(shiftTemplate.from.split(':')[1]),
                        historicTo: view.dayModeDate.clone().hours(shiftTemplate.to.split(':')[0]).minutes(shiftTemplate.to.split(':')[1]),
                        historicSpotId: shiftTemplate.spotId,
                        employeeId: employee && employee.id ? employee.id : null,
                    };
                    
                    view.CreateShift(shift);
                },
                filterItems:  Object.values(window.roster.spotMap),
                shift: view.shift,
                filterMap: function(items, item)
                {
                    return items.filter(e => (e.skills && e.skills.find(s => s.skillId === item.requiredSkill)) || (e.shifts && e.shifts.find(s => s.spotId && s.spotId === item.id)));
                },
                displayMap: function(item){ return item.firstName + ' ' + item.lastName },
            });
    },
    SwitchTemplateDay(){
        this.PopulateUnitGroups(true);
    },
    PopulateUnitGroups(isShiftTemplate){
        var view = this;
        this.shiftsSelected = [];
        this.shiftTemplateView = isShiftTemplate;
        if(!isShiftTemplate) {

            this.employeeGroups = [];
            requestAnimationFrame(function(){
                view.sortEmployeeGroups();
            });
            return;
        }

        this.employeeGroups = [];
        let sortedBusinessUnits = Object.values(this.shiftTemplateGroupMap);
        for (let i = 0; i < sortedBusinessUnits.length; i++) {
            var bUnit = sortedBusinessUnits[i];
            var group = {};
            group.label = bUnit.name;
            group.bUnit = bUnit;
            group.show = true;
            group.showMajor = true;
            var shiftEntries = [];
            if(!bUnit.templates) bUnit.templates = [];
            bUnit.templates = Object.values(view.shiftTemplateMap).filter(u => u.groupId === bUnit.id && u.weekDays.find(d => d === view.templateDaySelection));
            for(var x in bUnit.templates){
                var shiftTemplate = bUnit.templates[x];
                var entry = {
                                picture: 'url(../img/default.jpg)',
                                firstName: shiftTemplate.spotId && shiftTemplate.spotId !== '' && view.spotMap[shiftTemplate.spotId]? view.spotMap[shiftTemplate.spotId].name : 'Template',
                                lastName: '',
                                shiftTemplateEntry: true,
                                shiftTemplateDelay: true,
                                shiftTemplate: shiftTemplate,
                            };
                (function(shiftEntry){
                    requestAnimationFrame(function(){
                        shiftEntry.shiftTemplateDelay = false;
                    });
                })(entry);
                shiftEntries.push(entry);
                shiftTemplate.linkedShifts = [];
                var templatedShifts = Object.values(this.planShiftMap).filter(s => s.templateId === shiftTemplate.id && s.employeeId && s.eemployeeId !== '' && s.fromDate.date() === view.dayModeDate.date());
                for(var y in templatedShifts){
                    shiftTemplate.linkedShifts.push(templatedShifts[y]);
                    /*var user = this.employeeMap[templatedShifts[y].employeeId];

                    shiftEntries.push(user);*/
                }
                /*
                var unassignedShifts = Object.values(this.planShiftMap).filter(s => s.templateId === shiftTemplate.id && (!s.employeeId || s.eemployeeId === '') && s.fromDate.date() === view.dayModeDate.date());
                for(var y in unassignedShifts){

                    var entry = {
                                    picture: 'url(../img/default.jpg)',
                                    firstName: 'Unassigned',
                                    lastName: '',
                                    shiftTemplateUnassigned: unassignedShifts[y],
                                };
                    shiftTemplate.linkedShifts.push(entry);

                    shiftEntries.push(entry);
                }*/
            }
            group.employees = shiftEntries;
            group.employeesFiltered = shiftEntries.slice();
            group.collapsed = group.employeesFiltered.length <= 0;
            this.employeeGroups.push(group);
        }
        this.$forceUpdate();
        /*var group = {};
        group.label = 'Nicht zugeordnet';
        group.bUnit = null;
        group.collapsed = false;
        group.employees = view.employees.filter(e => view.employeeMap[e.id].unitId == null);
        group.employeesFiltered = group.employees.slice();
        group.collapsed = group.employeesFiltered.length <= 0;
        this.employeeGroups.push(group);*/
    },



    sortByPriorityAndName: function(a,b){
      if ( a.priority < b.priority ) return -1;
      if ( a.priority > b.priority ) return 1;
      if ( a.name.toUpperCase() < b.name.toUpperCase() ) return -1;
      if ( a.name.toUpperCase() > b.name.toUpperCase() ) return 1;
      return 0;
    },
    sortEmployeeByName: function(a,b){
      if ( a.lastName.toUpperCase() < b.lastName.toUpperCase() ) return -1;
      if ( a.firstName.toUpperCase() > b.firstName.toUpperCase() ) return 1;
      return 0;
    },
    sortSpotMap: function(){
        let majorGroups = [];
        for(var i in this.spotMap){
            if(this.spotMap[i].isMain){
                majorGroups.push(this.spotMap[i]);
            }
        }
        majorGroups.sort(this.sortByPriorityAndName);
        // The employeeGroups with a BusinessUnit are now sorted

        let childGroups = [];
        for(var i in this.spotMap){
            if(!this.spotMap[i].isMain){
                childGroups.push(this.spotMap[i]);
            }
        }
        childGroups.sort(this.sortByPriorityAndName);
        // The employeeGroups with indentation are now sorted

        // Loop to PUSH the child groups after the parent, BUT in the same array like the parent group
        let groups = [];
        for(let i = 0; i < majorGroups.length; i++){
            groups.push(majorGroups[i]);
            for(var j in childGroups){
                if(childGroups[j].unitId == majorGroups[i].unitId){
                    groups.push(childGroups[j]);
                }
            }
        }
        return groups;
    },


    computeEmployeeGroup: function(spot){
        var view = this;
        var group = {};
        group.label = (spot == null) ? 'Nicht zugeordnet' : spot.label; // Needed for employeeGroups that don't have a spot but need a label
        group.spot = spot; // set the spot to have all infos about the spot this employeeGroup represents
        group.employees = (spot == null) ? view.employees.filter(e => view.employeeMap[e.id].spotId == null) : view.employees.filter(e => (view.employeeMap[e.id].spotId != null && view.employeeMap[e.id].spotId == spot.id)); // employees, where spotId is set AND spot id equals this spot
        group.employeesFiltered = group.employees.slice();//copy the employees for now, for filtering later
        group.collapsed = group.employeesFiltered.length <= 0; // auto collapse, if no employees in this group
        group.draggable = (spot == null) ? false : true; // this employeeGroup is draggable?
        group.helper = false; // its a existing emplyoee group and not a helper element for dragging
        group.show = group.employees.length > 0;
        group.showMajor = group.show; // possibility to override the show mechanism if the user overrules it, right now just set it the same as show
        if(spot == null || this.$helpers.isBlank(spot.parentId)){
            group.indentationLevel = 0;
        }else{
            group.indentationLevel = 1;
        }
        return group;
    },

    sortEmployeeGroups: function(){
        var view = this;
        this.employeeGroups = [];
        if(this.showBusinessUnits){ // Sort by business units and spots?
            //Yes, Sortierung nach Bereichen
            let sortedUnits = this.sortSpotMap();
            for (let i = 0; i < sortedUnits.length; i++) {
                this.employeeGroups.push(view.computeEmployeeGroup(sortedUnits[i]));
            }
            this.employeeGroups.push(view.computeEmployeeGroup(null));
        } else{
            //Keine Sortierung nach Bereichen
            var group = {};
            group.label = 'Alle Mitarbeiter';
            group.spot = null;
            group.collapsed = false;
            group.employees = view.employees.slice();
            group.employeesFiltered = group.employees.slice();
            group.draggable = false;
            group.helper = false;
            group.show = true;
            group.showMajor = true;
            group.indentationLevel = 0;
            this.employeeGroups.push(group);
        }
        for(let i in view.employeeGroups){
            view.employeeGroups[i].employees.sort(this.sortEmployeeByName);
            view.employeeGroups[i].employeesFiltered.sort(this.sortEmployeeByName);
        }
        
        for(let i in view.employeeGroups){
            let hasChilds = false;
            if(view.employeeGroups[i].spot != null){
                 for(let x in view.employeeGroups){
                    if(view.employeeGroups[x].spot != null && view.employeeGroups[x].spot.parentId === view.employeeGroups[i].spot.id){
                        view.employeeGroups[i].show = true;
                        view.employeeGroups[i].showMajor = true;
                        break;
                    }
                }
            }
           
        }

        this.filterEmployees();
        return;
    },
    ClearEmployeeFilter(){
         this.dynamicSkillsFiltered = [];
         this.filterEmployees();
    },

    filterEmployees: function(){
        var view = this;
        this.dynamicFilterActive = false;
        if(this.dynamicFiltering){
            if(this.dragging){
                this.dynamicFilterActive = true;
            }
            for (let i = 0; i < this.employeeGroups.length; i++) {
                this.employeeGroups[i].employeesFiltered = this.dynamicSkillsFiltered.length > 0 ? this.employeeGroups[i].employees.filter(e => e.skills && this.dynamicSkillsFiltered.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)) : this.employeeGroups[i].employees.slice();
            }
        }else{
            for (let i = 0; i < this.employeeGroups.length; i++) {
                this.employeeGroups[i].employeesFiltered = this.softSkillsFiltered.length > 0 ? this.employeeGroups[i].employees.filter(e => e.skills && this.softSkillsFiltered.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)) : this.employeeGroups[i].employees.slice();
            }
            // CODE TO UPDATE EMPLOYEE COUNT BELOW
            let tmp = this.softSkillsFiltered.slice();
            for (let i in this.spotMap) {
                let sum = 0;
                let skillId = this.spotMap[i].requiredSkill;
                let index = tmp.indexOf(skillId);
                if (index !== -1){
                    tmp.splice(index, 1);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => e.skills && tmp.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.push(skillId);
                }else{
                    tmp.push(skillId);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => e.skills && tmp.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.splice(index, 1);
                }
                this.spotMap[i].employeeCount = sum;
            }

            let helperArray = this.softSkills.slice();
            for (let i = 0; i < this.softSkills.length; i++) {
                let sum = 0;
                let skillId = this.softSkills[i].id;
                let index = tmp.indexOf(skillId);
                if (index !== -1){
                    tmp.splice(index, 1);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => e.skills && tmp.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.push(skillId);
                }else{
                    tmp.push(skillId);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => e.skills && tmp.every(elem => e.skills.filter(s => s.skillId === elem).length > 0)).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.splice(index, 1);
                }
                helperArray[i].employeeCount = sum;
            }
            this.softSkills = helperArray.slice();
            this.$forceUpdate();

            if(window.timebars) {
                window.timebars.forEach(t => t.$refs.overlay.toggled = false);
            }
            // CODE TO UPDATE EMPLOYEE COUNT END
        }
    },


    
    updateUserUnitSort: function(data){
        let userunitsort = []
        for (let i = 0; i < data.length; i++) {
            userunitsort.push(data[i]);
        }
        this.userunitsort = userunitsort;
    },
    updateBusinessUnits: function(data){
        var view = this;
        var i;
        let tbunits = {}
        for (i = 0; i < data.length; i++) {
            let item = {
                id: data[i].id,
                name: data[i].name
            }
            data[i].label = data[i].name
            tbunits[item.id] = item;
        }
        this.businessunitMap = tbunits;

    },
    loadHolidays: function() {
        let url = '/api/sec/storeevent';
        let params = {
            storeId: this.$store.state.storeId,
            from: this.dateSelectionStart.clone().date(15).month(11).subtract(1, 'year').format(),
            to: this.dateSelectionStart.clone().date(15).month(0).add(1, 'year').format(),
            holiday: true,
            active: true,
        };
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            return new Promise((resolve, reject) => {
                if(response.status == 200 && response.data.length > 0){
                    //retrieved stored, customized holidays =>  resolve with response
                    resolve(response);
                } else if (response.status == 200){
                    //didnt find any holidays, retrieve the default holiday from past year, current year and next year
                    let url = '/api/sec/storeevent/holidays/default';
                    let currentyear = this.$helpers.getCurrentMonthMomentUTC().year();
                    let params = {
                        storeId: this.$store.state.storeId,
                        years: currentyear+','+(currentyear+1)+','+(currentyear-1)
                    };
                    this.axios({
                        method: 'get',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url
                    }).then(response => {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error)
                    })
                } else {
                    reject('Invalid return code');
                } 
            })   
        }).catch(function (error) {
            return new Promise((resolve, reject) => {
                 reject(error)
            })
        })
    },
    updateHolidays: function(data){
        let i;
        let tholidays = {}
        for (i = 0; i < data.length; i++) {
            let key = this.$helpers.getMomentFromString(data[i].from).format('YYYY-MM-DD');
            if(!tholidays[key]){
                tholidays[key] = [];
            }
            tholidays[key].push(data[i]);
            
        }
        //console.log(JSON.stringify(tholidays));
        this.holidayMap = tholidays;
    },
    loadShifts : function() {

        let url = '/api/sec/planshift';

        let params = {
            storeId: this.$store.state.storeId,
            from: this.$store.state.rosterFromTo.from,
            to: this.$store.state.rosterFromTo.to,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },
    RefreshStoreSales(){
        var view = this;
        this.loadStoreSales()
        .then(response => {
            view.storeSales = {};
            view.AddStoreSales(response.data, false);
            view.loadStoreSalesPlanned()
            .then(response => {
                view.AddStoreSales(response.data, true);
                view.$forceUpdate();
            }).catch(function (error) {
                console.log(error)
            })
        }).catch(function (error) {
            console.log(error)
        })
    },
    AddStoreSales(sales, planned){
        var view = this;
        for(let x in sales){
            (function(sale){
                if(!view.storeSales[sale.date]) view.storeSales[sale.date] = {};
                if(planned) view.storeSales[sale.date].planned = sale;
                if(!planned) view.storeSales[sale.date].actual = sale;
                sale.dateMoment = moment(sale.date, 'YYYY-MM-DD');
            })(sales[x]);
        }
    },
    loadStoreSalesDaily(date) {

      let url = '/api/sec/storesales';
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');

      url = this.$helpers.appendParam("from", date.clone().hours(0).format('YYYY-MM-DD') + 'T00:00Z', url, '/api/sec/storesales');
      url = this.$helpers.appendParam("to", date.clone().hours(0).add(1, 'day').format('YYYY-MM-DD') + 'T00:00Z', url, '/api/sec/storesales');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })


    },

    loadStoreSales : function() {

        let url = '/api/sec/storesales/grouped';

        let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to,
                    planned: false
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },
    loadStoreSalesPlanned : function() {

        let url = '/api/sec/storesales/grouped';

        let params = {
            storeId: this.$store.state.storeId,
            from: this.$store.state.rosterFromTo.from,
            to: this.$store.state.rosterFromTo.to,
            planned: true
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadShiftSkills : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shiftskillrequirement/any/shift';

            let params = {
                storeId: this.$store.state.storeId      
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            });
        }
        


    },
    loadEmployeeContracts : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeecontract/any/employee';

            let params = {
                storeId: this.$store.state.storeId,
            };
        
            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            });
        }
        


    },
    loadUserUnitSort : function() {

        let url = '/api/sec/userunitsort';

        let params = {
            storeId: this.$store.state.storeId,
        };
        return this.axios({
            method: 'get',
            params: params, 
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadBusinessUnits : function() {

        let url = '/api/sec/businessunit';

        let params = {
            storeId: this.$store.state.storeId,
        };


        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadSpots : function() {

        let url = '/api/sec/spot';

        let params = {
            storeId: this.$store.state.storeId,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadSkills : function() {

        let url = '/api/sec/skill';

        let params = {
            storeId: this.$store.state.storeId,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadEmployeeSkills : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeeskill/any/employee';

            let params = {
                storeId: this.$store.state.storeId,   
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            });
        }
    },
    loadEmployeeAvailabilities : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeeavailability/any/employee';

            let params = {
                storeId: this.$store.state.storeId,
            };

             return this.axios({
                method: 'post',
                params: params, 
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }

        


    },
    loadEmployeeTypes : function() {

        let url = '/api/sec/employeetype';

        let params = {
            storeId: this.$store.state.storeId,
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    updateEmployeeRules: function(data){
        var i;
        let trules = {}
        for (i = 0; i < data.length; i++) {
            trules[data[i].id] =data[i];
        }
        this.employeeRulesMap = trules;
    },
    updateShiftSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.shiftSkillMap = tskills;
    },
    loadEmployeeRules : function() {

      let url = '/api/sec/employeerules';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })


    },
    sortByName: function(a,b){
      var x = a.firstName + " " + a.lastName;
      var y = b.firstName + " " + b.lastName;
      if ( x.toUpperCase() < y.toUpperCase() ) return -1;
      if ( x.toUpperCase() > y.toUpperCase() ) return 1;
      return 0;
    },
    updateEmployees: function(data) {
        // set employee data
        //console.log(data);
        let overviewA = [];
        var i;
        var roster = this;
        let tEmployeeMap = {};
        for (i = 0; i < data.length; i++) {
            data[i].shiftsDate = {};
            

            data[i].picture = roster.GetProfilePictureUrl(data[i]);
            tEmployeeMap[data[i].id] = data[i];
            overviewA.push(data[i]);

        }
        this.employeeMap = tEmployeeMap;
        this.employees = overviewA;
        this.employees.sort( this.sortByName );
        this.employeesFiltered = this.employees.slice();
        
    },
    updateShiftChanges: function(data){
        var i;
        let tshiftchanges = {}
        let overviewB = [];
        for (i = 0; i < data.length; i++) {
            tshiftchanges[data[i].id] =data[i];
            //overviewB.push(this.createShiftChangeItem(data[i]));
        }
        this.shiftChangeMap = tshiftchanges;
        this.shiftChanges = overviewB;
    },
    loadShiftChanges : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shiftchange/any/shift';

            let params = {
                storeId: this.$store.state.storeId,
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            });
        }
        


    },
    updateShifts: function(data) {
        var view = this;
        let overviewA = [];
        /*
        *   WHEN UPDATING SHIFTS OR ANY OTHER FUCKING ENTITY PLEASE DISCARD THE OLD MAP INSTEAD OF ADDING TO THE EXISTING ONE
        *   OTHERWISE WE WILL HAVE STALE DATA INSIDE THE MAP AND EVERYONE WILL BE VERY SAD
        */
        let tplanShiftMap =  {};
        var i;
        for (i = 0; i < data.length; i++) {
            (function(data){
                //BANDAID FIX START
                //TODO: FIX PROPERLY AND USE TZ OFFSET
                data.from = view.$helpers.extractDateString(data.from,'YYYY-MM-DDTHH:mm');
                data.to = view.$helpers.extractDateString(data.to,'YYYY-MM-DDTHH:mm');
                if(data.historicTo) data.historicToDate = view.$helpers.extractDateString(data.historicTo,'YYYY-MM-DDTHH:mm');
                if(data.historicFrom) data.historicFromDate = view.$helpers.extractDateString(data.historicFrom,'YYYY-MM-DDTHH:mm');
                //BANDAID FIX OVER

                tplanShiftMap[data.id] = data;

                let planShiftItem = {
                    id: data.id,
                    from: data.from,
                    to: data.to,
                    published: data.published,
                    publishDate: data.publishDate,
                }
                if(!view.$helpers.isBlank(data.employeeId)){
                    planShiftItem.employeeId = data.employeeId;
                    planShiftItem.employee = view.employeeMap[data.employeeId].firstName+" "+view.employeeMap[data.employeeId].lastName;
                } else {
                    planShiftItem.employee = "";
                }
                if(!view.$helpers.isBlank(data.spotId)){
                    planShiftItem.spot = view.spotMap[data.spotId].name;
                } else {
                    planShiftItem.spot = "";
                }
                let employee = view.employeeMap[data.employeeId];
                //TODO: use helper method to get moment, since in helper method we can change in one place whether to get utc or local
                planShiftItem.toDate = data.toDate = view.$helpers.getMomentFromStringUTC(data.to, 'YYYY-MM-DDTHH:mm');
                
                planShiftItem.fromDate = data.fromDate = view.$helpers.getMomentFromStringUTC(data.from, 'YYYY-MM-DDTHH:mm');
                if(data.historicTo) data.historicToDate = view.$helpers.getMomentFromStringUTC(data.historicTo, 'YYYY-MM-DDTHH:mm');
                if(data.historicFrom) data.historicFromDate = view.$helpers.getMomentFromStringUTC(data.historicFrom, 'YYYY-MM-DDTHH:mm');
                //if(parseInt(data.fromDate.format('x')) > parseInt(data.toDate.format('x'))) data.toDate.add(1, 'day');
                if(employee)
                {
                    if(!employee.shifts) employee.shifts = [];
                    if(!employee.shiftsDate) employee.shiftsDate = {};
                    employee.shifts.push(data);
                    if(!employee.shiftsDate[data.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[data.fromDate.format('YYYY-MM-DD')] = [];
                    employee.shiftsDate[data.fromDate.format('YYYY-MM-DD')].push(data);
                }
                overviewA.push(planShiftItem);
            })(data[i]);
        }
        
        this.planshifts = overviewA;
        this.planshifts.forEach(s => s.date = view.$helpers.getMomentFromStringUTC(s.from, 'YYYY-MM-DDTHH:mm'));

        this.planShiftMap = tplanShiftMap;
        
        this.UpdateSollIstMap();
    },
    removeShiftFromEmployee(shiftId){
        let oldShift = this.planShiftMap[shiftId];
        if(oldShift){
            let oldShiftDate = moment(oldShift.from);
            let fromDateKey = oldShift.fromDate.format('YYYY-MM-DD');
            if(oldShift.employeeId && this.employeeMap[oldShift.employeeId]){
                    
                if(this.employeeMap[oldShift.employeeId].shifts){
                    let index = this.employeeMap[oldShift.employeeId].shifts.findIndex(shift => shift.id == oldShift.id)
                    if (~index) {
                        this.employeeMap[oldShift.employeeId].shifts.splice(index, 1);
                    } 
                }
                if(this.employeeMap[oldShift.employeeId].shiftsDate && this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey]){
                    let index = this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].findIndex(shift => shift.id == oldShift.id)
                    if (~index) {
                        this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].splice(index, 1);
                    } 
                }
                        
            }
            let index = this.planshifts.findIndex(shift => shift.id == oldShift.id)
            if (~index) {
                this.planshifts[index].employeeId = null;
                this.planshifts[index].employee = "";
            }
            this.$set(this.planShiftMap[oldShift.id], 'employeeId', null);
            this.$set(this.planShiftMap[oldShift.id], 'preview', false);
            
        }
    },
    replaceShifts(newShifts, preview){
        for(let i = 0; i<newShifts.length; i++){
            let newShift = newShifts[i];
            let oldShift = this.planShiftMap[newShift.id];
            let oldShiftDate = moment(oldShift.from);
            let currentDate = this.$helpers.getMomentUTC();
            
            if(oldShift != null && (!oldShift.published || oldShiftDate.isSameOrAfter(currentDate))){
                
                
                let fromDateKey = oldShift.fromDate.format('YYYY-MM-DD');
                if(oldShift.employeeId && this.employeeMap[oldShift.employeeId]){
                   
                    if(this.employeeMap[oldShift.employeeId].shifts){
                        let index = this.employeeMap[oldShift.employeeId].shifts.findIndex(shift => shift.id == oldShift.id)
                        if (~index) {
                            this.employeeMap[oldShift.employeeId].shifts.splice(index, 1);
                        } 
                    }
                    if(this.employeeMap[oldShift.employeeId].shiftsDate && this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey]){
                        let index = this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].findIndex(shift => shift.id == oldShift.id)
                        if (~index) {
                            this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].splice(index, 1);
                        } 
                    }
                    
                }
                
                let index = this.planshifts.findIndex(shift => shift.id == oldShift.id)
                if (~index) {
                    this.planshifts[index].employeeId = newShift.employeeId;
                    
                    if(!this.$helpers.isBlank(newShift.employeeId)){
                        this.planshifts[index].employee = this.employeeMap[newShift.employeeId].firstName+" "+this.employeeMap[newShift.employeeId].lastName;
                    } else {
                        this.planshifts[index].employee = "";
                    }
                    
                }
                oldShift.employeeId = newShift.employeeId;
                this.$set(this.planShiftMap[oldShift.id], 'employeeId', newShift.employeeId);
                if(preview){
                    this.$set(this.planShiftMap[oldShift.id], 'preview', true);
                }
               
                let employee = this.employeeMap[newShift.employeeId];
                //TODO: use helper method to get moment, since in helper method we can change in one place whether to get utc or local
            
            
                if(employee)
                {
                        if(!employee.shifts) employee.shifts = [];
                        if(!employee.shiftsDate) employee.shiftsDate = {};
                        employee.shifts.push(oldShift);
                        if(!employee.shiftsDate[fromDateKey]) employee.shiftsDate[fromDateKey] = [];
                        employee.shiftsDate[fromDateKey].push(oldShift);
                }
            }
        }
        
        this.$forceUpdate();
        
        this.UpdateSollIstMap();
    },
    UpdateSollIstMapEntry(employee,shift){
        //remove shift from the employee which the shift is safed to.
        //update the employee where the shift was moved to
        this.UpdateSollIstMap();
    },

    UpdateHoverSollIst(employeeId){
        this.sollIstDragging.employeeIdNew = employeeId;
        this.UpdateSollIstMap();
    },

    UpdateSollIstMap(){
        var view = this;

        this.sollIstOverflow = 1;
        for (let i in view.employeeMap) {
            let employee = view.employeeMap[i];
            //if(employee.id != "bc14c50e-624d-42a9-b0fd-88dd35874ac0")continue;

            //Get the work balances from map and sort it desc
            let workBalanceArray = [];
            if(this.employeeWorkBalanceMap[employee.id] != null && this.employeeWorkBalanceMap[employee.id] != undefined){
                workBalanceArray = this.employeeWorkBalanceMap[employee.id].slice();
            }
            workBalanceArray.sort(this.sortHelper); // Sorted now DESC


            //Get what the minutes per month are per contract
            // !!!!!!!!!!!!!!!!!!!!!!!!! TODO !!!!!!!!!!!!!!!!!!!!!
            //ToDO !! IF CONTRACT CHANGES - THEN SELECT THE RIGHT CONTRACT (if user goes back in time, or contract changes for next month)
            let weekTimeRegular = 0;
            let hoursPerWorkday = 0;
            for (let j in view.employeeContractMap) {
                if(view.employeeContractMap[j].employeeId == employee.id){
                    weekTimeRegular = (view.employeeContractMap[j].weekTimeRegular) * 52.0 / 12.0;
                    hoursPerWorkday = (view.employeeContractMap[j].weekTimeRegular) / 5;
                }
            }
            employee.si_weekTimeRegular = weekTimeRegular;
            employee.si_hoursPerWorkday = hoursPerWorkday;

            let start = this.dateSelectionStart.clone().format();
            let end = this.dateSelectionStart.clone().endOf('month').add(1,'second').format();
            let startMoment = moment.utc(start);
            let endMoment = moment.utc(end);
            

            employee.si_monthBalanceFound = false;
            employee.si_holidayTimeBalance = 0;
            employee.si_vacationTimeBalance = 0;
            employee.si_workTimeBalance = 0;
            employee.si_sumPlanned = 0;

            if(view.sollIstMode == 0){
                for(let j = 0; j < workBalanceArray.length; j++){
                    let obj = workBalanceArray[j];
                    let month = moment(obj.date).month();
                    if(month == startMoment.month()-1){
                        employee.si_monthBalanceFound = true;
                        employee.si_holidayTimeBalance = obj.holidayTimeBalance;
                        employee.si_vacationTimeBalance = obj.vacationTimeBalance;
                        employee.si_workTimeBalance = obj.workTimeBalance;                    
                        break;
                    }
                }
            }

            let sumHoliday = 0;
            let sumSickness = 0;
            employee.si_sumHoliday = 0;
            employee.si_sumSickness = 0;
            for (let j in view.employeePreferenceMap) {
                let x = view.employeePreferenceMap[j];
                if(x.type == 1 || x.type == 2){ // 1 = Urlaub , 2 = Krankenstand
                    if(x.employeeId == employee.id){
                        if(x.fromDate.unix() < startMoment.unix() && x.toDate.unix() < endMoment.unix()){
                            //Ignore, this preference is complete outside the shown month
                        }else if(x.fromDate.unix() < startMoment.unix() && x.toDate.unix() > endMoment.unix()){
                            //This Preference is half within the month (take second half of preference)
                            let diff = Math.floor((x.toDate.unix() - startMoment.unix())/60);
                            (x.type == 1) ? sumHoliday+=diff : sumSickness+=diff;
                        }else if(x.fromDate.unix() >= startMoment.unix() && x.toDate.unix() <= endMoment.unix()){
                            //This Preference is complete within this month
                            let diff = Math.floor((x.toDate.unix() - x.fromDate.unix())/60);
                            (x.type == 1) ? sumHoliday+=diff : sumSickness+=diff;
                        }else if(x.fromDate.unix() >= startMoment.unix() && x.toDate.unix() <= endMoment.unix()){
                            //This Preference is half within the month (take first half of preference)
                            let diff = Math.floor((endMoment.unix() - x.fromDate.unix())/60);
                            (x.type == 1) ? sumHoliday+=diff : sumSickness+=diff;
                        }else{
                            //Preference complete outside the month, ignore
                        }
                    }
                }
            }
            employee.si_sumHoliday = sumHoliday / 60 / 24 * hoursPerWorkday;
            employee.si_sumSickness = sumSickness / 60 / 24 * hoursPerWorkday;




            let sumPlanned = 0; 
            employee.si_sumPlanned = 0; 
            let sumHolidayPlanned = 0; 
            employee.si_sumHolidayPlanned = 0;
            
            if(view.sollIstMode == 1 || employee.si_monthBalanceFound){
                //We have a month closing balance. Or calculate every month for its own.
                //Thus only add shifts from this month

                if(employee.shifts != null && employee.shifts != undefined){
                    //console.log("Employee:");
                    //console.log(employee.firstName + " " + employee.lastName);
                    for(let j = 0; j < employee.shifts.length; j++){
                        let shift = employee.shifts[j];


                        //Feiertag Check
                        shift.helperHolidayValue = 0;
                        if(true || shift.holidayWorkValue == -1){
                            for (let k in view.holidayMap) {
                                let x = view.holidayMap[k][0];
                                if(x.federalHoliday){
                                    //Gesetzlicher Feiertag
                                    let holidayFrom = moment(x.from);
                                    let holidayTo = moment(x.to);

                                    if(shift.fromDate.unix() >= holidayFrom.unix() && shift.toDate.unix() <= holidayTo.unix()){
                                        //Fully working in federal holiday day
                                        let diff = Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);
                                        sumHolidayPlanned = sumHolidayPlanned + diff;
                                        shift.helperHolidayValue = diff;
                                    }

                                }
                            }
                        }else{
                            console.log("ToDo: Calculate holiday work value.");
                            console.log(shift);
                        }


                        if(shift.fromDate.unix() < startMoment.unix() && shift.toDate.month() != startMoment.month()){
                            //IF From-Date & To-Date both in prev month, then ignore
                        }else if(shift.fromDate.unix() < startMoment.unix() && shift.toDate.month() == startMoment.month()){
                            //IF From-Date in prev month & To-Date in this month, then calculate diff (take second half)
                            if(shift.workValue != -1){
                                console.log("Error: Can not calculate correct Soll-Ist Values")
                            }
                            let diff = Math.floor((shift.toDate.unix() - startMoment.unix())/60);
                            sumPlanned = sumPlanned + diff;
                        }else if(shift.fromDate.unix() >= startMoment.unix() && shift.toDate.month() == startMoment.month()){
                            //IF From-Date & To-Date both in this month, then take complete
                            if(shift.workValue == -1){
                                //Calculate value on its own
                                let diff = Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);
                                sumPlanned = sumPlanned + diff;
                            }else{
                                //ToDo take value from obj
                                sumPlanned = sumPlanned + shift.workValue;
                            }
                        }else if(shift.fromDate.month() == startMoment.month() && shift.toDate.month() != startMoment.month()){
                            //IF From-Date in this month & To-Date in next month, then calculate diff (take first half)
                            if(shift.workValue != -1){
                                console.log("Error: Can not calculate correct Soll-Ist Values")
                            }
                            let diff = Math.floor((endMoment.unix() - shift.fromDate.unix())/60);
                            sumPlanned = sumPlanned + diff;
                        }else if(shift.fromDate.month() != startMoment.month()){
                            //IF From-Date in next month, then ignore
                        }
                    }
                    employee.si_sumHolidayPlanned = sumHolidayPlanned;
                    employee.si_sumPlanned = sumPlanned;
                }
            }else{
                //Check if we have a 2 months previous closing balance. IF not, then use 0.
                //Get the shifts from previous month too!


                if(employee.shifts != null && employee.shifts != undefined){
                    //console.log("Employee:");
                    //console.log(employee.firstName + " " + employee.lastName);
                    for(let j = 0; j < employee.shifts.length; j++){
                        let shift = employee.shifts[j];


                        //Feiertag Check
                        shift.helperHolidayValue = 0;
                        if(true || shift.holidayWorkValue == -1){
                            for (let k in view.holidayMap) {
                                let x = view.holidayMap[k][0];
                                if(x.federalHoliday){
                                    //Gesetzlicher Feiertag
                                    let holidayFrom = moment(x.from);
                                    let holidayTo = moment(x.to);

                                    if(shift.fromDate.unix() >= holidayFrom.unix() && shift.toDate.unix() <= holidayTo.unix()){
                                        //Fully working in federal holiday day
                                        let diff = Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);
                                        sumHolidayPlanned = sumHolidayPlanned + diff;
                                        shift.helperHolidayValue = diff;
                                    }

                                }
                            }
                        }else{
                            console.log("ToDo: Calculate holiday work value.");
                            console.log(shift);
                        }


                        if(shift.fromDate.unix() < startMoment.unix() && shift.toDate.month() != startMoment.month()){
                            //IF From-Date & To-Date both in prev month, then ignore
                        }else if(shift.fromDate.unix() < startMoment.unix() && shift.toDate.month() == startMoment.month()){
                            //IF From-Date in prev month & To-Date in this month, then calculate diff (take second half)
                            if(shift.workValue != -1){
                                console.log("Error: Can not calculate correct Soll-Ist Values")
                            }
                            let diff = Math.floor((shift.toDate.unix() - startMoment.unix())/60);
                            sumPlanned = sumPlanned + diff;
                        }else if(shift.fromDate.unix() >= startMoment.unix() && shift.toDate.month() == startMoment.month()){
                            //IF From-Date & To-Date both in this month, then take complete
                            if(shift.workValue == -1){
                                //Calculate value on its own
                                let diff = Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);
                                sumPlanned = sumPlanned + diff;
                            }else{
                                //ToDo take value from obj
                                sumPlanned = sumPlanned + shift.workValue;
                            }
                        }else if(shift.fromDate.month() == startMoment.month() && shift.toDate.month() != startMoment.month()){
                            //IF From-Date in this month & To-Date in next month, then calculate diff (take first half)
                            if(shift.workValue != -1){
                                console.log("Error: Can not calculate correct Soll-Ist Values")
                            }
                            let diff = Math.floor((endMoment.unix() - shift.fromDate.unix())/60);
                            sumPlanned = sumPlanned + diff;
                        }else if(shift.fromDate.month() != startMoment.month()){
                            //IF From-Date in next month, then ignore
                        }
                    }
                    employee.si_sumHolidayPlanned = sumHolidayPlanned;
                    employee.si_sumPlanned = sumPlanned;
                }

            }


/*


                sollIstDragging: {
                    employeeIdOld: null,
                    employeeIdNew: null,
                    shiftTimeinMinutes: 0
                },
*/

            if(this.sollIstDragging.employeeIdOld != null){
                if(employee.id == this.sollIstDragging.employeeIdOld && employee.id != this.sollIstDragging.employeeIdNew){
                    employee.si_sumPlanned = employee.si_sumPlanned - this.sollIstDragging.shiftTimeinMinutes;
                }else if(employee.id == this.sollIstDragging.employeeIdNew && employee.id != this.sollIstDragging.employeeIdOld){
                    employee.si_sumPlanned = employee.si_sumPlanned + this.sollIstDragging.shiftTimeinMinutes;
                }
            }

            let summe = employee.si_workTimeBalance + employee.si_sumPlanned + employee.si_holidayTimeBalance; // + ist_Summe
            if(view.sollIstMode == 1){
                summe = employee.si_sumPlanned + employee.si_holidayTimeBalance; // + ist_Summe
            }

            let tmpOverflow = (summe > 1 && employee.si_weekTimeRegular > 1) ? employee.si_weekTimeRegular / summe : 1; // sollIstOverflow
            employee.si_overflow = tmpOverflow;
            this.sollIstOverflow = Math.min(this.sollIstOverflow,tmpOverflow);

        }//End for loop employee map



        //Tell every bar to update itself. It has the data from the $parent anyways
        if(this.$refs.sollistbars != null && this.$refs.sollistbars != undefined){
            for(let i = 0; i < this.$refs.sollistbars.length;i++){
                this.$refs.sollistbars[i].update();
            }
        }
    },
    sortHelper(a,b){
        return (moment(a.date).isSameOrBefore(b.date)) ? 1 : -1; // sort desc
        //return (moment(a.date).isSameOrBefore(b.date)) ? -1 : 1; // sort asc
    },




    GenerateEmployeeShiftsFromMap(planShiftMap){
        var view = this;
        planShiftMap = Object.values(planShiftMap);
        Object.values(view.employeeMap).forEach(function(e){
            e.shifts = [];
            e.shiftsDate = {};
        });
        for (var i = 0; i < planShiftMap.length; i++) {
            (function(planShiftMap){
                var employee = view.employeeMap[planShiftMap.employeeId];
                if(employee)
                {
                    if(!employee.shifts) employee.shifts = [];
                    if(!employee.shiftsDate) employee.shiftsDate = {};
                    employee.shifts.push(planShiftMap);
                    if(!employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')] = [];
                    employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')].push(planShiftMap);
                }
            })(planShiftMap[i]);
        }
        this.$forceUpdate();
    },
    loadActiveEmployees : function() {

        let url = '/api/sec/employee';
        let params = {
            storeId: this.$store.state.storeId,
            activeAt: this.$store.state.rosterFromTo.from,
        };
        
        
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },
    loadEmployeePreferences : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            
            let url = '/api/sec/employeepreference/any/employee';

            let params = {
                storeId: this.$store.state.storeId,
                approved: true,
            };


            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            });
        }
        

    },
    loadEmployeeWorkBalances : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let view = this;
            let url = '/api/sec/employeeworkbalance/any/employee';
            //load from 2 months ago and from 1 month ago
            let pastMonthDateStart = this.$helpers.getMomentUTC().utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).subtract(2, 'month');
            let pastMonthDateEnd = pastMonthDateStart.clone().date(2).add(1,'month');
            let params = {
                storeId: this.$store.state.storeId,
                from: pastMonthDateStart.format(),
                to: pastMonthDateEnd.format()
            };
        
            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }
        
			
    },
    updateEmployeeWorkBalances: function(data) {
        let tbalance = {}
        for (let i = 0; i < data.length; i++) {
            if(!tbalance[data[i].employeeId]){
               tbalance[data[i].employeeId] =[]; 
            }
            tbalance[data[i].employeeId].push(data[i])
            
        }
        this.employeeWorkBalanceMap = tbalance;
    },
    hideModal(ref) {
        this.$refs[ref].hide();
    },
    showModal(ref) {
        this.$refs[ref].show()
    },
            
            CloseEmployeeDetails: function () {
                this.employeeSelected = null;
                this.UpdateTimebarLabels();
            },
            SelectEmployee: function ($event, employee) {

                console.log($event.currentTarget);//.getBoundingClientRect();


                if(!employee || !employee.id || employee.id === '' || employee.shiftTemplateEntry) return;
                this.employeeSelected = employee;
                this.UpdateTimebarLabels();
            },
            UpdateMouse: function () {
                this.posx = event.pageX;
            },
            DragStartEmployee: function ($event, employeeGroup,indexGroup,employee){
                var view = this; 
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    //show all units and collapse all units
                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        view.employeeGroups[x].show = true;
                    }


                    //add helper units for easier dropping of a dragged item
                    let helperArray = [];
                    for(let i = 0; i < view.employeeGroups.length;i++){
                        if(view.employeeGroups[i].show){
                            var group = {};
                            group.label = '';
                            group.bUnit = null;
                            group.collapsed = true;
                            group.employees = [];
                            group.employeesFiltered = [];
                            group.draggable = false;
                            group.show = true;
                            group.helper = true;
                            group.indentationLevel = view.employeeGroups[i].indentationLevel;

                            helperArray.push(view.employeeGroups[i]);
                            helperArray.push(group);
                        }
                    }
                    view.employeeGroups = helperArray.slice();

                    view.draggingEmployee = true;
                    var event = $event;                    
                    view.$refs.dragemployee.DragStart(event.pageX, event.pageY, indexGroup,employee);
                    view.$refs.dragemployee.callbackEnd = view.DragEndEmployee;
                }, 200);
            },
            DragEndEmployee: function (closest,employee) {
                let view = this;
                view.draggingEmployee = false;

                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(i == (view.dropIndexBusinessUnit-1)){
                        let spotId = null;
                        let unitName = null;
                        if(this.employeeGroups[i].spot != null){
                            spotId = this.employeeGroups[i].spot.id;
                        }
                        
                        let url = '/api/sec/employee/linkspot';
                        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                        
                        let payload = {id: employee.id, spotId: spotId, deleteOldSkill: true, skillValue: 10}
                        //ToDo : soll der alte skill gelöscht werden? Welchen Skill Wert soll der Mitarbeiter in der neuen Position bekommen?
                        this.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+this.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            employee.spotId = spotId;
                            view.employeeMap[employee.id].spotId = spotId;
                            view.sortSpotMap();
                            view.sortEmployeeGroups();
                            let employeePayload = {ids: []};
                            for (let employeeId in view.employeeMap) {
                                employeePayload.ids.push(view.employeeMap[employeeId].id);
                            }
                            view.loadEmployeeSkills(employeePayload).then(response => {
                                view.updateEmployeeSkills(response.data);
                            });
                            //console.log(response);
                        }).catch(function (error) {
                            console.log(error)
                            view.sortSpotMap();
                            view.sortEmployeeGroups();
                        })
                        break;
                    }
                }

                
            },



            DragStartBusinessUnit: function ($event, employeeGroup,indexGroup){
                var view = this; 
                setTimeout(function(){
                    if(!window.mouse.click) return;
                    //hide logical units and collapse all units
                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        if(view.employeeGroups[x].spot == null || view.employeeGroups[x].spot.id === employeeGroup.spot.id){
                            view.employeeGroups[x].show = false;
                        }else{
                            view.employeeGroups[x].show = true;
                        }
                    }
                    let helperArray = [];


                    if(employeeGroup.spot.isMain){
                        // Haupt Spot - Business Unit
                        //add helper units for easier dropping of a dragged item
                        for(let i = 0; i < view.employeeGroups.length;i++){
                            if(view.employeeGroups[i].show){
                                if(view.employeeGroups[i].spot.isMain){
                                    var group = {};
                                    group.label = '';
                                    group.spot = null;
                                    group.collapsed = true;
                                    group.employees = [];
                                    group.employeesFiltered = [];
                                    group.draggable = false;
                                    group.show = true;
                                    group.helper = true;
                                    group.indentationLevel = 0;
                                    helperArray.push(group);
                                }
                                helperArray.push(view.employeeGroups[i]);
                            }
                        }
                        var group = {};
                        group.label = '';
                        group.spot = null;
                        group.collapsed = true;
                        group.employees = [];
                        group.employeesFiltered = [];
                        group.draggable = false;
                        group.show = true;
                        group.helper = true;
                        group.indentationLevel = 0;
                        helperArray.push(group);
                    }else{
                        // Neben Spot - also Child
                        //add helper units for easier dropping of a dragged item
                        for(let i = 0; i < view.employeeGroups.length;i++){
                            if(view.employeeGroups[i].show){
                                helperArray.push(view.employeeGroups[i]);// We need to show every employeeGroup Entry. but helpers only to childs
                                
                                if(employeeGroup.spot.unitId == view.employeeGroups[i].spot.unitId){
                                    //now we are in the same unit ID
                                    //You can only drop the childs to the same unit id
                                    var group = {};
                                    group.label = '';
                                    group.spot = null;
                                    group.collapsed = true;
                                    group.employees = [];
                                    group.employeesFiltered = [];
                                    group.draggable = false;
                                    group.show = true;
                                    group.helper = true;
                                    group.indentationLevel = 1;
                                    helperArray.push(group);
                                }
                            }
                        }
                    }
                    view.employeeGroups = helperArray.slice();//This line also removes the "not categorized group"

                    view.draggingBusinessUnit = true;
                    var event = $event;                    
                    view.$refs.dragbusinessunit.DragStart(view,event.pageX, event.pageY, employeeGroup,indexGroup);
                    view.$refs.dragbusinessunit.callbackEnd = view.DragEndBusinessUnit;
                }, 500);
            },
            DragEndBusinessUnit: function (dragging,closest) {
                this.draggingBusinessUnit = false;
                let newSorted = [];

                let skip = [];
                if(dragging.indentationLevel == 0){
                    for(let j = 0; j < this.employeeGroups.length; j++){
                        if(!this.employeeGroups[j].helper && dragging.spot.unitId == this.employeeGroups[j].spot.unitId){
                            skip.push(j);
                        }
                    }
                }

                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(skip.includes(i)){
                        continue;
                    }
                    if(!this.employeeGroups[i].helper){
                        //IF the employeeGroup is not helper, then copy
                        newSorted.push(this.employeeGroups[i]);
                    }
                    if(i == this.dropIndexBusinessUnit){
                        //We found the helper, where we want to drop
                        newSorted.push(dragging);//First drop the major group
                        if(this.employeeGroups[i].indentationLevel == 0){
                            for(let j = 0; j < this.employeeGroups.length; j++){
                                if(!this.employeeGroups[j].helper && dragging.spot.unitId == this.employeeGroups[j].spot.unitId){
                                    newSorted.push(this.employeeGroups[j]);
                                }
                            }
                        }
                    }
                }

                for(let i = 0; i < newSorted.length; i++){
                    newSorted[i].collapsed = newSorted[i].employeesFiltered.length <= 0;
                    newSorted[i].helper = false;
                    newSorted[i].show = newSorted[i].employees.length > 0;
                }
                newSorted.push(this.computeEmployeeGroup(null));//Push the not categorized group

                this.employeeGroups = newSorted.slice();
                this.filterEmployees();
                this.$forceUpdate();

                //SEND POST REQUEST TO UPDATE NEW SORTING
                let toSendArray = [];
                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(this.employeeGroups[i].spot != null){
                        let id = this.employeeGroups[i].spot.id;
                        toSendArray.push({unitId: id,priority: i});
                    }
                }
                this.SendBusinessUnitsPriorityUpdate(toSendArray);
            },
            updateParentFromSpot: function(spotId,parentId){
                let view = this;
                let url = '/api/sec/spot';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
                
                let payload = {
                id: spotId,
                parentId: parentId,
                updateFields: ["parentId"]
                }

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                }).catch(function (error) {
                    console.log(error)
                })

            },



            SendBusinessUnitsPriorityUpdate: function(data){
                let view = this;
                let url = '/api/sec/userunitsortupdate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userunitsortupdate');
                let payload = {
                  data: data
                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success('Gespeichert', 'Die neue Reihenfolge wurde gespeichert!');
                }).catch(function (error) {
                    view.$helpers.warning('Fehler', 'Speichern fehlgeschlagen!');
                    view.error=true;
                    console.log(error)
                })
            },




            DragStart: function ($event, employee, indexweek, index) {
                var roster = this;
                /*var mousetemp = {x: window.mouse.x, y: window.mouse.y};
            || Math.abs(mousetemp.x - window.mouse.x) < 10 || Math.abs(mousetemp.y - window.mouse.y) < 10*/
                setTimeout(function(){
                    if(!window.mouse.click) return;
                    roster.dragging = true;
                    var event = $event;
                    roster.$refs.drag.htmlContent = '';
                    roster.$refs.drag.DragStart(event.pageX, event.pageY, {employee: employee, date: ''});
                }, 200);
            },
            DragStartShift: function ($event, shift) {
                if(!shift || shift.published) return;
                var view = this;

                /*var mousetemp = {x: window.mouse.x, y: window.mouse.y};
            || Math.abs(mousetemp.x - window.mouse.x) < 10 || Math.abs(mousetemp.y - window.mouse.y) < 10*/
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    view.sollIstDragging.employeeIdOld = shift.employeeId;
                    view.sollIstDragging.shiftTimeinMinutes = shift.helperHolidayValue + Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);

                    view.dragging = true;
                    window.roster.UpdateTimeTableBorders([shift]);
                    view.FilterSpot(shift.spotId,true);
                    var event = $event;
                    view.$refs.drag.info = [];
                    view.$refs.drag.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    view.$refs.drag.info.push({label: 'Skill:', data: shift.spotId ? view.spotMap[shift.spotId].unitName : '', half: true});
                    view.$refs.drag.info.push({label: 'Spot:', data: shift.spotId ? view.spotMap[shift.spotId].name : '', half: true});
                    view.$refs.drag.DragStart(event.pageX, event.pageY, shift);
                    view.$refs.drag.callbackEnd = view.DragEndShift;
                }, 200);
            },
            DragEndShift: function (shift) {
                this.sollIstDragging.employeeIdOld = null;
                
                if(!this.dragging) return;
                var view = this;
                requestAnimationFrame(function(){
                    view.dragging = false;
                });

                let shiftDragSuccess = false;

                var timebar = $(window.mouse.element).closest('.time-bar-new');
                if(timebar && timebar.length > 0){
                    var timebarComponent = window.timebars.find(t => t.$el === timebar[0]);
                    if(timebarComponent){
                        //if((parseInt(this.$helpers.getMomentUTC().hours(0).minutes(0).format('x')) >= parseInt(timebarComponent.day.format('x')))) return;
                        var employee = timebarComponent.eventProp.employee;
                        if(employee){
                            shiftDragSuccess = true;
                            var employeePrev = this.employeeMap[shift.employeeId];
                            view.UpdateShift(shift, {employeeId: employee.id}, function(){

                                if(employeePrev)
                                {
                                    employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                    employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                                }
                                shift.employeeId = employee.id;
                                
                                if(!employee.shiftsDate) employee.shiftsDate = {};
                                if(!employee.shifts) employee.shifts = [];
                                if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                                employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                                employee.shifts.push(shift);
                                view.UpdateSollIstMapEntry(employee,shift);
                                setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                requestAnimationFrame(function(){
                                    window.timebars.forEach(t => t.Init());
                                });
                                
                                
                            }, function(){
                                setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                             });
                        }
                    }
                }
                var day = $(window.mouse.element).closest('.day');
                if(day && day.length > 0){
                    var el = day[0];
                    var dayDate = moment(el.attributes['year'].value + '-' +el.attributes['month'].value + '-' +el.attributes['day'].value, 'YYYY-MM-DD');
                    
                    var entry = day.closest('.entry');
                    var index = entry.parent().find('.entry').toArray().indexOf(entry[0]) - 1;

                    var employee = view.employeeMap[day.attr('employeeId')];
                    if(employee){
                        var employeePrev = view.employeeMap[shift.employeeId];
                            if(employeePrev && employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].length > 1){
                                var shiftList = [];
                                for(var x in employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')])
                                {
                                    var shiftTemp = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')][x];
                                    shiftList.push({label: shiftTemp.fromDate.format('HH') + ':' + shiftTemp.fromDate.format('mm') + ' - ' + shiftTemp.toDate.format('HH') + ':' + shiftTemp.toDate.format('mm'), shift: shiftTemp, employee: employee, dayDate: dayDate});
                                }
                                view.ToggleDropdownPickShift({currentTarget: el, pageY: window.mouse.y, pageX:window.mouse.x}, shiftList, 0, 10);
                            }
                            else
                            {
                                shiftDragSuccess = true;
                                view.UpdateShift(shift, {employeeId: employee.id}, function(){
                                    if(employeePrev)
                                    {
                                        employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                        employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                                    }
                                    shift.employeeId = employee.id;
                                    
                                    if(!employee.shiftsDate) employee.shiftsDate = {};
                                    if(!employee.shifts) employee.shifts = [];
                                    //shift.fromDate = shift.fromDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                                    //shift.toDate = shift.toDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                                    if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                                    employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                                    employee.shifts.push(shift);
                                    view.UpdateSollIstMapEntry(employee,shift);
                                    
                                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                }, function(){
                                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                });
                            }
                    }

                }
                if(window.timebars) {
                    window.timebars.forEach(t => t.$refs.overlay.toggled = false);
                }
                if(!shiftDragSuccess){
                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                }
                this.$forceUpdate();
            },
            DragEnd: function ($event, employee, indexweek, index) {
                
                if(!this.dragging) return;
                var roster = this;
                requestAnimationFrame(function(){roster.dragging = false});
                var daynum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                var monthnum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);
                var exists = employee.calendar.filter(c => c.day === parseInt(daynum) && c.month === parseInt(monthnum));
                if (exists.length === 0) {

                    if (employee === this.$refs.drag.appendedData.employee) {
                        this.$refs.drag.appendedData.date.day = parseInt(daynum);
                        this.$refs.drag.appendedData.date.month = parseInt(monthnum);
                        this.$refs.drag.appendedData = {};
                    } else {
                        this.$refs.drag.appendedData.date.day = parseInt(daynum);
                        this.$refs.drag.appendedData.date.month = parseInt(monthnum);
                        employee.calendar.push(this.$refs.drag.appendedData.date);
                        this.$refs.drag.appendedData.employee.calendar = this.$refs.drag.appendedData.employee.calendar.filter(c => c !== this.$refs.drag.appendedData.date);

                        this.$refs.drag.appendedData = {};
                    }
                    this.$forceUpdate()
                }
            },
            GetSelectedDay: function () {
                return this.dateSelectionStart.format('DD').substring(0, 2);
            },
            GetSelectedMonth: function () {
                return this.dateSelectionStart.format('MM').substring(0, 2);
            },
            GetSelectedYear: function () {
                return this.dateSelectionStart.format('YYYY').substring(0, 4);
            },
            moment: function () {
                return this.$helpers.getMomentUTC();
            },
            
            hasPreference: function (employee, indexweek, index){
                let gridWeekEntry = this.gridWeekInfo['w'+indexweek]['e'+index];
                if(!employee || employee.shiftTemplateEntry || !gridWeekEntry) return false;
                var currentDate = gridWeekEntry.date;



            },

            GetDayStatus: function (employee, indexweek, index) {
                let gridWeekEntry = this.gridWeekInfo['w'+indexweek]['e'+index];
                if(!employee || employee.shiftTemplateEntry || !gridWeekEntry) return '';
                var currentDate = gridWeekEntry.date;
                var lowerDate = (parseInt(currentDate.format('x')) < parseInt(this.dateSelectionStart.format('x')));
                var upperDate = (parseInt(currentDate.format('x')) > parseInt(this.dateSelectionStart.clone().add(1, 'month').date(0).format('x')));
                let hasShift = this.employeeMap[employee.id] && this.employeeMap[employee.id].shifts;
                let hasPreview = false;
                if(hasShift){
                    let shift = this.employeeMap[employee.id].shifts.find(s => s.fromDate.format('YYYY-MM-DD') === currentDate.format('YYYY-MM-DD'));
                    hasShift = hasShift && shift;
                    if(shift && shift.preview != null){
                        hasPreview = shift.preview;
                    }
                }
                let classes = (lowerDate || upperDate) ? 'out-of-range ' : 'in-range ';
                hasPreview ? classes += ' Yellow ' : hasShift ? classes += 'Green ' : classes +='';
                
                classes += this.GetDayAvailabilityType(employee, currentDate);
                return  classes;
                /*
                var daynum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                var monthnum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);
                var exists = employee.calendar.filter(c => c.day === parseInt(daynum) && c.month === parseInt(monthnum));
                if (exists.length > 0) {
                    return exists[0].status.label;
                } */
            },
            GetDayOptions(employee, indexweek, index) {
                var daynum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                var monthnum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);
                return [
                    {label: 'Green', color: '#6d8d22', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Yellow', color: '#e3c423', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Sick', color: '#e5154f', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Vacations', color: '#e76e13', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Remove', color: 'var(--contrast-3)', employee: employee, daynum: daynum, monthnum: monthnum}
                ];
            },
            toggleDropdownDate: function ($event, employee, indexweek, index) {
                var event = $event;
                var daynum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                var monthnum = moment(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);

                this.$refs.dropdown.posx = event.pageX;
                this.$refs.dropdown.posy = event.pageY;
                this.$refs.dropdown.items = [{label: 'Green', color: '#6d8d22'}, {label: 'Yellow', color: '#e3c423'}
                    , {label: 'Sick', color: '#e5154f'}, {label: 'Vacations', color: '#e76e13'}, {
                        label: 'Remove',
                        color: 'var(--contrast-3)'
                    }];
                this.$refs.dropdown.onceSelected = function (item) {
                    if (item.label !== 'Remove') employee.calendar.push({
                        day: parseInt(daynum),
                        month: parseInt(monthnum),
                        year: 2019,
                        status: item
                    });
                    else employee.calendar = employee.calendar.filter(c => c.day !== parseInt(daynum) && c.month !== parseInt(monthnum))
                    this.$forceUpdate()
                };
                this.$refs.dropdown.toggle();
            },
            OpenNewUnassignedShiftPopup($event, date){
                var view = this;
                var from = date.clone().hours(8).minutes(0);
                var to = date.clone().hours(16).minutes(0);
                var spotItems = [];
                Object.values(view.spotMap).forEach(s => spotItems.push({label: s.name, value: s.id}));
                var dataEntries = [
                  {label: 'From', key: 'from', hidden: false, type: 'timeframe', value: from, hours: from.hours(), minutes: from.minutes()},
                  {label: 'To', key: 'to', hidden: false, type: 'timeframe', value: to, hours: to.hours(), minutes: to.minutes()},
                  {label: 'Spot', key: 'spotId', hidden: false, type: 'searchbar', value: null, selectMultiple: false, searchbar:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectMultiple: false,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
                  {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1},
                ];
                var target = $event.currentTarget;
                this.ToggleDataFill($event, {
                    header: 'Schicht anlegen',
                    dataEntries: dataEntries,
                    pointerDirection: 1,
                    posx: 0,
                    posy: 0,
                    elRelative: target,
                    selectCallback: function (shift) {
                            
                            window.roster.CreateShift(shift);
                        }
                });

            },
            DeleteShift(shift){

            },
            AddNewShiftToMaps(shift){
                var view = this;
                let planShiftItem = {
                    id: shift.id,
                    from: shift.from,
                    to: shift.to,
                    published: shift.published,
                    publishDate: shift.publishDate
                }
                if(!view.$helpers.isBlank(shift.employeeId)){
                    planShiftItem.employee = view.employeeMap[shift.employeeId].firstName+" "+view.employeeMap[shift.employeeId].lastName;
                } else {
                    planShiftItem.employee = "";
                }
                if(!view.$helpers.isBlank(shift.spotId)){
                    planShiftItem.spot = view.spotMap[shift.spotId].name;
                } else {
                    planShiftItem.spot = "";
                }
                planShiftItem.toDate = shift.toDate = moment(shift.to, 'YYYY-MM-DDTHH:mm');
                planShiftItem.date = planShiftItem.fromDate = shift.fromDate = shift.date = moment(shift.from, 'YYYY-MM-DDTHH:mm');
                
                view.$set(view.planShiftMap, shift.id, shift);
                
                view.planshifts.push(planShiftItem);
                
                if(view.shiftTemplateView){
                    if(shift.templateId && shift.templateId !== ''){
                        var group = view.employeeGroups.find(g => g.templates && g.templates.find(t => t.id === shift.templateId));
                        if(group) {
                            var template = group.templates.find(t => t.id === shift.templateId);
                            template.linkedShifts.push(shift);
                            if(shift.employeeId){
                                group.employeesFiltered.push(view.employeeMap[shift.employeeId]);
                            } else {
                                group.employeesFiltered.push({
                                    picture: 'url(../img/default.jpg)',
                                    firstName: 'Unassigned',
                                    lastName: '',
                                    shiftTemplateUnassigned: shift,
                                });
                            }
                        }
                    }
                }

                view.$forceUpdate();
            },
            CreateShift(shift){
                
                let view = this;
                let url = '/api/sec/planshift';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift');
                let payload = {
                  storeId: this.$store.state.storeId,
                  skillMultiplier: 1,
                  workValueMultiplier:1,
                  from: view.$helpers.extractDateString(shift.from.format('YYYY-MM-DDTHH:mm'), 'YYYY-MM-DDTHH:mmZ'),
                  to: view.$helpers.extractDateString(shift.to.format('YYYY-MM-DDTHH:mm'), 'YYYY-MM-DDTHH:mmZ'),
                  historicFrom: shift.historicFrom ? view.$helpers.extractDateString(shift.historicFrom, 'YYYY-MM-DDTHH:mmZ') : '',
                  historicTo: shift.historicTo ? view.$helpers.extractDateString(shift.historicTo, 'YYYY-MM-DDTHH:mmZ') : '',
                  employeeId: shift.employeeId ? shift.employeeId : '',
                  spotId: shift.spotId ? shift.spotId : '',
                  templateId: shift.templateId ? shift.templateId : '',
                  workValue: shift.workValue ? shift.workValue : -1,
                  holidayWorkValue: -1
                }
                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    console.log(response);
                    view.AddNewShiftToMaps(response.data.data);
                }).catch(function (error) {
                    console.log(error)
                })
            },
            OpenNewShiftTemplatePopup($event, shiftTemplateGroup){
                var view = this;
                var from = this.dayModeDate.clone().hours(8).minutes(0);
                
                var to = this.dayModeDate.clone().hours(16).minutes(0);
                var dataEntries = [
                  {label: 'Group Id', key: 'groupId', hidden: true, type: '', value: shiftTemplateGroup.bUnit.id},
                  {label: 'From', key: 'from', hidden: false, type: 'timeframe', value: from, hours: from.hours(), minutes: from.minutes()},
                  {label: 'To', key: 'to', hidden: false, type: 'timeframe', value: to, hours: to.hours(), minutes: to.minutes()},
                  {label: 'Regular Only', key: 'regularOnly', hidden: false, type: 'bool', value: false},
                  {label: 'Holiday Only', key: 'holidayOnly', hidden: false, type: 'bool', value: false},
                  {label: 'Count', key: 'count', hidden: false, type: 'numeric', value: 1, min: 1, max: 10},
                  {label: 'Description', key: 'description', hidden: false, type: 'text', value: '', length: 20},
                  {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                  {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1},
                  {label: 'Week Days', key: 'weekDays', hidden: false, type: 'searchbar', value: null, selectMultiple: true, searchbar:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [
                        {label:'Monday', value: 1},
                        {label:'Tuesday', value: 2},
                        {label:'Wednesday', value: 3},
                        {label:'Thursday', value: 4},
                        {label:'Friday', value: 5},
                        {label:'Saturday', value: 6},
                        {label:'Sunday', value: 7},
                    ],
                    selectMultiple: true,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                    inheritedStyle: function inheritedStyle(el) {
                      $(el).find('input').css({
                        'box-shadow': '0 0px 0 1px #ebebeb',
                        'background': 'none'
                      });
                      $(el).find('.fa-angle-down').css({
                        'color': '#ffffff'
                      });
                      $(el).find('.fa-circle').css({
                        'color': '#d9d9d9'
                      });
                      $(el).find('.items').css({
                            position: 'absolute',
                            top: '26px',
                            left: '-1px',
                            width: 'calc(100% + 2px)',
                            'box-shadow': 'inset 0 0 0 1px #ebebeb',
                        });
                      $(el).find('.items .item:even').css({
                            background: '#e5e5e5'
                        });
                      $(el).find('.items .item:odd').css({
                            background: 'white'
                        });
                    }}},
                  {label: 'Year Days',key: 'yearDays', hidden: false, type: '', value: null},
                ];
                var target = $event.currentTarget;
                this.ToggleDataFill($event, {
                    header: 'Shift Template',
                    dataEntries: dataEntries,
                    pointerDirection: 3,
                    posx: 0,
                    posy: 0,
                    elRelative: target,
                    selectCallback: function (shiftTemplate) {
                            window.roster.CreateShiftTemplate(shiftTemplate);
                        }
                });

            },
            CreateShiftTemplate: function(shiftTemplate){
                let view = this;
                let url = '/api/sec/shifttemplate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplate');

                let payload = {
                  groupId: shiftTemplate.groupId,
                  from: view.$helpers.convertDateTimeString(null, shiftTemplate.from.format('YYYY-MM-DDTHH:mm'), 'YYYY-MM-DDTHH:mmZ'),
                  to: view.$helpers.convertDateTimeString(null, shiftTemplate.to.format('YYYY-MM-DDTHH:mm') ,'YYYY-MM-DDTHH:mmZ'),
                  regularOnly: shiftTemplate.regularOnly,
                  holidayOnly: shiftTemplate.holidayOnly,
                  count: shiftTemplate.count,
                  description: shiftTemplate.description,
                  skillMultiplier: 1,
                  workValueMultiplier:1,
                  workValue: 1,
                  holidayWorkValue: 1,
                  weekDays: shiftTemplate.weekDays ? shiftTemplate.weekDays : [],
                  yearDays: shiftTemplate.yearDays ? shiftTemplate.yearDays : [],
                }
                /*if(!this.$helpers.isBlank(this.shiftTemplate.spotId)){
                    payload.spotId = this.shiftTemplate.spotId
                }
                if(this.shiftTemplate.calculateWorkvalue){
                    payload.workValue = -1;
                } else {
                    payload.workValue = this.shiftTemplate.workValue;
                }*/

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {

                    let shiftTemplateItem = {
                        id: response.data.data.id,
                        from: response.data.data.from,
                        to: response.data.data.to,
                        regularOnly: response.data.data.regularOnly,
                        holidayOnly: response.data.data.holidayOnly,
                        count: response.data.data.count,
                        weekDays: response.data.data.weekDays,
                        yearDays: response.data.data.yearDays
                    }

                    /*if(!view.$helpers.isBlank(response.data.data.spotId)){
                        shiftTemplateItem.spot = view.spotMap[response.data.data.spotId].name;
                    } else {
                        shiftTemplateItem.spot = "";
                    }*/
                    if(view.shiftTemplateView) {
                        requestAnimationFrame(function(){
                            view.PopulateUnitGroups(true);
                        });
                    }
                }).catch(function (error) {
                    view.error=true;
                    console.log(error)
                })

            },
            ToggleDropdownPickShift: function ($event, items, indexweek, index) {
                var view = this;
                var event = $event;
                var dropdown = {};

                dropdown.posx = event.pageX;
                dropdown.posy = event.pageY;
                dropdown.items = items;
                dropdown.parentCallback = function () {
                    requestAnimationFrame(function(){
                        view.ClearEmployeeFilter();
                    });
                };
                dropdown.onceSelected = function ($event, item, dropdownReturn) {
                    var employee = item.employee;
                    var shift = item.shift;
                    var dayDate = item.dayDate;
                    var employeePrev = view.employeeMap[shift.employeeId];
                    requestAnimationFrame(function(){
                        //window.roster.filterEmployees();
                    });
                    view.UpdateShift(shift, {employeeId: employee.id}, function(){
                        if(employeePrev)
                        {
                            employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                            employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                        }
                        shift.employeeId = employee.id;
                        
                        if(!employee.shiftsDate) employee.shiftsDate = {};
                        if(!employee.shifts) employee.shifts = [];
                        shift.fromDate = shift.fromDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                        shift.toDate = shift.toDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                        if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                        employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                        employee.shifts.push(shift);
                        view.UpdateSollIstMapEntry(employee,shift);
                        
                        view.$forceUpdate()
                        view.dropdowns = view.dropdowns.filter(d => d !== dropdownReturn);
                        }, function(){
                            view.ClearEmployeeFilter();
                    });
                };
                dropdown.toggled = true;
                this.dropdowns.push(dropdown);
            },
            ToggleDropDown: function ($event, selection, offsetx, offsety) {
                if(this.dragging) return;
                var event = $event;
                var box = $event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    onceSelected: function ($eventInner, item, dropdown) {
                        var eventInner = $eventInner;
                        var boxInner = eventInner.currentTarget.getBoundingClientRect();
                        if (item.label !== 'Remove') item.employee.calendar.push({
                            day: parseInt(item.daynum),
                            month: parseInt(item.monthnum),
                            year: 2019,
                            status: item
                        });
                        if (!item.items) return;
                        var temp = {
                            items: item.items,
                            //el: event.currentTarget,
                            offsetx: offsetx + 130,
                            offsety: offsety,
                            posx: box.left + offsetx + 130,
                            toggled: true,
                            posy: boxInner.bottom - 30,
                            pointerDirection: 3,
                            parentCallback: function () {
                                dropdown.toggled = false
                            }
                        };
                        dropdowns.push(temp);
                    }
                });
            },
            ToggleDropDownContainer: function ($event, employee, type, offsetx, offsety, pointerOffset, pointerDirection) {
                var el = $event.currentTarget;
                var date = moment(el.attributes['year'].value + '-' +el.attributes['month'].value + '-' +el.attributes['day'].value, 'YYYY-MM-DD');
                if(this.dragging || !this.HasShift(employee, date)) return;
                this.$refs.dropdowncontainer.Init({
                    elRelative: el,
                    remainAfterSelect: true,
                    eventProp: this.GetTimeBarProp(employee, date, true),
                    currentComponent: type,
                    pointerDirection: pointerDirection,
                });
            },

            ToggleDataFill: function ($event, settings) {
                var box = $event.currentTarget.getBoundingClientRect();
                var target = $event.currentTarget;

                this.$refs.dropdowncontainer.Init({
                    elRelative: settings.elRelative,
                    data: settings.dataEntries,
                    header: settings.header,
                    currentComponent: 'datafill',
                    remainAfterSelect: false,
                    pointerOffset: (settings.pointerOffset && settings.pointerOffset !== 0) ? settings.pointerOffset : 15,
                    pointerDirection: (settings.pointerDirection && settings.pointerDirection !== 0) ? settings.pointerDirection : 0,
                    onceSelected: settings.selectCallback,
                });
                //this.$refs.dropdowncontainer.Toggle();
            },
            onTimebarUpdateShift(data){
                
                let view = this;
                if(data.clearEmployeeFilter){
                    this.UpdateShift(data.shift, data.fields, function(){setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);}, function(){setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);});
                } else {
                    this.UpdateShift(data.shift, data.fields);
                }
            },
            UpdateShift(shift, fields, responseCallback, errorCallback){

                this.error=false;
                let view = this;
                let url = '/api/sec/planshift';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift');
                let payload = {
                  storeId: this.$store.state.storeId,
                  id: shift.id,
                  updateFields: []
                }
                for(let key in fields){
                    let value = fields[key];
                    payload[key] = value;
                    payload.updateFields.push(key);
                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    const index = view.planshifts.findIndex(s => s.id === shift.id)
                    const index2 = view.shiftsSelected.findIndex(s => s.id === shift.id)  
                    for(let key in fields){
                        
                        view.$set(view.planShiftMap[shift.id], key, fields[key]);
                        if (~index) {
                            
                            view.$set(view.planshifts[index], key, fields[key]);
                            
                        } 
                        if (~index2) {
                            
                            view.$set(view.shiftsSelected[index2], key, fields[key]);
                            
                        } 
                        
                    }
                    if(responseCallback) {
                        responseCallback();
                    }
                    view.UpdateTimeTableBorders([]);
                }).catch(function (error) {
                    if(errorCallback) {
                        errorCallback();
                    }
                    view.error=true;
                    console.log(error)
                });
                if(view.shiftTemplateView) {
                    requestAnimationFrame(function(){
                        view.PopulateUnitGroups(true);
                    });
                }
            },
        },
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        cursor: default;
        user-select: none;
        /*opacity: 1!important;*/
    }

    html {
        height: 100%;
        width: 100%;
        /*
        transform: scale(0.8) translateX(-6%) translateY(-6%);*/
    }

    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .icon-main {
        background: var(--contrast-2) url('~@/assets/icon.png');
        background-size: 100%;
        float: left;
        margin: 5px 0 0 0 !important;
        height: 70px;
        width: 70px;
        border-radius: 15px;
        margin-right: 60px !important;
    }

    .icons-left {
        width: 566px;
        text-align: left;
    }

    .icons-left > *:nth-child(1), .icons-left > *:nth-child(2), .icons-left > *:nth-child(3) {

        background: var(--contrast-2) url('~@/assets/icon.png') !important;
        background-size: 60% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;
        filter: saturate(0%);
    }

    .icons-left > * {

        width: 35px !important;
        height: 35px !important;
        margin: 0 5px !important;
    }

    .icons-left > .divider {

        width: 1px !important;
        height: 35px !important;
        margin: 0 5px !important;
        background: none;
        border-right: 1px solid var(--contrast-5);
        border-radius: 0;
    }

    .icons-calender {
        width: 190px;
        margin-top: -8px !important;
        margin-left: 0px;
    }


    .icons-calender * {
        cursor: pointer;
    }
    .icons-calender * > .fas {
        color: var(--color-button);
    }
    .nightmode .icons-calender .fas {
        color: var(--contrast-4) !important;
    }
    .nightmode .icons-calender .fa-circle,.icons-calender .fa-circle {
        color: var(--contrast-2) !important;
    }

    .week-days {

    position: absolute;
    left: 10px;
    top: 15px;
    }
    .week-days > *{
        float: left;
        width: 40px;
        line-height: 190%;
        font-size: 12px;
        border: 1px solid var(--contrast-5) !important;
        color: var(--contrast-4);
        font-weight: 800;
        text-align: center;
        border-radius: 0 !important;
        margin: 0 !important;
        border-right: none !important;
        height: 27px !important;
        cursor: pointer;
        transition: .2s;
    }

    .week-days > *.toggled, .week-days > *:hover {
        background: #6d8d22 !important;
        color: var(--bg);
    }
    .week-days > *:last-child{

        border-radius: 0 5px 5px 0 !important;
        border-right: 1px solid var(--contrast-5) !important;
    }
    .week-days > *:first-child{
        border-radius: 5px 0 0 5px !important;
    }

    .icons-weekly {
        width: 285px;
        margin-top: 9px !important;
    }

    .icons-weekly > * {
        margin: 0 !important;
        border-radius: 0 !important;
        height: 20px !important;
        padding-top: 3px;
        font-weight: 800;
        color: var(--color-button);
        font-size: 9px;
        text-align: center;
        width: 35px !important;
        cursor: pointer;
    }



    .icons-weekly > *:nth-child(1) {
        margin: 0 !important;
        border-top-left-radius: 5px !important;
        border-bottom-left-radius: 5px !important;
    }

    .icons-weekly > *:nth-child(1), .icons-weekly > *:nth-child(2), .icons-weekly > *:nth-child(3), .icons-weekly > *:nth-child(4) {
        border-right: 1px solid var(--contrast-5) !important;
    }
    .header.day-mode .icons-weekly > * {
        border: 1px solid var(--contrast-5) !important;
        color: var(--contrast-4);
    }
    .header.day-mode .icons-weekly > .toggled {
        background: #6d8d22;
        color: var(--bg);
    }
    .header.day-mode .icons-weekly > *:nth-child(1), .header.day-mode .icons-weekly > *:nth-child(2), .header.day-mode .icons-weekly > *:nth-child(3){
        border-right: none !important;
    }

    .icons-weekly > *:nth-child(4){
        margin: 0 !important;
        border-top-right-radius: 5px !important;
        border-bottom-right-radius: 5px !important;
    }

    .header:not(.day-mode) .icons-weekly > *:last-child {
        margin-left: 10px !important;
        border-radius: 5px !important;
        background: var(--contrast-4) !important;
    } 

    .icons-right {
        float: right;
        width: 11%;
        padding-left: 15px;

    }

    .icons-right > * {
        color: var(--bg);
        width: 80px !important;
        background: var(--contrast-5) !important;
        height: 20px !important;
        margin-top: 15px !important;
        font-size: 10px;
        font-weight: 600;
        text-align: center;
        padding-top: 2px;
    }

    .icons-right > .selected {
        color: var(--bg);
        background: var(--contrast-3) !important;
    }


    .employees {
        position: absolute;
        height: calc(100vh - 115px);
        border-right: 1px solid var(--sub-menu);
        padding: 5px;
        padding-top: 13px;
        width: 140px;
        height: calc(100vh - 145px);
        overflow: hidden;
        z-index: 2;
        background: var(--bg);
    }

    .employees .scrollbar-container {
        overflow: scroll !important;
        width: calc(100% + 16px) !important;
        padding: 0 5px;
    }
    .employee:first-child {
        /*margin-top:50px;*/
    }

    .employee {
        width: 100%;
        box-shadow: inset 0 -.60px 0 -.50px var(--sub-menu);
        /*height: 60px;*/
        height: 4.380px;
        display: inline-block;
        position: relative;
        margin-bottom: 10px;
        cursor: pointer;
        transition: .2s;
        padding: 10px;
        padding-bottom: 30px;
        padding-top: 0;
        padding-left: 40px;
        border-radius: 5px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
		opacity: 1;
    }

    .show  *{
        transition: 0s;
    }

    .indentationLevelEmployee0{
        width: 230px;
        margin-left: 0px;
    }
    .indentationLevelEmployee1{
        width: 210px;
        margin-left: 20px;
    }

    .grid .employee{
        position: absolute;
        left: -20px;
        margin-top: 6px;
    }

    .grid .entry:last-child .employee{
        height: 44px;
    }

    .day-mode .grid .employee{
        z-index: 2;
        background: var(--bg);
        transition: 0s;
    }

    .day-mode .grid .week{
        border: none;
    }

    .employees .employee:last-child{
        margin-bottom: 20px;
    }

    .grid .employee{
        height: 45px;
        margin-bottom: 5px;
        box-shadow: inset 0 -2px 0 -1px var(--grid-shadow);
    }

    .grid .employee:hover {
        background: var(--contrast-2);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none;
    }

    .grid .employee * {
        cursor: pointer;
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
        cursor:  grab !important;
    }

    .employee .namefirst {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
    }

    .employee .namelast {
        font-size: 11px;
        color: var(--contrast-4);
        text-align: left;
		height: 15px;
        white-space: nowrap;
    }

    .employee .progressbar {
        position: absolute;
        width: calc(100% - 10px);
        right: 0;
        margin: auto;
        bottom: 5px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 0;
        overflow: hidden;
    }

    .employee .progressbar .progressfill {
        position: absolute;
        width: 50%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .grid:not(.preload) .entry.header{
        position: absolute;
        z-index: 1;
        top: -5px;
        background: var(--bg);
        margin-left: -10px;
    }
    .grid.preload .entry .week{

        transform: translateY(0px);
    }
    .grid.preload .entry .date{
    display: none;
    }


    .grid:not(.preload) .entry.header .day{
        margin-top: 32px;
    }

    .grid .entry.header .day {
        position: relative;
		opacity: 1 !important;
        padding-bottom: 0;
        height: 40px;
        width: 40px;
        margin: 5px;
        cursor: pointer !important;
    }
    .grid .entry.header .day:not(:last-child) .border-day{
        position:absolute;
        width: 1px;
        top: 4px !important;
        right: -6px;
        height: 10000px;
        margin-bottom: -10000px;
        top: -27px;
        border-right: 1px solid var(--contrast-3);
    }
    .grid .entry.header .day:last-child .border-day{
        position:absolute;
        width: 1px;
        top: 4px !important;
        right: -6px;
        height: 10000px;
        margin-bottom: -10000px;
        top: -27px;
        border-right: 1px solid var(--contrast-5) ;
    }
    .day-mode .grid .entry.header .day .border-day{
        opacity: 0;
    }
    .grid .entry.header .day *{
        cursor: pointer !important;
    }

    .grid .entry.header .name {
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
    }
    .grid .entry.header .income {
        width: calc(100% + 10px);
        position: absolute;
        bottom: -30px;
        font-size: 10px;
        background: transparent;
        border-top: 1px solid var(--contrast-3);
        height: 25px;
        left: -5px;
        padding-top: 3px;
        text-align: center;
        z-index: -1;
    }
    .grid .entry.header .weather {
        width: calc(100% + 11px);
        position: absolute;
        top: -22px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -6px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: -1;
    }
    .grid .entry.header .weather .label{
        font-family: DistrictProLight;
        pointer-events: none;
        font-weight: 200;
        color: var(--contrast-4);
    }
    .grid .entry.header .weather .picture{

        width: 15px;
        margin-top: 2px;
        margin-left: 5px;
        height: 15px;
        display: inline-block;
        pointer-events: none;
        float: left;
    }
    .grid .entry.header .day:first-child .income {
        width: calc(100% + 11px);
        left: -6px;
    }
    .grid .entry.header .day .income .income-bar {
        position: absolute;
        border-radius: 100px;
        height: 8px;
        left: 5px;
        top: 9px;
    }
    .grid .entry.header .day .income .income-bar.red{
        background: #e51c50;
    }
    .grid .entry.header .day .income .income-bar.gray{
        background: var(--contrast-3);
    }

    .grid .entry.header .day .income .income-bar.green{
        background: #6d8d21;
    }

    .grid .entry.header .date {

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
    }

    .grid {
        position: absolute;
        padding-left: 250px;
        margin-top: -5px;
        /* overflow: scroll; */
        text-align: left;
        width: 100vw;
        height: 100%;
        padding-top: 50px;
    }

    .grid.show{
        width: calc(100vw);
        left: 0;
        padding-left: calc(230px + 237px + (10px * 2));
    }


    .show .entry.group{

        padding-left: calc(230px + 237px + (10px * -2));
        margin-left: calc(-1 * (230px + 237px + (10px * -1)));
    }
    .show .entry.group > .header{
        margin-left: calc(-1 * (230px + (10px * .5) + 237px + (10px * 0)));

    }

    .grid .week {
        float: left;
        height: 100%;
        /*width: calc(100% / 4);*/
        margin-right: 1px;
    }

    .grid .day {
        float: left;
		opacity: 0;
        position: relative;
        border-radius: 10px;
        transition: .2s;
		transform: scale(1);
        cursor: pointer;
        height: 40px;
        width: 40px;
        margin: 5px;
        margin-left: 6px !important;
    }

    .grid .entry,.grid .entry .week{
        float: none;
        width: initial;
        display: inline-block;
        white-space: nowrap;
        height: 50px;
        margin-bottom: -6px;

    }

    .grid .entry{
        display: block;
        margin-bottom: 0px;
    }

    .entry:not(.header) .day {

        background: var(--contrast-1);
    }
    .day * {

        cursor: pointer;
    }

    .grid .entry:not(.header) .day:hover {
        transform: scale(1.3);
        /*background: lightgray;*/
        z-index: 10;
    }

    .grid .entry.header .day {
        cursor: default;
    }
    .grid .entry.header .day * {
        cursor: default;
    }

    .grid .day.Green {
        background: #6d8d22;
        transform: scale(1.1);
    }

    .grid .day.Green * {
        background: #c1e077 !important;
    }

    .grid .day.Green *.date {
        background: #879d53!important;
    }

    .grid .day.Yellow {
        transform: scale(1.1);
    }
    .grid .day.Yellow * {
        background: #e3c423 !important;
    }
    .grid .day.Yellow *.date {
        background: #9f8918 !important;
    }

    .grid .day.Sick {
        background: var(--contrast-1) url('~@/assets/sick.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e5154f;
        transform: scale(1.1);
    }

    .grid .day.Sick * {
        display: none;
    }

    .grid .day.Vacations {
        background: var(--contrast-1) url('~@/assets/vacation.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e76e13;
        transform: scale(1.25);
    }

    .grid .day.Vacations * {
        display: none;
    }

    .grid .day.Remove {
        background: var(--contrast-3);
    }

    .grid .entry .name {
        float: left;
        height: calc(50% + 1px);
        width: 100%;
        left: 0;
        margin-bottom: -1px;
        bottom: 0;
        right: 0;
        text-align: center;
        font-size: 10px;
        background: var(--contrast-6);
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        padding-top: 3px !important;
    }

    .grid .entry .date {
        float: left;
        height: 50%;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        background: var(--sub-menu);
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 3px !important;
    }

    .grid .entry:not(.header) .name{
        position: absolute;
        top: 0;
        bottom: initial;
        height: 50%;
        line-height: 14px;
    }

    .grid .entry:not(.header) .date{
        position: absolute;
        bottom: 0;
        top: initial;
        line-height: 14px;
    }

    .employee-data {
        position: absolute;
        left: calc(-1 * (230px + 10px));
        height: calc(100vh - 124px);
        padding: 15px;
        padding-top: 5px;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        -webkit-transition: .2s;
        transition: .2s;
        opacity: 0;
        /* bottom: 0; */
        top: 0;
        overflow-y: scroll;
        z-index: 3;
        pointer-events: none;
    }
    .show .employee-data {
        transition: 0s;
        pointer-events: initial;
    }
    .time-table {
        position: fixed;
        left: calc(100vw);
        height: calc(100vh - 115px);
        padding: 15px 0;
        padding-top: 5px;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        -webkit-transition: .2s;
        transition: .2s;
        opacity: 0;
        /* bottom: 0; */
        top: 144px;
        overflow-y: scroll;
        z-index: 2;
    }

    .time-table{
        width: calc(100vw - 200px);
        background: var(--bg);
        opacity: 1;
        padding-bottom: 70px;
    }

    .time-table .table{
        position: relative;
        width: calc(100%);
        float: left;
        height: 50px;
        top: 40px;
        overflow: hidden;
    }
    .show-unassigned .time-table .table{
        width: calc(100% - 300px);
    }

    .time-table .table:last-child{
        margin-bottom: 20px;
    }


    .employee-data.show {
        left: calc((230px + 10px));

        opacity: 1;

    }
    .time-table.show
    {

        left: calc(200px);
    }

    .employee-data > * {
        border-bottom: 1px solid var(--contrast-5);
    }

    .employee-data > *:first-child {
        border-bottom: none;
    }

    .employee-data > .employee {
        height: 90px;
        padding-left: 75px;
        opacity: 1 !important;
    }

    .employee-data > .employee .picture {

        height: 65px;
        width: 65px;
        border-radius: 12px;
        left: -1px;
    }

    .employee-data > .employee .progressbar {
        width: 115px;
        left: initial;
        top: 60px;
    }

    .employee-data > .employee .bonus {
        position: absolute;
        top: 43px;
        left: 73px;
    }

    .employee-data > .employee .bonus .entry {
        margin: 0;
        height: 10px
    }

    .employee-data > .employee .bonus .left {
        font-size: 10px;
        width: 60px;
        float: left;
        text-align: left;
    }

    .employee-data > .employee .bonus .right {
        font-size: 10px;
        float: right;
        width: 44px;
        text-align: left;
    }

    .employee-data > .employee .slideshow {
        position: absolute;
        text-align: center;
        top: 61px;
        left: 17px;
    }

    .employee-data > .employee .slideshow .marker {
        background: var(--contrast-2);
        position: relative;
        display: inline-block;
        border-radius: 100px;
        height: 5px;
        width: 5px;
        margin: 0 2px;

    }

    .employee-data > .employee .slideshow .marker.selected {
        background: #6d8d22;
    }

    .employee-data > .employee .namefirst {

        font-size: 17px;
    }

    .employee-data > .employee .namelast {

        font-size: 18px;
    }

    .employee-data .entry .label {
        float: left;
        color: var(--contrast-5);
        font-size: 11px;
        padding-top: 3px;
    }

    .employee-data .entry .icon {
        float: right;
        background: var(--contrast-4);
        height: 15px;
        width: 15px;
        margin-top: 2px;
        border-radius: 100px;
        margin-right: 2px;
    }

    .employee-data .entry .icon.send {
        height: initial;
        width: initial;
        border-radius: 100px;
        color: var(--bg);
        font-size: 12px;
        padding: 3px 8px;
    }

    .employee-data .entry > .fas, .employee-data .entry > .fa-stack{
        margin-top: 4px;
        margin-right: 5px;
    }

    .employee-data .entry > .fas, .employee-data .entry > .fa-stack{
        float: right;
    }

    .employee-data .store .entry > .fas, .employee-data .store .entry > .fa-stack{
        float: left;
    }

    .checkbox.false:before{
        content: "\f111";
    }

    .employee-data .entry {
        margin: 1px 0;
    }

    .employee-data .section {
        margin-bottom: 5px;
    }

    .employee-data > .title .label {
        font-weight: 700;
        font-size: 14px;
        color: #6d8d22;
        float: right;
        transform: translateY(2px);
    }



    .disabled {
        cursor: none !important;
        pointer-events: none !important;
        opacity: .3 !important;
    }

    .entry {

        float: left;
        width: 100%;
        display: inline-block;
    }


    .section .entry {
        float: none;
    }

    .icon.dropdownmarker:after {
        display: inline-block;
        content: '\276F';
        transform: rotate(90deg) translateX(-20%) translateY(-4%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.leftmarker:after {
        display: inline-block;
        content: '\276F';
        transform: scaleX(-1) translateX(0%) translateY(-16%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.rightmarker:after {
        display: inline-block;
        content: '\276F';
        transform: translateX(0%) translateY(-16%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.plus:after {
        display: inline-block;
        content: '+';
        color: var(--bg);
        font-weight: 400;
        transform: translateX(-7%) translateY(-8%);
        font-size: 15px;
    }

    .icon.ticked:after {
        display: inline-block;
        content: '✔';
        color: var(--bg);
        font-weight: 400;
        transform: translateX(-0%) translateY(-20%);
        font-size: 11px;
    }

    .icon.menu {

        background: none !important;
    }

    .icon.menu:after {
        display: inline-block;
        content: '☰';
        color: var(--contrast-6);
        font-weight: 800;
        transform: translateX(-0%) translateY(-25%);
        font-size: 19px;
    }


    .mockup {
        position: fixed;
        top: 0;
        left: 0;
        height: 1080px;
        width: 1920px;
        background-size: 100%;
        opacity: .5;
        z-index: 10000;
        pointer-events: none;
        display: none;
    }

    .drag.Green {
        background: #6d8d22;
    }

    .drag.Yellow {
        background: #e3c423;
    }

    .drag.Sick {
        background: var(--contrast-1) url('~@/assets/sick.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e5154f;
    }

    .drag.Sick * {
        display: none;
    }

    .drag.Vacations {
        background: var(--contrast-1) url('~@/assets/vacation.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e76e13;
    }

    .drag.Vacations * {
        display: none;
    }

    .drag.Remove {
        background: var(--contrast-3);
    }
    .entry.half {
        width: 50%;
    }

    .entry.half .label {
        float: left;
        text-align: left;
    }

    .entry.half .label:nth-child(3) {
        padding-left: 10px;
    }

    .entry.half .icon {
        float: left;
    }

    .entry.half .icon:nth-child(4), .entry.half .send {
        float: right;
    }

    .entry.half .fa-stack{
        float: right;
    }

    .icon.left {
        float: left !important;
    }


    .icon.right {
        float: right !important;
    }

    .addperson {
        background: var(--contrast-2) !important;
        background: url('~@/assets/addperson.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
    }

    .graph {
        background: var(--contrast-2) !important;
        background: url('~@/assets/graph.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
    }

    .calendar {
        background: var(--contrast-4) url('~@/assets/calendar.png') !important;
        background-size: 60% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;

    }

    .addtimeslot {
        background: var(--contrast-2) url('~@/assets/addtimeslot.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .managetimeslots {
        background: var(--contrast-2) !important;
        background: var(--contrast-2) url('~@/assets/managetimeslots.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .scanid {
        background: var(--contrast-2) !important;
        background: var(--contrast-2) url('~@/assets/scanid.png') !important;
        background-size: 75% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .vacation {
        background: var(--contrast-2) url('~@/assets/vacationmono.png') !important;
        background-size: 80% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;
    }

    .icons-calender .calendar {
        filter: saturate(0%);
        transition: .2s;
        width: 25px !Important;
        height: 25px !Important;
        margin-top: 00px !important;
        margin-bottom: 5px !important;
        margin-left: 4px !important;
        margin-right: 3px !important;

        border-radius: 3px !important;
    }

    .icons-calender .calendar:hover {
        filter: saturate(100%);
    }

    .icons-calender .dropdownmarker {

        width: 15px !important;
        height: 15px !important;
        border-radius: 100px !important;
        position: absolute;
        margin-top: 8px !important;
        margin-left: -17px !important;
        background: var(--contrast-5);
    }

    .icons-calender .leftmarker, .icons-calender .rightmarker {

        width: 20px !important;
        height: 20px !important;
        border-radius: 100px !important;
        background: var(--contrast-5);
    }

    .icons-calender .leftmarker:after {

        transform: translateX(55%) translateY(-09%) scaleX(-1) !important;
    }

    .icons-calender .rightmarker:after {

        transform: translateX(55%) translateY(-10%) !important;
    }

    .icons-calender .dropdownmarker:after {

        display: inline-block;
        content: '\276F';
        -webkit-transform: rotate(90deg) translateX(-40%) translateY(-1%);
        transform: rotate(90deg) translateX(-65%) translateY(-23%);
        color: var(--bg);
        font-size: 11px;
    }


    .icons-calender > .datepicker {
        background: var(--contrast-4) url('~@/assets/calendar.png') !important;
        background-size: contain !important;;
        background-repeat: no-repeat !important;;
        background-position: 50% !important;;
        position: relative;
        height: 25px !important;
        width: 25px !important;
        display: inline-block;
        cursor: pointer;
        margin: 7px 0 0 5px !important;;
        top: 7px;
        box-shadow: 0 0 0 1px var(--contrast-4);
        border-radius: 2px !important;;
        filter: saturate(0%);
        opacity: .5;
        transition: .2s;
    }

    .icons-calender > .datepicker.selected {
        opacity: 1;
        filter: saturate(100%);
    }

    .icons-calender > .datepicker:hover {
        filter: saturate(100%);
        opacity: 1;
    }

    .fa-stack {
        cursor: pointer;
        width: 15px;
        height: 15px;
    }
    .fa-stack.add {
        cursor: pointer;
        width: 15px;
        height: 15px;
    }

    .fa-stack.time-pick {
        position: absolute;
        margin-top: 21px;
        margin-left: -18px;
        width: 15px;
        height: 15px;
    }

    .fa-stack * {
        font-size: 16px;
    }
    .fa-stack.add * {
        font-size: 16px;
    }


    .fa-stack.time-pick * {
        font-size: 14px;
    }

    .fa-stack .fa-circle {
        color: var(--contrast-5);
    }
    .fa-stack.add .fa-circle {
        color: var(--contrast-5);
    }

    .fa-stack .fa-plus{
        transform: scale(.7) translateX(1px);
    }
    .fa-stack.add .fa-plus{
        transform: scale(.7) translateX(1px);
    }

    .entry.half .icon.send{
        margin-top: 4px;
        margin-bottom: -4px;
    }

    .app {
    }

    .app .scrollbar-container{
        top: initial;
        height: 100%;
        width: calc(100vw);
    }
   

    .app .scrollbar-container.show{
        width: calc(100vw - 1px);
        /*left: 88px;*/
    }

	.app.loading-roster > *{
		filter: blur(1px);
	}

   .app .loading{
	filter: none !important;
    position:absolute;
    box-sizing:content-box;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh);
    background: rgba(0,0,0,.5);
  }
  .loading .fa-spinner{
    position:absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: var(--contrast-3);
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }

  .day.fade-in,.employee.fade-in{
  opacity: 1;
    animation-name: fade-in;
    animation-duration: 200ms;
    animation-timing-function: ease-out;
  }

    .employees.faded-in .employee{
        opacity: 1;
    }

  .preload{
    pointer-events: none;
  }
  .grid.preload{
    overflow:hidden;
  }


  .preload .day, .preload .employee{
	opacity: 1;
  }

  .preload .entry:not(.header) .day{

	/*background: rgb(169, 169, 169);*/
	}

	.preload .employee{
		margin: 0;

    margin-top: -1px;
    transform: translateY(1px);
	}

  /*.preload .fade-out,.preload .fade-out{
  opacity: 0;
    animation-name: fade-out;
    animation-duration: 200ms;
    animation-timing-function: ease-out;
  }*/
  .preload .day.fade-out{

    opacity: 0;
    animation-name: fade-out !important;
    animation-duration: 200ms !important;
    animation-timing-function: ease-out !important;
  }


  .preload .fade-out .header .label{
    animation: fade-out-label forwards;
        animation-delay: 100ms;
        animation-duration: 500ms;
    animation-timing-function: ease-out;
  }
  .preload .fade-out .header .fa-stack{
        animation: fade-out-label-stack forwards;
        animation-delay:100ms;
        animation-duration: 500ms;
        animation-timing-function: ease-out;
     }

  @keyframes fade-out-label {
    from {
       opacity: 1;
       transform: translateX(0px);
    }
    to {
       transform: translateX(300px);
       opacity: 0;
    }
  }

  @keyframes fade-out-label-stack {
    from {
       opacity: 1;
        right: 5px;
    }
    to {
        right: -100px;
       opacity: 0;
    }
  }

  @keyframes fade-in {
    from {
	opacity: 0;
      transform:translateX(-30px) translateY(-30px);
    }
    to {
	opacity: 1;
      transform:translateX(0px) translateY(0px);
    }
  }
  @keyframes fade-out {
    from {
	opacity: 1;
    }
    to {
	opacity: 0;
    }
  }

  .day.out-of-range{
    opacity: .5 !important;
    pointer-events: none;
  }
  .day.unavailable{
    opacity: .5 !important;
    pointer-events: none;
  }
  .day.in-range{
    opacity: 1 !important;
  }

  .day i{
    position: absolute;
    font-size: 12px;
    right: -3px;
    bottom: -3px;
    z-index: 1;
    border-radius: 100px;
  }

  .day.Green i{
    position: absolute;
    font-size: 12px;
    right: -3px;
    top: -3px;
    z-index: 1;
    height: 12px;
    border-radius: 100px;
  }

  .day i:nth-child(2){
    top: 8px;
  }
  .day i:nth-child(3){
    top: 19px;
  }


  .time-table .time-bar-new{
    top: -10px;
    overflow: hidden;
    height: 57px;
    width: calc(100% - 10px);
    z-index: initial;
  }
  .shifts .time-bar-new{
    top: 0;
    overflow: hidden;
    width: 100%;
    border-radius: 10px;
    height: 60px;
    padding-top: 10px;
      background: var(--bg);
  }
  .shifts .shift.selected .time-bar-new{
        box-shadow: 4px 4px 5px 3px rgba(0,80,0,0.2);
  }
  .shifts{
    position: fixed;
    right: -300px;
    width: 300px;
    height: calc(100vh - 126px);
    top: 109px;
    background: var(--bg);
    z-index: 5;
    padding: 10px;
    transition: .2s;
  }

  .show-unassigned .shifts{
    right: 0;
  }

  .shifts-toggle{
    width: 30px;
    height: 30px;
    position: fixed;
    right: 0px;
    cursor: pointer;
    font-weight: 600;
    color: rgba(0,0,0,.3);
    transition: .2s;
    margin-top: -3px;
  }

  .show-unassigned .shifts-toggle{
    right: 270px;
    transform: scaleX(-1);
  }

  .shifts .label{
    width: calc(100% - 10px);
    text-align: center;
    font-size: 16px;
    height: 36px;
    box-shadow: inset 0 -2px 0 -1px rgba(0,0,0,.3);
  }

    .shifts .shift{
        position: relative;
        width: 100%;
        float: left;
        margin-top: 5px;
  }

    .shifts .shift.add{
        cursor: pointer;
  }

    .shifts .shift > .label{
    background: var(--bg);
    -webkit-box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
    box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
    border-radius: 10px;
    font-weight: 200;
    line-height: 210%;
    pointer-events: none;
  }

  .header .day.unnassigned
  {
    /*background: rgb(255, 255, 185);*/
  }
  .header .day.today
  {
    background: #6d8d21;
    box-shadow: 2px 2px 0 3px #6d8d21, -2px 2px 0 3px #6d8d21;
    border-radius: 0;
  }
  .header .day.today:first-child
  {
    background: #6d8d21;
    box-shadow: 2px 2px 0 3px #6d8d21, -3px 2px 0 3px #6d8d21;
    border-radius: 0;
  }
  .header .day.today *:not(.income)
  {
    color: white;
  }
  .header .day .unnassigned-marker
  {
    display: none;
  }
  .header .day.unnassigned .unnassigned-marker
  {
    display: inline-block;
    background: rgb(238, 238, 59);
    border-radius: 50px;
    height: 12px;
    width: 12px;
    font-size: 9px;
    text-align: center;
    padding-top: 2px;
    bottom: -4px;
    right: -4px;
    position: absolute;
    line-height: 110%;
  }
  .header .day.today.unnassigned .unnassigned-marker
  {
    background: rgb(193, 224, 119);
    color: black;
  }

  .day.border-red{
    box-shadow: 0 0 0 2px rgba(155, 0, 0, .5);
  }
  .day.border-green{
    box-shadow: 0 0 0 2px rgba(0, 180, 0, .3);
  }
  .day.border-yellow{
    box-shadow: 0 0 0 2px rgba(220, 200, 0, .7);
  }

  .table.border-red{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
  .table.border-green{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
  .table.border-yellow{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
    .grid .table{
        display: none;

        left: 0px;
    }

    .grid .table .time-bar-new{
        height: 50px;
        margin-top: -9px;
    }

    .day-mode .grid .table{
        position: absolute;
        left: 280px;
        display: initial;
        overflow: hidden;
        width: calc(100vw - 610px);
        background: var(--bg);
        margin-top: 0px;
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow);
    }
    .day-mode .grid .entry:not(.header){
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow);
    }
    .day-mode .grid .entry:last-child{
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow), inset 0 -2px 0 -1px var(--grid-shadow);
    }
    .day-mode .grid .entry:last-child .table{
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow), inset 0 -2px 0 -1px var(--grid-shadow);
        height: 50px;
    }
    .day-mode .grid .entry.group{
        box-shadow: none;
    }

    .hour-grid{
        position: fixed;
        right: 10px;
        top: 110px;
        width: calc(100vw - (230px + 10px + 10px));
        height: 100%;
        z-index: 1;
        padding: 30px 10px 0;
    }

    .show .hour-grid{
        width: calc(100vw - (230px + 10px + 237px + 10px));
        right: 10px;
    }
    .show.show-unassigned .hour-grid{
        width: calc(100vw - (230px + 10px + 300px + 10px + 237px));
        right: calc(300px + 10px);
    }
    .show-unassigned .hour-grid{
        width: calc(100vw - (230px + 10px + 300px + 10px));
        right: calc(300px + 10px);
    }
    .day-mode .grid .table{
        width: calc(100vw - (228px + (10px * 4)));
        left: calc(230px + (10px * -1));
    }
    .day-mode .grid.show .table{
        width: calc(100vw - (230px + (10px * 4) + 237px));
        left: calc(230px + (10px * -1) + 237px);
    }
    .day-mode .show-unassigned .grid.show .table{
        width: calc(100vw - (230px + (10px * 4) + 237px + 300px + 10px));
        left: calc(230px + (10px * -1) + 237px);
    }
    .day-mode .show-unassigned .grid .table{
        width: calc(100vw - (220px + (10px * 4) + 300px + 10px));
        left: calc(230px + (10px * -1));
    }

    .time-marks{
        width: 100%;
        height: 100%;
        display: inline-block;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        float: left;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px var(--contrast-1);
        background: none;
    }
    .hour-grid.full-half .time-marks .mark{
        width: calc(100% / 36);
    }
    .hour-grid.full .time-marks .mark{
        width: calc(100% / 24);
    }
    .hour-grid.half .time-marks .mark{
        width: calc(100% / 12);
    }
    .hour-grid.quarter .time-marks .mark{
        width: calc(100% / 6);
    }
    .time-marks .mark.am{
    }
    .time-marks .mark .quarter{
        position: relative;
        display: inline-block;
        width: 8px;
        border-radius: 100px;
        height: 8px;
        margin: 0 1px;
    }

    .red{
        background: #e51c50;
    }

    .orange{
        background: #e86d1d;
    }

    .green{
        background: #6d8d21;
    }

    .gray{
        background: #ccc;
    }

    .entry.group{
        height: initial;
        width: 100%;
        position: relative;
        margin-left: -220px;
        padding-left: 210px;
        padding-bottom: 05px;
        transition: .2s;
        top: 25px;
    }

    .entry.group.collapsed{
        height: 25px;
        padding-bottom: 0px;
    }
    .entry.group > .header{
        position: relative;
    width: 230px;
    height: 40px;
    margin-left: -235px;
        margin-bottom: -16px;
        transform: translateY(4px);
        overflow: hidden;
    }

    .business-sort .entry.group:not(.business) > .header{
        height: 40px;
        margin-left: -230px;
    }

    .entry.group.collapsed > .header{
    }

    .indentationLevel0{
        width: 100%;
    }
    .indentationLevel1{
        width: 90%;
        margin-left: 10%;
    }
    .entry.group > .header .label{
        /* h-employee-groups */
        color: #efefef;
        background: #6d8d23;
        font-size: 13px;
        border-radius: 100px;
        padding: 0 25px;
        height: 19px;
        margin-top: -1px;
        transition: .2s;
    }
    .entry.group.collapsed > .header .label{
        background: var(--contrast-6);
    }

    .entry.group.collapsed > .header .helper{
        background: var(--bg);
        border: dashed 1px var(--contrast-5);
        margin-top: 0px;
        color: var(--contrast-4);
    }
    .entry.group.collapsed > .header .helperDroppable{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        margin-top: 0px;
        color: var(--contrast-4);
    }

    .entry.group > .entry{
    }
    .entry.group.collapsed > .entry{
    }

    .entry.group > .header .fa-stack.add{
        position: absolute;
        bottom: 24px;
        right: 13px;
        transform: scale(0.8);
        transition: .4s;
    }

    .entry.group > .header .fa-stack.add .fa-circle{
        color: #efefef;
    }
    .entry.group > .header .fa-stack.add .fa-plus{
        color: #6d8d23;
    }
    .entry.group.collapsed > .header .fa-stack.add .fa-circle{
        color: #efefef;
    }
    .entry.group.collapsed > .header .fa-stack.add .fa-plus{
        color: #898989;
    }


    .entry.group > .header .fa-stack{
        position: absolute;
        bottom: 9px;
        right: 5px;
        transform: scale(0.8);
        transition: .4s;
    }
    .entry.group > .header .fa-stack.new{
        right: 22px;
    }
    .entry.group > .header .fa-stack .fa-circle{
        color: #efefef;
    }
    .entry.group > .header .fa-stack .fa-angle-down, .entry.group > .header .fa-stack .fa-angle-up, .entry.group > .header .fa-stack .fa-plus{
        color: #6d8d23;
    }
    .entry.group.collapsed > .header .fa-stack .fa-circle{
        color: #efefef;
    }
    .entry.group.collapsed > .header .fa-stack .fa-angle-down, .entry.group.collapsed > .header .fa-stack .fa-angle-up, .entry.group > .header .fa-stack .fa-plus{
        color: #898989;
    }
    .grid:not(.preload) .entry.group > .entry{
        animation-name: unfold;
        animation-duration: 300ms;
        animation-timing-function: ease-out;
    }

    .entry.group > .header > .label .fa-stack{
        position: absolute;
        bottom: 9px;
        left: 5px;
        transform: scale(0.8);
        transition: .4s;
        cursor:grab;
    }
    .entry.group > .header > .label  .fa-stack .fa-circle{
        color: #6d8d23;
    }
    .entry.group > .header > .label  .fa-stack .fa-arrows-alt{
        transform: scale(0.8);
        color: #efefef;
    }
    .entry.group.collapsed > .header > .label  .fa-stack .fa-circle{
        color: var(--contrast-6);
    }
    .entry.group.collapsed > .header > .label  .fa-stack .fa-arrows-alt{
        color: #898989;
    }

  @keyframes unfold {
    from {
        margin-top: -50px;
    }
    to {
      margin-top: 0px;
    }
  }

    .return{
        position: fixed;
        left: 215px;
        margin-top: -5px;
        z-index: 4;
    }
    .return.forward{
        position: absolute;
        right: 330px;
        margin-top: 0;
        top: 5px;
        left: initial;
    }

    .return .fa-stack{
        transform: scale(1.5);
        transition: .2s;
    }
    .return .fa-stack .fa-circle{
        color: var(--contrast-6);
    }

    .fa-refresh:before{
        content: '\f021';
    }
    .header.day-mode{
        background: var(--contrast-1);
        padding-left: 306px;
    }
    .header.day-mode .user,.header.day-mode .icons-weekly, .header.day-mode .refresh{
        margin-right: 30px;
        margin-top: 3px;
    }
    .header.day-mode .user, .header.day-mode .refresh{
        height: 30px;
        width: 30px;
        border-radius: 100px;
        box-shadow: 0 0 0 1.4px var(--contrast-5);
    }

    .header.day-mode .fa-refresh,.header.day-mode .fa-user{
        font-size: 18px;
        transform: translate(0px, 5px);
    }
    .header.day-mode .icons-weekly{
        font-size: 18px;
        transform: translate(0px, -7px);
    }
    .header.day-mode .icons-weekly .icon{
        font-size: 12px;
        height: 27px !important;
        width: 43px !important;
        display: inline-block;
    }
    .header.day-mode .icons-weekly .icon:hover{
        color: var(--bg);
        background: #6d8d21;
    }
    .header.day-mode .user{

    }
    .header.day-mode .refresh{

    }
    .header.day-mode .fas{

        color: var(--contrast-5);
    }
    .header.day-mode .fa-stack:hover .fa-circle{
        color: #6d8d23 !important;
    }
    .header.day-mode .fa-stack:hover{
        background: #6d8d23 !important;
    }
    .header.day-mode .fa-circle{
        font-size: 30px;
        color: var(--contrast-2);
        opacity: 0;
    }

    .loading-roster .searchbar.employee-sort{
        z-index: 0;
    }

    .positions-filter{
        display: inline-block;
        text-align: center;
        width: 32px;
        cursor: pointer;
        top: -5px;
        margin-left: -240px;
        z-index: 3;
        margin-right: 5px;
    }
    .employee-filter{
        display: inline-block;
        text-align: center;
        width: 32px;
        cursor: pointer;
        top: -5px;
        z-index: 3;
    }
    .sollist-switcher{
        display: inline-block;
        text-align: center;
        width: 32px;
        cursor: pointer;
        top: -5px;
        z-index: 3;
        margin-left: 120px;
    }
    .sollist-switcher-aktuell{
        display: inline-block;
        text-align: center;
        width: 60px;
        cursor: pointer;
        font-size:9px;
        font-weight: 200;
        top: -11px;
        z-index: 3;
        margin-left: 35px;
        line-height: 20px;
        height: 20px;
        border-bottom-right-radius: 0px;
        border-top-right-radius: 0px;
    }
    .sollist-switcher-aktuell .label{
        font-size:9px !important;
    }
    .sollist-switcher-alle{
        display: inline-block;
        text-align: center;
        width: 60px;
        cursor: pointer;
        top: -11px;
        z-index: 3;
        margin-left: -1px;
        line-height: 20px;
        height: 20px;
        font-size:9px;
        font-weight: 200;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 0px;
    }
    .sollist-switcher-alle .label{
        font-size:9px !important;
    }

    .sollist-active {
        background: #6d8d23;
    }
    .sollist-active * {
        color: var(--bg);
    }


    .loading-roster .employee-filter, .loading-roster .positions-filter, .loading-roster .sollist-switcher{
        z-index: -1;
    }

    .searchbar.employee-sort{
        position: absolute;
        width: 200px;
        left: 10px;
        margin-top: 10px;
    }
    .searchbar:not(.employee-sort){
        opacity: 0;
        pointer-events: none;
    }

    .button.month-only.toggled {
        background: #6d8d23 !important;
    }
    .button.month-only.toggled .label{
        color: white !important;
    }
    .button.month-only.toggled:hover {
        background: #efefef !important;
    }
    .button.month-only.toggled:active {
        background: #6d8d23 !important;
    }
    .button.month-only.toggled:hover  .label{
        color: #404040 !important;
    }

    .entry > .table.border-red{

        box-shadow: inset 0 0 1px 2px rgb(229, 28, 80);
        background: rgba(229, 28, 80, .4);
    }
    .entry > .table.border-yellow{

        box-shadow: inset 0 0 1px 2px rgb(232, 109, 29);
        background: rgba(232, 109, 29, 0.5);
    }
    .entry > .table.border-green{

        box-shadow: inset 0 0 1px 2px rgb(108, 141, 37);
        background: rgba(108, 141, 37, 0.5);
    }

    .hour-grid .amount{
        position: fixed;
        margin: auto;
        height: 30px;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,.2);
        color: var(--contrast-4);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 0;
    }

    .hour-grid.full-half .quarter{
        width: 7px;
        height: 7px;
        margin: 0;
    }

    .shift-template .entry.group .employee{
        left: 0px;
        width: 210px
    }
    .shift-template .entry.group .employee.template{
        left: -20px;
        width: 230px
    }

    .entry.group:last-child > .entry{
        margin-bottom: -1px !important;
    }

    .fa-stack.refresh.selected{
        background: #6d8d22;
        color: white;
    }
    .fa-stack.refresh.selected .fa-refresh{
        color: white;
    }

    .day-mode .grid .entry.header .day{
        position: fixed;
        top: 62px;
        left: 0px;
        margin: 0;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }
    .day-mode .grid .entry.header .day.today{

        width: 90px;
        background: #6d8d21;
        box-shadow: none;
    }

    .shift-template .entry.header .day{
        display:none !important;
    }

    .day-mode .grid .entry.header .day .shadow{
        position: absolute;
        height: 40px;
        width: 140px;
        -webkit-box-shadow: 0 0 1px 0 #808080;
        box-shadow: 0 0 1px 0 #808080;
        left: -50px;
        top: 0;
    }


    .day-mode .grid .entry.header .day .weather{
        top: 0px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -50px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: 1;
        display:none;
    }



    .day-mode .grid .entry.header .day .income{
        bottom: 0px;
        left: -50px;
        background: white;
        display:none
    }

    .employee .fa-stack{
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .employee .fa-stack.user{
        position: absolute;
        right: 30px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .employee .fa-stack > .fas:not(.fa-circle){
        transform: scale(.6);
    }
    .employee .fa-stack > .fa-user{
        transform: scale(.55) !important;
    }

    .fa-stack.new, .fa-stack.add{
        cursor: pointer;
    }
    .fa-stack.new, .fa-stack.add > *{
        pointer-events: none;
    }

    .template .fa-stack.new{
        pointer-events: initial;
    }
    .template .fa-stack.new .fa-plus{
        transform: scale(0.4) translate(9px, -8px);
    }
    .template .fa-stack.new .fa-user{
        transform: scale(.5) translate(-1px, 0px) !important
    }

    .grid-header-backdrop{
        background: var(--bg);

        position: absolute;
        width: calc(230px + 10px);
        left: 0;
        /* margin-top: 10px; */
        cursor: pointer;
        z-index: 3;
        height: 45px;
    }
    .shift-template .grid-header-backdrop,.day-mode .grid-header-backdrop{
        width: calc(100vw);
    }

    .loading-roster .grid-header-backdrop{
        display: none;
    }

    .app > .navigate{
        position: absolute;
        top: 68px;
        left: 30px;
        z-index: 10;
        border: 1px solid var(--contrast-5);
        border-radius: 100px;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }
    .app > .navigate *{
        color: var(--contrast-5);
        font-size: 25px;
        transform: translate(-1px, 1px);
        pointer-events: none;
    }

    .navigate:hover *{
        color: white;
    }

    .navigate:hover{
        background: #6c8d25;
    }

    .header > .preference{
        box-shadow: 0 0 0 1.4px  var(--contrast-5);
        border-radius: 100px;
        height: 30px;
        width: 30px;
        margin-right: 30px;
        margin-top: 3px;
    }
    .header > .preference *{
        color: var(--contrast-5);
        font-size: 18px;
        transform: translate(0px, 4px) rotate(90deg);
    }

    .header > .preference:hover *{
        color: white;
    }

    .header > .preference:hover{
        background: #6c8d25;
    }

    .employee-preference-view{

    }

    .hide{
        display: none !important;
    }

    .shift-template > *:not(.template-view){
        display: none;
    }
    .app > .template-view{
        display: none;
    }
    .shift-template > .template-view{
        display: inline-block;
        width: 100%;
        height: 100%;
    }

    .button.change-month{
        border: none;
        transform: scale(.6);
        box-shadow: none;
        margin-left: 3px;
        margin-right: 3px;
    }
    .button.reset-date{
        padding-left: 10px;
        padding-right: 10px;
    }

    .button.set-date{
        margin-left: 0px;
        margin-right: 0px;
    }
</style>
